import React from "react";

// New icons
// Social media icons
const SrCompIconDiscord = (props) => {
  return (
    <svg
      width={props.size ? props.size : "48"}
      height={props.size ? props.size : "48"}
      viewBox={props.size ? `0 0 ${props.size} ${props.size}` : "0 0 48 48"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.952 5.67181C18.048 4.14081 15.036 3.88181 14.908 3.87081C14.707 3.85381 14.516 3.96781 14.434 4.15181C14.428 4.16381 14.362 4.31481 14.289 4.54981C15.548 4.76181 17.095 5.18981 18.495 6.05881C18.719 6.19781 18.788 6.49281 18.649 6.71781C18.559 6.86381 18.402 6.94381 18.242 6.94381C18.156 6.94381 18.069 6.92081 17.99 6.87181C15.584 5.37981 12.578 5.30481 12 5.30481C11.422 5.30481 8.415 5.37981 6.011 6.87181C5.786 7.01181 5.492 6.94181 5.352 6.71781C5.212 6.49281 5.282 6.19881 5.506 6.05881C6.906 5.19081 8.452 4.76181 9.712 4.54981C9.638 4.31381 9.572 4.16381 9.567 4.15181C9.484 3.96781 9.294 3.85181 9.092 3.87181C8.965 3.88181 5.953 4.14081 4.023 5.69381C3.015 6.62481 1 12.0728 1 16.7828C1 16.8658 1.022 16.9478 1.063 17.0198C2.454 19.4628 6.248 20.1028 7.113 20.1308C7.118 20.1308 7.123 20.1308 7.128 20.1308C7.281 20.1308 7.425 20.0578 7.515 19.9338L8.39 18.7318C6.031 18.1218 4.826 17.0868 4.756 17.0258C4.558 16.8508 4.539 16.5488 4.714 16.3508C4.889 16.1528 5.19 16.1338 5.388 16.3078C5.417 16.3338 7.636 18.2168 12 18.2168C16.372 18.2168 18.591 16.3258 18.613 16.3068C18.811 16.1348 19.113 16.1528 19.287 16.3518C19.461 16.5498 19.442 16.8508 19.245 17.0248C19.175 17.0868 17.97 18.1208 15.611 18.7308L16.486 19.9328C16.576 20.0568 16.72 20.1298 16.873 20.1298C16.878 20.1298 16.883 20.1298 16.888 20.1298C17.753 20.1028 21.547 19.4628 22.938 17.0188C22.978 16.9468 23 16.8658 23 16.7828C23 12.0728 20.985 6.62481 19.952 5.67181ZM8.891 14.8698C7.967 14.8698 7.217 14.0128 7.217 12.9568C7.217 11.9008 7.966 11.0438 8.891 11.0438C9.816 11.0438 10.565 11.9008 10.565 12.9568C10.565 14.0128 9.816 14.8698 8.891 14.8698ZM15.109 14.8698C14.185 14.8698 13.435 14.0128 13.435 12.9568C13.435 11.9008 14.184 11.0438 15.109 11.0438C16.033 11.0438 16.783 11.9008 16.783 12.9568C16.783 14.0128 16.033 14.8698 15.109 14.8698Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconFacebook = (props) => {
  return (
    <svg
      width={props.size ? props.size : "48"}
      height={props.size ? props.size : "48"}
      viewBox={props.size ? `0 0 ${props.size} ${props.size}` : "0 0 48 48"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.477 2 2 6.477 2 12C2 17.013 5.693 21.153 10.505 21.876V14.65H8.031V12.021H10.505V10.272C10.505 7.376 11.916 6.105 14.323 6.105C15.476 6.105 16.085 6.19 16.374 6.229V8.523H14.732C13.71 8.523 13.353 9.492 13.353 10.584V12.021H16.348L15.942 14.65H13.354V21.897C18.235 21.236 22 17.062 22 12C22 6.477 17.523 2 12 2Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconInstagram = (props) => {
  return (
    <svg
      width={props.size ? props.size : "48"}
      height={props.size ? props.size : "48"}
      viewBox={props.size ? `0 0 ${props.size} ${props.size}` : "0 0 48 48"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 3C5.239 3 3 5.239 3 8V16C3 18.761 5.239 21 8 21H16C18.761 21 21 18.761 21 16V8C21 5.239 18.761 3 16 3H8ZM18 5C18.552 5 19 5.448 19 6C19 6.552 18.552 7 18 7C17.448 7 17 6.552 17 6C17 5.448 17.448 5 18 5ZM12 7C14.761 7 17 9.239 17 12C17 14.761 14.761 17 12 17C9.239 17 7 14.761 7 12C7 9.239 9.239 7 12 7ZM12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconLinkedin = (props) => {
  return (
    <svg
      width={props.size ? props.size : "48"}
      height={props.size ? props.size : "48"}
      viewBox={props.size ? `0 0 ${props.size} ${props.size}` : "0 0 48 48"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 3H5C3.895 3 3 3.895 3 5V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V5C21 3.895 20.105 3 19 3ZM9 17H6.477V10H9V17ZM7.694 8.717C6.923 8.717 6.408 8.203 6.408 7.517C6.408 6.831 6.922 6.317 7.779 6.317C8.55 6.317 9.065 6.831 9.065 7.517C9.065 8.203 8.551 8.717 7.694 8.717ZM18 17H15.558V13.174C15.558 12.116 14.907 11.872 14.663 11.872C14.419 11.872 13.605 12.035 13.605 13.174C13.605 13.337 13.605 17 13.605 17H11.082V10H13.605V10.977C13.93 10.407 14.581 10 15.802 10C17.023 10 18 10.977 18 13.174V17Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconMedium = (props) => {
  return (
    <svg
      width={props.size ? props.size : "48"}
      height={props.size ? props.size : "48"}
      viewBox={props.size ? `0 0 ${props.size} ${props.size}` : "0 0 48 48"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 6C6.08075 6 5.1705 6.18106 4.32122 6.53284C3.47194 6.88463 2.70026 7.40024 2.05025 8.05025C1.40024 8.70026 0.884626 9.47194 0.532843 10.3212C0.18106 11.1705 0 12.0807 0 13C0 13.9193 0.18106 14.8295 0.532843 15.6788C0.884626 16.5281 1.40024 17.2997 2.05025 17.9497C2.70026 18.5998 3.47194 19.1154 4.32122 19.4672C5.1705 19.8189 6.08075 20 7 20C7.91925 20 8.8295 19.8189 9.67878 19.4672C10.5281 19.1154 11.2997 18.5998 11.9497 17.9497C12.5998 17.2997 13.1154 16.5281 13.4672 15.6788C13.8189 14.8295 14 13.9193 14 13C14 12.0807 13.8189 11.1705 13.4672 10.3212C13.1154 9.47194 12.5998 8.70026 11.9497 8.05025C11.2997 7.40024 10.5281 6.88463 9.67878 6.53284C8.8295 6.18106 7.91925 6 7 6ZM18 6.5C17.2044 6.5 16.4413 7.18482 15.8787 8.40381C15.3161 9.62279 15 11.2761 15 13C15 14.7239 15.3161 16.3772 15.8787 17.5962C16.4413 18.8152 17.2044 19.5 18 19.5C18.7956 19.5 19.5587 18.8152 20.1213 17.5962C20.6839 16.3772 21 14.7239 21 13C21 11.2761 20.6839 9.62279 20.1213 8.40381C19.5587 7.18482 18.7956 6.5 18 6.5ZM23 8C22.7348 8 22.4804 8.52678 22.2929 9.46447C22.1054 10.4021 22 11.6739 22 13C22 14.3261 22.1054 15.5979 22.2929 16.5355C22.4804 17.4732 22.7348 18 23 18C23.2652 18 23.5196 17.4732 23.7071 16.5355C23.8946 15.5979 24 14.3261 24 13C24 11.6739 23.8946 10.4021 23.7071 9.46447C23.5196 8.52678 23.2652 8 23 8Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconPinterest = (props) => {
  return (
    <svg
      width={props.size ? props.size : "48"}
      height={props.size ? props.size : "48"}
      viewBox={props.size ? `0 0 ${props.size} ${props.size}` : "0 0 48 48"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.40039C6.69842 2.40039 2.40002 6.69879 2.40002 12.0004C2.40002 16.0676 4.93042 19.5412 8.50162 20.9396C8.41762 20.1804 8.34162 19.0148 8.53522 18.186C8.70962 17.4372 9.66082 13.414 9.66082 13.414C9.66082 13.414 9.37362 12.8388 9.37362 11.9892C9.37362 10.654 10.1472 9.65799 11.1104 9.65799C11.9296 9.65799 12.3248 10.2732 12.3248 11.01C12.3248 11.834 11.8008 13.0652 11.5296 14.206C11.3032 15.162 12.0088 15.9412 12.9512 15.9412C14.6576 15.9412 15.9688 14.142 15.9688 11.5452C15.9688 9.24679 14.3176 7.63959 11.9592 7.63959C9.22802 7.63959 7.62482 9.68839 7.62482 11.806C7.62482 12.6308 7.94242 13.5156 8.33922 13.9972C8.41762 14.0924 8.42882 14.1756 8.40562 14.2724C8.33282 14.5756 8.17122 15.2276 8.13922 15.3612C8.09762 15.5372 8.00002 15.574 7.81842 15.4892C6.61922 14.9308 5.86962 13.178 5.86962 11.77C5.86962 8.74199 8.06962 5.96039 12.2128 5.96039C15.5432 5.96039 18.1312 8.33319 18.1312 11.5052C18.1312 14.814 16.0448 17.4764 13.1496 17.4764C12.1768 17.4764 11.2624 16.9708 10.9496 16.374C10.9496 16.374 10.468 18.2068 10.3512 18.6564C10.1344 19.49 9.54962 20.5356 9.15762 21.1732C10.056 21.45 11.0104 21.6004 12 21.6004C17.3016 21.6004 21.6 17.302 21.6 12.0004C21.6 6.69879 17.3016 2.40039 12 2.40039Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconReddit = (props) => {
  return (
    <svg
      width={props.size ? props.size : "48"}
      height={props.size ? props.size : "48"}
      viewBox={props.size ? `0 0 ${props.size} ${props.size}` : "0 0 48 48"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3C12.3008 3 11 4.41406 11 6V8.03125C8.88284 8.17578 6.97659 8.78516 5.43753 9.71875C4.87894 9.28125 4.21878 9.03125 3.56253 9.03125C2.83597 9.03125 2.12894 9.30859 1.62503 9.875C0.668001 11.0703 0.753938 13.0234 2.09378 14.0312C2.03128 14.3477 2.00003 14.668 2.00003 15C2.00003 17.0547 3.24222 18.8438 5.06253 20.0625C6.88284 21.2812 9.32034 22 12 22C14.6797 22 17.1172 21.2812 18.9375 20.0625C20.7578 18.8438 22 17.0547 22 15C22 14.668 21.9375 14.3477 21.875 14.0312C23.2383 12.9453 23.3789 11.0039 22.375 9.875C21.8711 9.30859 21.1641 9.03125 20.4375 9.03125C19.7813 9.03125 19.1211 9.28125 18.5625 9.71875C17.0235 8.78516 15.1172 8.17578 13 8.03125V6C13 5.38672 13.3008 5 14 5C14.3203 5 14.7735 5.17188 15.5313 5.4375C16.2032 5.67188 17.0938 5.91406 18.25 5.96875C18.5899 6.58594 19.25 7 20 7C21.1016 7 22 6.10156 22 5C22 3.89844 21.1016 3 20 3C19.2735 3 18.6328 3.38281 18.2813 3.96875C17.3946 3.92578 16.7696 3.76562 16.1875 3.5625C15.5196 3.32812 14.8789 3 14 3ZM20 4C20.6016 4 21 4.39844 21 5C21 5.60156 20.6016 6 20 6C19.3985 6 19 5.60156 19 5C19 4.39844 19.3985 4 20 4ZM12 10C14.3203 10 16.3828 10.6367 17.8125 11.5938C19.2422 12.5508 20 13.7539 20 15C20 16.2461 19.2422 17.4492 17.8125 18.4062C16.3828 19.3633 14.3203 20 12 20C9.67972 20 7.61722 19.3633 6.18753 18.4062C4.75784 17.4492 4.00003 16.2461 4.00003 15C4.00003 13.7539 4.75784 12.5508 6.18753 11.5938C7.61722 10.6367 9.67972 10 12 10ZM3.59378 10.0312C3.92581 10.0312 4.27738 10.1016 4.59378 10.2812C3.62894 11.0234 2.87894 11.9375 2.43753 12.9688C1.8555 12.2812 1.86722 11.1914 2.37503 10.5312C2.67191 10.1953 3.12113 10.0312 3.59378 10.0312ZM20.4063 10.0312C20.8789 10.0312 21.3282 10.1953 21.625 10.5312C22.1172 11.0859 22.1563 12.1758 21.5625 12.9375C21.1211 11.9141 20.3633 11.0195 19.4063 10.2812C19.7227 10.1016 20.0743 10.0312 20.4063 10.0312ZM9.00003 12C8.17191 12 7.50003 12.6719 7.50003 13.5C7.50003 14.3281 8.17191 15 9.00003 15C9.82816 15 10.5 14.3281 10.5 13.5C10.5 12.6719 9.82816 12 9.00003 12ZM15 12C14.1719 12 13.5 12.6719 13.5 13.5C13.5 14.3281 14.1719 15 15 15C15.8282 15 16.5 14.3281 16.5 13.5C16.5 12.6719 15.8282 12 15 12ZM16.0938 16.4062C15.1953 17.207 13.6993 17.6875 12 17.6875C10.3008 17.6875 8.80472 17.1992 7.90628 16.5C8.40628 17.8008 10 19 12 19C14 19 15.5938 17.8047 16.0938 16.4062Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSubstack = (props) => {
  return (
    <svg
      width={props.size ? props.size : "48"}
      height={props.size ? props.size : "48"}
      viewBox={props.size ? `0 0 ${props.size} ${props.size}` : "0 0 48 48"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3H19.7663V5.21024H4V3ZM4 11.062H19.7663V21L11.8815 16.5776L4 21V11.062ZM4 7.031H19.7663V9.24123H4V7.031Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconTwitter = (props) => {
  return (
    <svg
      width={props.size ? props.size : "48"}
      height={props.size ? props.size : "48"}
      viewBox={props.size ? `0 0 ${props.size} ${props.size}` : "0 0 48 48"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 3.99902C21.22 4.46202 19.655 5.09302 18.735 5.27502C18.708 5.28202 18.686 5.29102 18.66 5.29802C17.847 4.49602 16.733 3.99902 15.5 3.99902C13.015 3.99902 11 6.01402 11 8.49902C11 8.63002 10.989 8.87102 11 8.99902C7.647 8.99902 5.095 7.24302 3.265 4.99902C3.066 5.49902 2.979 6.28902 2.979 7.03102C2.979 8.43202 4.074 9.80802 5.779 10.661C5.465 10.742 5.119 10.8 4.759 10.8C4.178 10.8 3.563 10.647 3 10.183C3 10.2 3 10.216 3 10.234C3 12.192 5.078 13.525 6.926 13.896C6.551 14.117 5.795 14.139 5.426 14.139C5.166 14.139 4.246 14.02 4 13.974C4.514 15.579 6.368 16.481 8.135 16.513C6.753 17.597 5.794 17.999 2.964 17.999H2C3.788 19.145 6.065 20 8.347 20C15.777 20 20 14.337 20 8.99902C20 8.91302 19.998 8.73302 19.995 8.55202C19.995 8.53402 20 8.51702 20 8.49902C20 8.47202 19.992 8.44602 19.992 8.41902C19.989 8.28302 19.986 8.15602 19.983 8.09002C20.773 7.52002 21.458 6.80902 22 5.99902C21.275 6.32102 20.497 6.53702 19.68 6.63502C20.514 6.13502 21.699 4.94302 22 3.99902Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconWhatsapp = (props) => {
  return (
    <svg
      width={props.size ? props.size : "48"}
      height={props.size ? props.size : "48"}
      viewBox={props.size ? `0 0 ${props.size} ${props.size}` : "0 0 48 48"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.077 4.928C17.191 3.041 14.683 2.001 12.011 2C6.505 2 2.024 6.479 2.022 11.985C2.021 13.745 2.481 15.463 3.355 16.977L2 22L7.233 20.763C8.692 21.559 10.334 21.978 12.006 21.979H12.01C17.515 21.979 21.996 17.499 21.999 11.994C22.001 9.325 20.963 6.816 19.077 4.928ZM16.898 15.554C16.69 16.137 15.671 16.699 15.213 16.74C14.755 16.782 14.326 16.947 12.218 16.116C9.681 15.116 8.079 12.515 7.955 12.349C7.83 12.182 6.936 10.996 6.936 9.768C6.936 8.54 7.581 7.936 7.81 7.687C8.039 7.437 8.309 7.375 8.476 7.375C8.642 7.375 8.809 7.375 8.954 7.381C9.132 7.388 9.329 7.397 9.516 7.812C9.738 8.306 10.223 9.54 10.285 9.665C10.347 9.79 10.389 9.936 10.306 10.102C10.223 10.268 10.181 10.372 10.057 10.518C9.932 10.664 9.795 10.843 9.683 10.955C9.558 11.079 9.428 11.215 9.573 11.464C9.719 11.714 10.219 12.531 10.961 13.192C11.915 14.042 12.718 14.305 12.968 14.431C13.218 14.556 13.363 14.535 13.509 14.368C13.655 14.202 14.133 13.64 14.299 13.39C14.465 13.14 14.632 13.182 14.861 13.265C15.09 13.348 16.317 13.952 16.566 14.077C16.816 14.202 16.982 14.264 17.044 14.368C17.106 14.471 17.106 14.971 16.898 15.554Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconYoutube = (props) => {
  return (
    <svg
      width={props.size ? props.size : "48"}
      height={props.size ? props.size : "48"}
      viewBox={props.size ? `0 0 ${props.size} ${props.size}` : "0 0 48 48"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5512 6.96031C21.3599 5.90469 20.4487 5.13594 19.3912 4.89594C17.8087 4.56031 14.8799 4.32031 11.7112 4.32031C8.54432 4.32031 5.56869 4.56031 3.98432 4.89594C2.92869 5.13594 2.01557 5.85594 1.82432 6.96031C1.63119 8.16031 1.43994 9.84031 1.43994 12.0003C1.43994 14.1603 1.63119 15.8403 1.87119 17.0403C2.06432 18.0959 2.97557 18.8647 4.03119 19.1047C5.71119 19.4403 8.59119 19.6803 11.7599 19.6803C14.9287 19.6803 17.8087 19.4403 19.4887 19.1047C20.5443 18.8647 21.4556 18.1447 21.6487 17.0403C21.8399 15.8403 22.0799 14.1116 22.1287 12.0003C22.0312 9.84031 21.7912 8.16031 21.5512 6.96031ZM9.11994 15.3603V8.64031L14.9756 12.0003L9.11994 15.3603Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconEMail = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.1 40.3q-1.35 0-2.375-1.025T3.7 36.9V11.1q0-1.4 1.025-2.4t2.375-1h33.8q1.4 0 2.4 1t1 2.4v25.8q0 1.35-1 2.375T40.9 40.3Zm16.9-15 16.9-11.15V11.1L24 22 7.1 11.1v3.05Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// General icons
const SrCompIconOpenInNew = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M9.1 42.3q-1.35 0-2.375-1.025T5.7 38.9V9.1q0-1.4 1.025-2.4t2.375-1h13.85v3.4H9.1v29.8h29.8V25.05h3.4V38.9q0 1.35-1 2.375T38.9 42.3Zm10.3-11.25L17 28.6 36.5 9.1H25.95V5.7H42.3v16.35h-3.4v-10.5Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconHome = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.7 42.3V17.85L24 5.6l16.3 12.25V42.3H28.05V27.95h-8.1V42.3Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconPreview = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.15 42.3q-1.4 0-2.425-1.025T5.7 38.85V9.15q0-1.4 1.025-2.425T9.15 5.7h29.7q1.4 0 2.425
      1.025T42.3 9.15v29.7q0 1.4-1.025 2.425T38.85 42.3ZM9 39h30V13H9v26Zm15-5.25q-4
      0-7.15-2.15-3.15-2.15-4.6-5.6 1.45-3.45 4.6-5.6Q20 18.25 24 18.25t7.15 2.15q3.15 2.15 4.6
      5.6-1.45 3.45-4.6 5.6Q28 33.75 24 33.75Zm0-2.5q2.85 0 5.25-1.4T33 26q-1.35-2.45-3.75-3.85T24
      20.75q-2.85 0-5.25 1.4T15 26q1.35 2.45 3.75 3.85t5.25 1.4Zm0-2.75q-1.05 0-1.775-.725Q21.5
      27.05 21.5 26q0-1.05.725-1.775Q22.95 23.5 24 23.5q1.05 0 1.775.725.725.725.725 1.775 0
      1.05-.725 1.775-.725.725-1.775.725Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSave = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 13.85V39q0 1.2-.9 2.1-.9.9-2.1.9H9q-1.2 0-2.1-.9Q6 40.2 6 39V9q0-1.2.9-2.1Q7.8 6 9 6h25.15Zm-3 1.35L32.8 9H9v30h30ZM24 35.75q2.15 0 3.675-1.525T29.2 30.55q0-2.15-1.525-3.675T24 25.35q-2.15 0-3.675 1.525T18.8 30.55q0 2.15 1.525 3.675T24 35.75ZM11.65 18.8h17.9v-7.15h-17.9ZM9 15.2V39 9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconUpload = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1Zm11.5-8.45V13.75l-5.95 5.9-2.45-2.4L24 7.15l10.1 10.1-2.45 2.4-5.95-5.9V32.1Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconManageAccounts = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 23.6q-3.45 0-5.625-2.175T12.2 15.8q0-3.45 2.175-5.625T20 8q3.45 0 5.625 2.175T27.8 15.8q0 3.45-2.175 5.625T20 23.6ZM3.7 40.25v-5q0-1.9.95-3.35.95-1.45 2.6-2.25 3.6-1.6 6.75-2.3 3.15-.7 6-.7h1.35q-.35.7-.575 1.55-.225.85-.325 1.85h-.4q-2.85 0-5.625.6T8.7 32.7q-.8.4-1.2 1.125-.4.725-.4 1.475v1.55h13.35q.25 1 .7 1.85.45.85 1 1.55Zm29.8 2.05-.5-3.35q-.85-.2-1.7-.675-.85-.475-1.4-1.075l-2.8.65-1.4-2.3 2.4-2.25q-.1-.4-.1-1.175t.1-1.175l-2.4-2.25 1.4-2.3 2.8.6q.55-.55 1.4-1.025.85-.475 1.7-.725l.5-3.35h2.9l.5 3.35q.85.25 1.7.725T40.05 27l2.75-.6 1.4 2.3-2.4 2.25q.1.4.1 1.175t-.1 1.175l2.4 2.25-1.4 2.3-2.75-.65q-.6.6-1.45 1.075t-1.7.675l-.5 3.35Zm1.45-6.25q1.75 0 2.85-1.075t1.1-2.875q0-1.75-1.1-2.825-1.1-1.075-2.85-1.075t-2.85 1.075Q31 30.35 31 32.1q0 1.8 1.1 2.875t2.85 1.075ZM20 20.2q1.9 0 3.15-1.25t1.25-3.15q0-1.9-1.25-3.15T20 11.4q-1.9 0-3.15 1.25T15.6 15.8q0 1.9 1.25 3.15T20 20.2Zm0-4.4Zm.45 21.05Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconBrowseActivity = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m24 28.9 2.5-5.4 5.4-2.5-5.4-2.5-2.5-5.4-2.5 5.4-5.4 2.5 5.4 2.5ZM3.7 36.3V5.7h40.6v30.6Zm3.4-3.4h33.8V9.1H7.1Zm-5.4 9.55V39.3h44.6v3.15Zm5.4-9.55V9.1v23.8Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Old icons
// Edit action icons
const SrCompIconEdit = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.09995 39H11.15L33.2 16.95L31.15 14.9L9.09995 36.95V39ZM39.75 14.8L33.2999 8.35L35.15 6.5C35.7833 5.83333 36.575 5.5 37.525 5.5C38.475 5.5 39.2666 5.81667 39.9 6.45L41.7999 8.35C42.4333 8.95 42.7333 9.68333 42.7 10.55C42.6666 11.4167 42.3666 12.15 41.7999 12.75L39.75 14.8ZM37.65 16.9L12.4 42.15H5.94995V35.7L31.2 10.45L37.65 16.9ZM32.2 15.9L31.15 14.9L33.2 16.95L32.2 15.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconDelete = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.95 42.2999C12.0167 42.2999 11.2167 41.9583 10.55 41.275C9.88338 40.5916 9.55005 39.8 9.55005 38.9V10.6H7.30005V7.19995H17.2V5.44995H30.8V7.19995H40.7001V10.6H38.4501V38.9C38.4501 39.8 38.1167 40.5916 37.4501 41.275C36.7834 41.9583 35.9834 42.2999 35.05 42.2999H12.95ZM35.05 10.6H12.95V38.9H35.05V10.6ZM18.2 34.7H21.4V14.75H18.2V34.7ZM26.6 34.7H29.8V14.75H26.6V34.7ZM12.95 10.6V38.9V10.6Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconClearAll = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.6499 34.6V31.2H34.0499V34.6H5.6499ZM9.7999 25.7V22.3H38.1999V25.7H9.7999ZM13.9499 16.8V13.4H42.3499V16.8H13.9499Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconAdd = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.3 38.2001V25.7H9.80005V22.3H22.3V9.80005H25.7V22.3H38.2001V25.7H25.7V38.2001H22.3Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconDone = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8999 36L7.3999 24.5L9.8499 22.05L18.8999 31.1L38.0999 11.9L40.5499 14.35L18.8999 36Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconClose = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.45 37.9501L10.05 35.55L21.6 24L10.05 12.45L12.45 10.05L24 21.6L35.55 10.05L37.9501 12.45L26.4 24L37.9501 35.55L35.55 37.9501L24 26.4L12.45 37.9501Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconAddCircle = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6 34.0499H25.7V25.75H34.0499V22.65H25.7V13.95H22.6V22.65H13.95V25.75H22.6V34.0499ZM24 44.2999C21.1333 44.2999 18.4583 43.7833 15.975 42.75C13.4916 41.7166 11.3416 40.2916 9.52495 38.4749C7.70828 36.6583 6.28328 34.5083 5.24995 32.025C4.21662 29.5416 3.69995 26.8666 3.69995 24C3.69995 21.1666 4.21662 18.5083 5.24995 16.025C6.28328 13.5416 7.70828 11.3916 9.52495 9.57495C11.3416 7.75828 13.4916 6.32495 15.975 5.27495C18.4583 4.22495 21.1333 3.69995 24 3.69995C26.8333 3.69995 29.4916 4.22495 31.975 5.27495C34.4583 6.32495 36.6083 7.75828 38.4249 9.57495C40.2416 11.3916 41.6749 13.5333 42.7249 16C43.7749 18.4666 44.2999 21.1333 44.2999 24C44.2999 26.8666 43.7749 29.5416 42.7249 32.025C41.6749 34.5083 40.2416 36.6583 38.4249 38.4749C36.6083 40.2916 34.4583 41.7166 31.975 42.75C29.4916 43.7833 26.8333 44.2999 24 44.2999ZM24 40.9C28.6333 40.9 32.6083 39.25 35.9249 35.95C39.2416 32.65 40.9 28.6666 40.9 24C40.9 19.3666 39.2416 15.3916 35.9249 12.075C32.6083 8.75828 28.6333 7.09995 24 7.09995C19.3666 7.09995 15.3916 8.75828 12.075 12.075C8.75828 15.3916 7.09995 19.3666 7.09995 24C7.09995 28.6666 8.75828 32.65 12.075 35.95C15.3916 39.25 19.3666 40.9 24 40.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconDoNotDisturbOn = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 25.5499H34V22.15H14V25.5499ZM24 44.2999C21.1333 44.2999 18.4583 43.7833 15.975 42.75C13.4916 41.7166 11.3416 40.2916 9.52495 38.4749C7.70828 36.6583 6.28328 34.5083 5.24995 32.025C4.21662 29.5416 3.69995 26.8666 3.69995 24C3.69995 21.1666 4.21662 18.5083 5.24995 16.025C6.28328 13.5416 7.70828 11.3916 9.52495 9.57495C11.3416 7.75828 13.4916 6.32495 15.975 5.27495C18.4583 4.22495 21.1333 3.69995 24 3.69995C26.8333 3.69995 29.4916 4.22495 31.975 5.27495C34.4583 6.32495 36.6083 7.75828 38.4249 9.57495C40.2416 11.3916 41.6749 13.5333 42.7249 16C43.7749 18.4666 44.2999 21.1333 44.2999 24C44.2999 26.8666 43.7749 29.5416 42.7249 32.025C41.6749 34.5083 40.2416 36.6583 38.4249 38.4749C36.6083 40.2916 34.4583 41.7166 31.975 42.75C29.4916 43.7833 26.8333 44.2999 24 44.2999ZM24 40.9C28.7999 40.9 32.8166 39.2833 36.0499 36.0499C39.2833 32.8166 40.9 28.7999 40.9 24C40.9 19.2 39.2833 15.1833 36.0499 11.95C32.8166 8.71662 28.7999 7.09995 24 7.09995C19.2 7.09995 15.1833 8.71662 11.95 11.95C8.71662 15.1833 7.09995 19.2 7.09995 24C7.09995 28.7999 8.71662 32.8166 11.95 36.0499C15.1833 39.2833 19.2 40.9 24 40.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconCancel = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6 33.5999L24 26.2L31.4 33.5999L33.5999 31.4L26.2 24L33.5999 16.6L31.4 14.4L24 21.7999L16.6 14.4L14.4 16.6L21.7999 24L14.4 31.4L16.6 33.5999ZM24 44.2999C21.1333 44.2999 18.4583 43.7833 15.975 42.75C13.4916 41.7166 11.3416 40.2916 9.52495 38.4749C7.70828 36.6583 6.28328 34.5083 5.24995 32.025C4.21662 29.5416 3.69995 26.8666 3.69995 24C3.69995 21.1666 4.21662 18.5083 5.24995 16.025C6.28328 13.5416 7.70828 11.3916 9.52495 9.57495C11.3416 7.75828 13.4916 6.32495 15.975 5.27495C18.4583 4.22495 21.1333 3.69995 24 3.69995C26.8333 3.69995 29.4916 4.22495 31.975 5.27495C34.4583 6.32495 36.6083 7.75828 38.4249 9.57495C40.2416 11.3916 41.6749 13.5416 42.7249 16.025C43.7749 18.5083 44.2999 21.1666 44.2999 24C44.2999 26.8666 43.7749 29.5416 42.7249 32.025C41.6749 34.5083 40.2416 36.6583 38.4249 38.4749C36.6083 40.2916 34.4583 41.7166 31.975 42.75C29.4916 43.7833 26.8333 44.2999 24 44.2999ZM24 40.9C28.6333 40.9 32.6083 39.25 35.9249 35.95C39.2416 32.65 40.9 28.6666 40.9 24C40.9 19.3666 39.2416 15.3916 35.9249 12.075C32.6083 8.75828 28.6333 7.09995 24 7.09995C19.3666 7.09995 15.3916 8.75828 12.075 12.075C8.75828 15.3916 7.09995 19.3666 7.09995 24C7.09995 28.6666 8.75828 32.65 12.075 35.95C15.3916 39.25 19.3666 40.9 24 40.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconBlock = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 44.2999C21.2 44.2999 18.5666 43.7666 16.1 42.7C13.6333 41.6333 11.4833 40.1833 9.64995 38.3499C7.81662 36.5166 6.36662 34.3666 5.29995 31.9C4.23328 29.4333 3.69995 26.7999 3.69995 24C3.69995 21.2 4.23328 18.5583 5.29995 16.075C6.36662 13.5916 7.81662 11.4416 9.64995 9.62495C11.4833 7.80828 13.6333 6.36662 16.1 5.29995C18.5666 4.23328 21.2 3.69995 24 3.69995C26.7999 3.69995 29.4333 4.23328 31.9 5.29995C34.3666 6.36662 36.5166 7.80828 38.3499 9.62495C40.1833 11.4416 41.6333 13.5916 42.7 16.075C43.7666 18.5583 44.2999 21.2 44.2999 24C44.2999 26.7999 43.7666 29.4333 42.7 31.9C41.6333 34.3666 40.1833 36.5166 38.3499 38.3499C36.5166 40.1833 34.3666 41.6333 31.9 42.7C29.4333 43.7666 26.7999 44.2999 24 44.2999ZM24 40.9C28.7 40.9 32.6916 39.2583 35.9749 35.9749C39.2583 32.6916 40.9 28.7 40.9 24C40.9 22.0333 40.5666 20.1333 39.9 18.3C39.2333 16.4666 38.2833 14.8 37.0499 13.3L13.3 37C14.7666 38.2999 16.425 39.2749 18.275 39.9249C20.125 40.575 22.0333 40.9 24 40.9ZM11 34.7L34.7 11C33.2 9.73328 31.5333 8.76662 29.7 8.09995C27.8666 7.43328 25.9666 7.09995 24 7.09995C19.3 7.09995 15.3083 8.73328 12.025 12C8.74162 15.2666 7.09995 19.2666 7.09995 24C7.09995 25.9666 7.44995 27.8666 8.14995 29.7C8.84995 31.5333 9.79995 33.2 11 34.7Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconPersonRemove = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.5499 20.6V17.3H44.4V20.6H32.5499ZM18 23.8C15.7333 23.8 13.8666 23.075 12.4 21.625C10.9333 20.175 10.2 18.3 10.2 16C10.2 13.7 10.9333 11.825 12.4 10.375C13.8666 8.92495 15.7333 8.19995 18 8.19995C20.3 8.19995 22.1833 8.92495 23.65 10.375C25.1166 11.825 25.85 13.7 25.85 16C25.85 18.3 25.1166 20.175 23.65 21.625C22.1833 23.075 20.3 23.8 18 23.8ZM1.69995 40.45V35.45C1.69995 34.2166 2.01662 33.0999 2.64995 32.0999C3.28328 31.0999 4.16662 30.35 5.29995 29.85C7.79995 28.75 10.0416 27.975 12.025 27.525C14.0083 27.075 16 26.85 18 26.85C20.0666 26.85 22.0749 27.075 24.025 27.525C25.975 27.975 28.2 28.75 30.7 29.85C31.8666 30.3833 32.7666 31.1416 33.4 32.125C34.0333 33.1083 34.3499 34.2166 34.3499 35.45V40.45H1.69995ZM5.14995 37.0499H30.9V35.5C30.9 34.9666 30.75 34.4583 30.45 33.9749C30.15 33.4916 29.75 33.1333 29.25 32.9C26.95 31.8333 24.9833 31.125 23.35 30.775C21.7166 30.425 19.9333 30.25 18 30.25C16.1 30.25 14.325 30.425 12.675 30.775C11.025 31.125 9.04995 31.8333 6.74995 32.9C6.24995 33.1333 5.85828 33.4916 5.57495 33.9749C5.29162 34.4583 5.14995 34.9666 5.14995 35.5V37.0499ZM18 20.4C19.3 20.4 20.3583 19.9833 21.1749 19.15C21.9916 18.3166 22.4 17.2666 22.4 16C22.4 14.7333 21.9916 13.6833 21.1749 12.85C20.3583 12.0166 19.3166 11.6 18.0499 11.6C16.7499 11.6 15.6916 12.0166 14.875 12.85C14.0583 13.6833 13.65 14.7333 13.65 16C13.65 17.2666 14.0583 18.3166 14.875 19.15C15.6916 19.9833 16.7333 20.4 18 20.4Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconPersonAddUnfilled = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 96 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M733.348 648.348V519.782H604.783v-62.869h128.565V328.348h62.87v128.565h128.565v62.869H796.218v128.566h-62.87ZM360.43 571.891q-68.68 0-112.305-43.625T204.5 415.961q0-68.679 43.625-112.353 43.625-43.674 112.305-43.674 68.679 0 112.472 43.674 43.794 43.674 43.794 112.353 0 68.68-43.794 112.305-43.793 43.625-112.472 43.625ZM34.5 905.087V804.63q0-36.746 18.503-66.512 18.503-29.767 52.845-44.748 75.478-33.24 134.404-46.859 58.927-13.62 119.945-13.62 61.477 0 120.194 13.62 58.718 13.619 133.957 46.859 34.341 15.707 53.345 44.968 19.003 29.262 19.003 66.238v100.511H34.5Zm68.13-68.13h515.696v-31.37q0-15.854-9.018-30.235-9.017-14.38-24.047-21.314Q515.522 721.783 467 711.522q-48.522-10.261-106.641-10.261-57.642 0-106.783 10.261t-118.843 42.506q-15.103 6.932-23.603 21.316-8.5 14.384-8.5 30.243v31.37Zm257.84-333.196q38.291 0 63.073-24.866 24.783-24.865 24.783-62.974 0-38.207-24.774-63.031-24.774-24.825-62.946-24.825-38.171 0-63.073 24.836-24.903 24.835-24.903 62.902 0 38.165 24.866 63.061 24.865 24.897 62.974 24.897Zm.008-87.848Zm0 421.044Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Navigation action icons
const SrCompIconThumbUpEmpty = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.5728 42.5142H13.325V16.5794L27.0934 2.31091L29.2766 3.99771C29.4983 4.17715 29.6667 4.43263 29.7818 4.76416C29.8968 5.0957 29.9543 5.49823 29.9543 5.97176V6.36416L27.7282 16.5794H42.5587C43.4591 16.5794 44.2539 16.9212 44.9432 17.6049C45.6325 18.2886 45.9772 19.0823 45.9772 19.9859V23.5398C45.9772 23.793 46.0002 24.053 46.0462 24.3196C46.0922 24.5862 46.0612 24.8362 45.9532 25.0696L39.6054 39.725C39.2808 40.5057 38.7366 41.1658 37.9727 41.7052C37.2088 42.2445 36.4088 42.5142 35.5728 42.5142ZM16.6 39.1076H36.2228L42.5467 24.0979V19.9859H23.6576L26.2 7.97831L16.6 18.1283V39.1076ZM13.325 16.5794V19.9859H6.94996V39.1076H13.325V42.5142H3.54346V16.5794H13.325Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Navigation action icons
const SrCompIconThumbUpUnfilled = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.5728 42.5142H13.325V16.5794L27.0934 2.31091L29.2766 3.99771C29.4983 4.17715 29.6667 4.43263 29.7818 4.76416C29.8968 5.0957 29.9543 5.49823 29.9543 5.97176V6.36416L27.7282 16.5794H42.5587C43.4591 16.5794 44.2539 16.9212 44.9432 17.6049C45.6325 18.2886 45.9772 19.0823 45.9772 19.9859V23.5398C45.9772 23.793 46.0002 24.053 46.0462 24.3196C46.0922 24.5862 46.0612 24.8362 45.9532 25.0696L39.6054 39.725C39.2808 40.5057 38.7366 41.1658 37.9727 41.7052C37.2088 42.2445 36.4088 42.5142 35.5728 42.5142ZM16.6 39.1076H36.2228L42.5467 24.0979V19.9859H23.6576L26.2 7.97831L16.6 18.1283V39.1076ZM13.325 16.5794V19.9859H6.94996V39.1076H13.325V42.5142H3.54346V16.5794H13.325Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconThumbUpFilled = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.05 42H12.7V16.4L26.6 2L28.25 3.3C28.6167 3.56667 28.8583 3.86667 28.975 4.2C29.0917 4.53333 29.15 4.91667 29.15 5.35V5.85L26.9 16.4H43C43.7667 16.4 44.4583 16.7083 45.075 17.325C45.6917 17.9417 46 18.6333 46 19.4V23.5C46 23.8667 45.9583 24.2917 45.875 24.775C45.7917 25.2583 45.6667 25.6833 45.5 26.05L39.7 39.45C39.4 40.15 38.9083 40.75 38.225 41.25C37.5417 41.75 36.8167 42 36.05 42ZM9.7 16.4V42H4V16.4H9.7Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconPersonAddFilled = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 96 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M733.348 648.348V519.782H604.783v-62.869h128.565V328.348h62.87v128.565h128.565v62.869H796.218v128.566h-62.87ZM360.43 571.891q-68.68 0-112.305-43.625T204.5 415.961q0-68.679 43.625-112.353 43.625-43.674 112.305-43.674 68.679 0 112.472 43.674 43.794 43.674 43.794 112.353 0 68.68-43.794 112.305-43.793 43.625-112.472 43.625ZM34.5 905.087V804.63q0-36.746 18.503-66.512 18.503-29.767 52.845-44.748 75.478-33.24 134.566-46.859 59.088-13.62 119.945-13.62 61.315 0 120.032 13.62 58.718 13.619 133.957 46.859 34.341 15.707 53.345 44.968 19.003 29.262 19.003 66.238v100.511H34.5Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconThumbUpFull = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.05 42H12.7V16.4L26.6 2L28.25 3.3C28.6167 3.56667 28.8583 3.86667 28.975 4.2C29.0917 4.53333 29.15 4.91667 29.15 5.35V5.85L26.9 16.4H43C43.7667 16.4 44.4583 16.7083 45.075 17.325C45.6917 17.9417 46 18.6333 46 19.4V23.5C46 23.8667 45.9583 24.2917 45.875 24.775C45.7917 25.2583 45.6667 25.6833 45.5 26.05L39.7 39.45C39.4 40.15 38.9083 40.75 38.225 41.25C37.5417 41.75 36.8167 42 36.05 42ZM9.7 16.4V42H4V16.4H9.7Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconExpandLess = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.15 31.05L11.7 28.6L24 16.3L36.2999 28.55L33.8499 31L24 21.15L14.15 31.05Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconExpandMore = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 31.05L11.7 18.75L14.15 16.3L24 26.2001L33.8499 16.35L36.2999 18.8L24 31.05Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconChevronRight = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 36.3L16.3 33.85L26.2001 23.95L16.3 14.05L18.75 11.6L31.1 23.95L18.75 36.3Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconArrowBack = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.0001 40.15L7.8501 24L24.0001 7.84998L26.4001 10.25L14.3501 22.3H40.1501V25.7H14.3501L26.4001 37.75L24.0001 40.15Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconArrowOutward = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4 36L10 33.6L30.4 13.2H11.8V9.80005H36.2V34.2001H32.8V15.6L12.4 36Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconArrowsMoreUp = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.8 27.2V9.2H16.8V5.75H38.25V27.2H34.8ZM23.75 38.25V20.25H5.75V16.85H27.15V38.25H23.75Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconDisabledVisible = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.25 44.3002C21.3166 44.3335 18.6083 43.8335 16.125 42.8002C13.6416 41.7669 11.475 40.3419 9.62495 38.5252C7.77495 36.7085 6.32495 34.5585 5.27495 32.0752C4.22495 29.5919 3.69995 26.9002 3.69995 24.0002C3.69995 21.1669 4.21662 18.5085 5.24995 16.0252C6.28328 13.5419 7.70828 11.3919 9.52495 9.5752C11.3416 7.75853 13.4916 6.3252 15.975 5.2752C18.4583 4.2252 21.1333 3.7002 24 3.7002C26.8333 3.7002 29.4916 4.2252 31.975 5.2752C34.4583 6.3252 36.6083 7.75853 38.4249 9.5752C40.2416 11.3919 41.6749 13.5419 42.7249 16.0252C43.7749 18.5085 44.2999 21.1669 44.2999 24.0002C44.2999 24.2669 44.2916 24.5419 44.275 24.8252C44.2583 25.1085 44.2333 25.3835 44.2 25.6502C43.7 25.3169 43.1583 24.9835 42.575 24.6502C41.9916 24.3169 41.4166 24.0335 40.8499 23.8002C40.8166 19.0669 39.1916 15.1002 35.9749 11.9002C32.7583 8.7002 28.75 7.1002 23.95 7.1002C21.8166 7.1002 19.8333 7.44186 18 8.1252C16.1666 8.80853 14.55 9.7502 13.15 10.9502L26.65 24.4502C26.15 24.6835 25.6666 24.9335 25.2 25.2002C24.7333 25.4669 24.2833 25.7669 23.85 26.1002L10.9 13.1502C9.69995 14.5502 8.76662 16.1752 8.09995 18.0252C7.43328 19.8752 7.09995 21.8669 7.09995 24.0002C7.09995 28.0669 8.29995 31.5919 10.7 34.5752C13.1 37.5585 16.1833 39.4669 19.95 40.3002C20.4833 41.0002 21.1416 41.7252 21.9249 42.4752C22.7083 43.2252 23.4833 43.8335 24.25 44.3002ZM34 41.0002C36.1333 41.0002 38.1499 40.4585 40.0499 39.3752C41.95 38.2919 43.5 36.8335 44.7 35.0002C43.5 33.1669 41.95 31.7085 40.0499 30.6252C38.1499 29.5419 36.1333 29.0002 34 29.0002C31.8666 29.0002 29.85 29.5419 27.95 30.6252C26.05 31.7085 24.5 33.1669 23.2999 35.0002C24.5 36.8335 26.05 38.2919 27.95 39.3752C29.85 40.4585 31.8666 41.0002 34 41.0002ZM34 44.1502C30.7666 44.1502 27.8833 43.2919 25.35 41.5752C22.8166 39.8585 20.9833 37.6669 19.85 35.0002C20.9833 32.3335 22.8166 30.1419 25.35 28.4252C27.8833 26.7085 30.7666 25.8502 34 25.8502C37.2333 25.8502 40.1166 26.7085 42.65 28.4252C45.1833 30.1419 47.0166 32.3335 48.15 35.0002C47.0166 37.6669 45.1833 39.8585 42.65 41.5752C40.1166 43.2919 37.2333 44.1502 34 44.1502ZM34 38.0502C33.1666 38.0502 32.45 37.7585 31.85 37.1752C31.25 36.5919 30.95 35.8669 30.95 35.0002C30.95 34.1335 31.2416 33.4085 31.825 32.8252C32.4083 32.2419 33.1333 31.9502 34 31.9502C34.8666 31.9502 35.5916 32.2419 36.1749 32.8252C36.7583 33.4085 37.0499 34.1335 37.0499 35.0002C37.0499 35.8335 36.7583 36.5502 36.1749 37.1502C35.5916 37.7502 34.8666 38.0502 34 38.0502Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconPlayCircle = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1 32.5999L32.65 24L19.1 15.35V32.5999ZM24 44.2999C21.2333 44.2999 18.6083 43.7666 16.125 42.7C13.6416 41.6333 11.4833 40.1833 9.64995 38.3499C7.81662 36.5166 6.36662 34.3666 5.29995 31.9C4.23328 29.4333 3.69995 26.7999 3.69995 24C3.69995 21.2 4.23328 18.5583 5.29995 16.075C6.36662 13.5916 7.81662 11.4416 9.64995 9.62495C11.4833 7.80828 13.6333 6.36662 16.1 5.29995C18.5666 4.23328 21.2 3.69995 24 3.69995C26.7999 3.69995 29.4416 4.23328 31.9249 5.29995C34.4083 6.36662 36.5583 7.80828 38.375 9.62495C40.1916 11.4416 41.6333 13.5833 42.7 16.05C43.7666 18.5166 44.2999 21.1666 44.2999 24C44.2999 26.7999 43.7666 29.4333 42.7 31.9C41.6333 34.3666 40.1916 36.5166 38.375 38.3499C36.5583 40.1833 34.4166 41.6333 31.95 42.7C29.4833 43.7666 26.8333 44.2999 24 44.2999ZM24 40.9C28.7 40.9 32.6916 39.25 35.9749 35.95C39.2583 32.65 40.9 28.6666 40.9 24C40.9 19.3 39.2583 15.3083 35.9749 12.025C32.6916 8.74162 28.7 7.09995 24 7.09995C19.3333 7.09995 15.35 8.74162 12.05 12.025C8.74995 15.3083 7.09995 19.3 7.09995 24C7.09995 28.6666 8.74995 32.65 12.05 35.95C15.35 39.25 19.3333 40.9 24 40.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconStarRateFilled = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 96 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m227.022 985.087 95.152-311.413L69.717 492.891H381.37L480 165l98.63 327.891h311.892L637.826 673.674l95.392 311.413-252.979-192.543-253.217 192.543Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconStarRateUnfilled = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 96 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m343 813 137-104 137 104-55-173 126-82H537l-57-173-57 173H272l126 82-55 173ZM227.022 985.087l95.152-311.413L69.717 492.891H381.37L480 165l98.63 327.891h311.892L637.826 673.674l95.392 311.413-252.979-192.543-253.217 192.543ZM480 599Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Review action icons
const SrCompIconGradeUnfilled = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.15 35.8499L24 30.65L30.85 35.8499L28.1 27.2L34.4 23.1H26.85L24 14.45L21.15 23.1H13.6L19.9 27.2L17.15 35.8499ZM11.35 44.45L16.1 28.9L3.5 19.85H19.05L24 3.44995L28.95 19.85H44.55L31.9 28.9L36.65 44.45L24 34.8499L11.35 44.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconGradeFilled = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.35 44.45L16.1 28.9L3.5 19.85H19.05L24 3.44995L28.95 19.85H44.55L31.9 28.9L36.65 44.45L24 34.8499L11.35 44.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSentimentDissatisfied = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.25 21.4C32.0166 21.4 32.6666 21.1416 33.2 20.625C33.7333 20.1083 34 19.45 34 18.65C34 17.85 33.7416 17.1916 33.2249 16.675C32.7083 16.1583 32.0499 15.9 31.25 15.9C30.45 15.9 29.7833 16.1583 29.25 16.675C28.7166 17.1916 28.45 17.85 28.45 18.65C28.45 19.45 28.7166 20.1083 29.25 20.625C29.7833 21.1416 30.45 21.4 31.25 21.4ZM16.75 21.4C17.55 21.4 18.2166 21.1416 18.75 20.625C19.2833 20.1083 19.55 19.45 19.55 18.65C19.55 17.85 19.2833 17.1916 18.75 16.675C18.2166 16.1583 17.55 15.9 16.75 15.9C15.9833 15.9 15.3333 16.1583 14.8 16.675C14.2666 17.1916 14 17.85 14 18.65C14 19.45 14.2583 20.1083 14.775 20.625C15.2916 21.1416 15.95 21.4 16.75 21.4ZM24 27.15C21.7666 27.15 19.7416 27.775 17.925 29.025C16.1083 30.275 14.7666 31.9333 13.9 34H16.7C17.4333 32.6333 18.4583 31.5833 19.775 30.85C21.0916 30.1166 22.5166 29.75 24.0499 29.75C25.5833 29.75 26.9916 30.1166 28.275 30.85C29.5583 31.5833 30.5833 32.6333 31.35 34H34.0999C33.2666 31.9333 31.9333 30.275 30.1 29.025C28.2666 27.775 26.2333 27.15 24 27.15ZM24 44.2999C21.2 44.2999 18.5666 43.7666 16.1 42.7C13.6333 41.6333 11.4833 40.1833 9.64995 38.3499C7.81662 36.5166 6.36662 34.3666 5.29995 31.9C4.23328 29.4333 3.69995 26.7999 3.69995 24C3.69995 21.1666 4.23328 18.5166 5.29995 16.05C6.36662 13.5833 7.81662 11.4416 9.64995 9.62495C11.4833 7.80828 13.6333 6.36662 16.1 5.29995C18.5666 4.23328 21.2 3.69995 24 3.69995C26.8333 3.69995 29.4833 4.23328 31.95 5.29995C34.4166 6.36662 36.5583 7.80828 38.375 9.62495C40.1916 11.4416 41.6333 13.5833 42.7 16.05C43.7666 18.5166 44.2999 21.1666 44.2999 24C44.2999 26.7999 43.7666 29.4333 42.7 31.9C41.6333 34.3666 40.1916 36.5166 38.375 38.3499C36.5583 40.1833 34.4166 41.6333 31.95 42.7C29.4833 43.7666 26.8333 44.2999 24 44.2999ZM24 40.9C28.7 40.9 32.6916 39.25 35.9749 35.95C39.2583 32.65 40.9 28.6666 40.9 24C40.9 19.3 39.2583 15.3083 35.9749 12.025C32.6916 8.74162 28.7 7.09995 24 7.09995C19.3333 7.09995 15.35 8.74162 12.05 12.025C8.74995 15.3083 7.09995 19.2833 7.09995 23.95C7.09995 28.65 8.74995 32.65 12.05 35.95C15.35 39.25 19.3333 40.9 24 40.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSentimentVerySatisfied = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 34.95C26.2333 34.95 28.275 34.35 30.125 33.15C31.975 31.95 33.3166 30.3166 34.15 28.25H13.85C14.7166 30.2833 16.0666 31.9083 17.9 33.125C19.7333 34.3416 21.7666 34.95 24 34.95ZM15.1 21.45L17.35 19.2L19.6 21.45L21.5499 19.55L17.35 15.4L13.2 19.55L15.1 21.45ZM28.45 21.45L30.7 19.2L32.95 21.45L34.9 19.55L30.7 15.4L26.5499 19.55L28.45 21.45ZM24 44.2999C21.2333 44.2999 18.6083 43.7666 16.125 42.7C13.6416 41.6333 11.4833 40.1833 9.64995 38.3499C7.81662 36.5166 6.36662 34.3666 5.29995 31.9C4.23328 29.4333 3.69995 26.7999 3.69995 24C3.69995 21.2 4.23328 18.5583 5.29995 16.075C6.36662 13.5916 7.81662 11.4416 9.64995 9.62495C11.4833 7.80828 13.6333 6.36662 16.1 5.29995C18.5666 4.23328 21.2 3.69995 24 3.69995C26.7999 3.69995 29.4416 4.23328 31.9249 5.29995C34.4083 6.36662 36.5583 7.80828 38.375 9.62495C40.1916 11.4416 41.6333 13.5833 42.7 16.05C43.7666 18.5166 44.2999 21.1666 44.2999 24C44.2999 26.7999 43.7666 29.4333 42.7 31.9C41.6333 34.3666 40.1916 36.5166 38.375 38.3499C36.5583 40.1833 34.4166 41.6333 31.95 42.7C29.4833 43.7666 26.8333 44.2999 24 44.2999ZM24 40.9C28.7 40.9 32.6916 39.25 35.9749 35.95C39.2583 32.65 40.9 28.6666 40.9 24C40.9 19.3 39.2583 15.3083 35.9749 12.025C32.6916 8.74162 28.7 7.09995 24 7.09995C19.3333 7.09995 15.35 8.74162 12.05 12.025C8.74995 15.3083 7.09995 19.3 7.09995 24C7.09995 28.6666 8.74995 32.65 12.05 35.95C15.35 39.25 19.3333 40.9 24 40.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconStarHalf = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 14.45V30.65L30.85 35.8499L28.1 27.2L34.4 23.1H26.85L24 14.45ZM11.35 44.45L16.1 28.9L3.5 19.85H19.05L24 3.44995L28.95 19.85H44.55L31.9 28.9L36.65 44.45L24 34.8499L11.35 44.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// To-do list icons
const SrCompIconEditNote = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.8 42.2V38.35L34.6501 27.5L38.5 31.35L27.65 42.2H23.8ZM5.80005 31.85V28.4H21.35V31.85H5.80005ZM40.6501 29.2L36.8 25.35L38.25 23.9C38.55 23.6 38.9501 23.45 39.4501 23.45C39.9501 23.45 40.3501 23.6 40.6501 23.9L42.1 25.35C42.4 25.65 42.55 26.05 42.55 26.55C42.55 27.05 42.4 27.45 42.1 27.75L40.6501 29.2ZM5.80005 23.3V19.9H29.7001V23.3H5.80005ZM5.80005 14.75V11.35H29.7001V14.75H5.80005Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconCheckBox = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.09995 42.2999C8.19995 42.2999 7.40828 41.9583 6.72495 41.275C6.04162 40.5916 5.69995 39.8 5.69995 38.9V9.09995C5.69995 8.16662 6.04162 7.36662 6.72495 6.69995C7.40828 6.03328 8.19995 5.69995 9.09995 5.69995H38.9C39.8333 5.69995 40.6333 6.03328 41.2999 6.69995C41.9666 7.36662 42.2999 8.16662 42.2999 9.09995V38.9C42.2999 39.8 41.9666 40.5916 41.2999 41.275C40.6333 41.9583 39.8333 42.2999 38.9 42.2999H9.09995ZM9.09995 38.9H38.9V9.09995H9.09995V38.9ZM20.95 32.2L35.5 17.6L33.0999 15.2L20.95 27.35L15.1 21.55L12.7 23.95L20.95 32.2ZM9.09995 38.9V9.09995V38.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconCheckBoxOutlineBlank = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.09995 42.2999C8.19995 42.2999 7.40828 41.9583 6.72495 41.275C6.04162 40.5916 5.69995 39.8 5.69995 38.9V9.09995C5.69995 8.16662 6.04162 7.36662 6.72495 6.69995C7.40828 6.03328 8.19995 5.69995 9.09995 5.69995H38.9C39.8333 5.69995 40.6333 6.03328 41.2999 6.69995C41.9666 7.36662 42.2999 8.16662 42.2999 9.09995V38.9C42.2999 39.8 41.9666 40.5916 41.2999 41.275C40.6333 41.9583 39.8333 42.2999 38.9 42.2999H9.09995ZM9.09995 38.9H38.9V9.09995H9.09995V38.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconNoteAdd = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 36.4H25.5V29.95H32V26.95H25.5V20.45H22.5V26.95H16V29.95H22.5V36.4ZM36.9 44.2999H11.1C10.2 44.2999 9.40829 43.9583 8.72495 43.275C8.04162 42.5916 7.69995 41.8 7.69995 40.9V7.09995C7.69995 6.16662 8.04162 5.36662 8.72495 4.69995C9.40829 4.03328 10.2 3.69995 11.1 3.69995H29.2L40.2999 14.8V40.9C40.2999 41.8 39.9666 42.5916 39.2999 43.275C38.6333 43.9583 37.8333 44.2999 36.9 44.2999ZM27.45 16.4V7.09995H11.1V40.9H36.9V16.4H27.45ZM11.1 7.09995V16.4V7.09995V16.4V40.9V7.09995Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Task action icons
const SrCompIconAssignmentLate = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 34.2C24.5 34.2 24.9333 34.0166 25.2999 33.65C25.6666 33.2833 25.85 32.8499 25.85 32.3499C25.85 31.8166 25.6666 31.375 25.2999 31.025C24.9333 30.6749 24.5 30.5 24 30.5C23.5 30.5 23.0666 30.6749 22.7 31.025C22.3333 31.375 22.15 31.8166 22.15 32.3499C22.15 32.8499 22.3333 33.2833 22.7 33.65C23.0666 34.0166 23.5 34.2 24 34.2ZM22.4 27.65H25.5V13.8H22.4V27.65ZM9.09995 38.9H38.9V9.14995H9.09995V38.9ZM9.09995 9.14995V38.9V9.14995ZM9.09995 42.3499C8.16662 42.3499 7.36662 42.0166 6.69995 41.3499C6.03328 40.6833 5.69995 39.8666 5.69995 38.9V9.14995C5.69995 8.21662 6.03328 7.40828 6.69995 6.72495C7.36662 6.04162 8.16662 5.69995 9.09995 5.69995H19.05C19.2833 4.53328 19.8583 3.57495 20.775 2.82495C21.6916 2.07495 22.7666 1.69995 24 1.69995C25.2333 1.69995 26.3083 2.07495 27.225 2.82495C28.1416 3.57495 28.7166 4.53328 28.95 5.69995H38.9C39.8333 5.69995 40.6333 6.04162 41.2999 6.72495C41.9666 7.40828 42.2999 8.21662 42.2999 9.14995V38.9C42.2999 39.8666 41.9666 40.6833 41.2999 41.3499C40.6333 42.0166 39.8333 42.3499 38.9 42.3499H9.09995ZM24 8.24995C24.5 8.24995 24.925 8.06662 25.275 7.69995C25.625 7.33328 25.7999 6.91662 25.7999 6.44995C25.7999 5.94995 25.625 5.51662 25.275 5.14995C24.925 4.78328 24.5 4.59995 24 4.59995C23.5 4.59995 23.075 4.78328 22.725 5.14995C22.375 5.51662 22.2 5.93328 22.2 6.39995C22.2 6.89995 22.375 7.33328 22.725 7.69995C23.075 8.06662 23.5 8.24995 24 8.24995Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconFileOpen = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1 44.2999C10.2 44.2999 9.40829 43.9583 8.72495 43.275C8.04162 42.5916 7.69995 41.8 7.69995 40.9V7.09995C7.69995 6.16662 8.04162 5.36662 8.72495 4.69995C9.40829 4.03328 10.2 3.69995 11.1 3.69995H28.15L40.2999 15.85V29.2999H36.9V18.1H25.9V7.09995H11.1V40.9H31.2999V44.2999H11.1ZM43.9 44.3499L37.7 38.15V44.2999H34.2999V32.2999H46.2999V35.7H40.0999L46.2999 41.9L43.9 44.3499ZM11.1 40.9V7.09995V40.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconUploadFile = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6 37.8499H25.6V27.75L29.7 31.85L31.7999 29.75L24 22.15L16.3 29.85L18.4 31.95L22.6 27.75V37.8499ZM11.1 44.2999C10.2 44.2999 9.40829 43.9583 8.72495 43.275C8.04162 42.5916 7.69995 41.8 7.69995 40.9V7.09995C7.69995 6.16662 8.04162 5.36662 8.72495 4.69995C9.40829 4.03328 10.2 3.69995 11.1 3.69995H29.2L40.2999 14.8V40.9C40.2999 41.8 39.9666 42.5916 39.2999 43.275C38.6333 43.9583 37.8333 44.2999 36.9 44.2999H11.1ZM27.45 16.4V7.09995H11.1V40.9H36.9V16.4H27.45ZM11.1 7.09995V16.4V7.09995V40.9V7.09995Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconTask = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7 35.25L33.25 23.7L31.2 21.65L21.7 31.15L16.55 26L14.5 28.0499L21.7 35.25ZM11.1 44.2999C10.2 44.2999 9.40829 43.9583 8.72495 43.275C8.04162 42.5916 7.69995 41.8 7.69995 40.9V7.09995C7.69995 6.16662 8.04162 5.36662 8.72495 4.69995C9.40829 4.03328 10.2 3.69995 11.1 3.69995H29.2L40.2999 14.8V40.9C40.2999 41.8 39.9666 42.5916 39.2999 43.275C38.6333 43.9583 37.8333 44.2999 36.9 44.2999H11.1ZM27.45 16.4V7.09995H11.1V40.9H36.9V16.4H27.45ZM11.1 7.09995V16.4V7.09995V40.9V7.09995Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconWorkHistory = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.09995 38.9V14.5C7.09995 20.1 7.09995 24.4916 7.09995 27.6749C7.09995 30.8583 7.09995 33.2416 7.09995 34.825C7.09995 36.4083 7.09995 37.4249 7.09995 37.875C7.09995 38.325 7.09995 38.6666 7.09995 38.9ZM7.09995 42.3499C6.19995 42.3499 5.40828 42.0083 4.72495 41.325C4.04162 40.6416 3.69995 39.8333 3.69995 38.9V14.5C3.69995 13.5666 4.04162 12.7583 4.72495 12.075C5.40828 11.3916 6.19995 11.05 7.09995 11.05H16.2V6.84995C16.2 5.98328 16.5416 5.19995 17.225 4.49995C17.9083 3.79995 18.7166 3.44995 19.65 3.44995H28.35C29.2833 3.44995 30.0916 3.79995 30.775 4.49995C31.4583 5.19995 31.7999 5.98328 31.7999 6.84995V11.05H40.9C41.8333 11.05 42.6333 11.3916 43.2999 12.075C43.9666 12.7583 44.2999 13.5666 44.2999 14.5V26.5C43.7999 26.0666 43.2666 25.675 42.7 25.325C42.1333 24.975 41.5333 24.65 40.9 24.35V14.5H7.09995V38.9C7.09995 38.9 7.09995 38.9083 7.09995 38.9249C7.09995 38.9416 7.09995 38.9333 7.09995 38.9H23.7C23.8333 39.5333 24.0166 40.1333 24.25 40.7C24.4833 41.2666 24.7666 41.8166 25.1 42.3499H7.09995ZM19.65 11.05H28.35V6.84995H19.65V11.05ZM36 45.65C33.3666 45.65 31.1 44.7 29.2 42.7999C27.3 40.8999 26.35 38.6333 26.35 36C26.35 33.3666 27.3 31.1 29.2 29.2C31.1 27.3 33.3666 26.35 36 26.35C38.6333 26.35 40.8999 27.3 42.7999 29.2C44.7 31.1 45.65 33.3666 45.65 36C45.65 38.6333 44.7 40.8999 42.7999 42.7999C40.8999 44.7 38.6333 45.65 36 45.65ZM39.7 41.15L41.15 39.7L36.9 35.8499V29.65H34.7V36.5L39.7 41.15Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconFlag = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.69995 42.2999V7.69995H27.4L28.35 12H40.2999V31.1H26.95L26 26.85H13.1V42.2999H9.69995ZM29.85 27.7H36.9V15.4H25.45L24.5 11.1H13.1V23.45H28.9L29.85 27.7Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconPolyline = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31 44V39.25L15.5 31.5H6V20.5H14.75L21 13.5V4H32V15H23.7L17 22.5V28.95L31 35.9V33H42V44H31ZM24 12H29V7H24V12ZM9 28.5H14V23.5H9V28.5ZM34 41H39V36H34V41Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconNotes = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.80005 36.3499V32.9499H30.2001V36.3499H5.80005ZM5.80005 25.6999V22.2999H42.2001V25.6999H5.80005ZM5.80005 15.0499V11.6499H42.2001V15.0499H5.80005Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconTour = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.8501 44.2999V3.69995H13.2501V7.79995H42.6001L38.4001 17.85L42.6001 27.9H13.2501V44.2999H9.8501ZM13.2501 11.2V24.5V11.2ZM25.1501 21.45C26.1501 21.45 27.0001 21.1 27.7001 20.4C28.4001 19.7 28.7501 18.85 28.7501 17.85C28.7501 16.85 28.3918 16 27.6751 15.3C26.9584 14.6 26.1168 14.25 25.1501 14.25C24.1501 14.25 23.3001 14.6 22.6001 15.3C21.9001 16 21.5501 16.85 21.5501 17.85C21.5501 18.85 21.9001 19.7 22.6001 20.4C23.3001 21.1 24.1501 21.45 25.1501 21.45V21.45ZM13.2501 24.5H37.5501L34.8001 17.85L37.5501 11.2H13.2501V24.5Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconBolt = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9001 42.3L21.9501 27.95H14.5501C14.1501 27.95 13.8667 27.7833 13.7001 27.45C13.5334 27.1167 13.5501 26.8 13.7501 26.5L26.2001 5.70001H28.2501L26.2001 20H33.5001C33.8667 20 34.1501 20.1667 34.3501 20.5C34.5501 20.8333 34.5501 21.15 34.3501 21.45L21.9501 42.3H19.9001Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconFiberManualRecord = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 38.3C20.0333 38.3 16.6583 36.9167 13.875 34.15C11.0916 31.3833 9.69995 28 9.69995 24C9.69995 20.0333 11.0833 16.6583 13.85 13.875C16.6166 11.0917 20 9.70001 24 9.70001C27.9666 9.70001 31.3416 11.0917 34.125 13.875C36.9083 16.6583 38.2999 20.0333 38.2999 24C38.2999 27.9667 36.9083 31.3417 34.125 34.125C31.3416 36.9083 27.9666 38.3 24 38.3ZM24 34.9C27.0333 34.9 29.6083 33.8417 31.725 31.725C33.8416 29.6083 34.9 27.0333 34.9 24C34.9 20.9667 33.8416 18.3917 31.725 16.275C29.6083 14.1583 27.0333 13.1 24 13.1C20.9666 13.1 18.3916 14.1583 16.275 16.275C14.1583 18.3917 13.1 20.9667 13.1 24C13.1 27.0333 14.1583 29.6083 16.275 31.725C18.3916 33.8417 20.9666 34.9 24 34.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSearch = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.7999 42.3L26.5499 29.1C25.5833 29.9333 24.4333 30.5833 23.1 31.05C21.7666 31.5167 20.35 31.75 18.85 31.75C15.1833 31.75 12.075 30.4833 9.52495 27.95C6.97495 25.4167 5.69995 22.35 5.69995 18.75C5.69995 15.15 6.97495 12.0833 9.52495 9.55C12.075 7.01667 15.15 5.75 18.75 5.75C22.35 5.75 25.4166 7.01667 27.95 9.55C30.4833 12.0833 31.75 15.15 31.75 18.75C31.75 20.1833 31.5166 21.5667 31.0499 22.9C30.5833 24.2333 29.9 25.4833 29 26.65L42.2999 39.8L39.7999 42.3ZM18.8 28.35C21.4333 28.35 23.675 27.4083 25.525 25.525C27.375 23.6417 28.2999 21.3833 28.2999 18.75C28.2999 16.1167 27.375 13.8583 25.525 11.975C23.675 10.0917 21.4333 9.15 18.8 9.15C16.1 9.15 13.8166 10.0917 11.95 11.975C10.0833 13.8583 9.14995 16.1167 9.14995 18.75C9.14995 21.3833 10.0833 23.6417 11.95 25.525C13.8166 27.4083 16.1 28.35 18.8 28.35Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconAirwave = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.3 16.15q-1.35 1.3-2.975 1.95-1.625.65-3.375.65t-3.375-.65q-1.625-.65-2.975-1.95l-3.75-3.75q-.8-.85-1.8-1.225-1-.375-2.05-.375-1.05 0-2.05.375-1 .375-1.8 1.225L9.6 15.95 7.15 13.5l3.55-3.55q1.35-1.3 2.975-1.95Q15.3 7.35 17 7.35q1.7 0 3.3.65 1.6.65 2.95 1.95L27 13.7q.8.85 1.8 1.25t2.1.4q1.1 0 2.125-.4t1.825-1.25l3.55-3.55 2.45 2.45Zm0 10.95q-1.35 1.3-2.975 1.95-1.625.65-3.375.65t-3.375-.65Q25.95 28.4 24.6 27.1l-3.75-3.75q-.8-.8-1.8-1.2-1-.4-2.05-.4-1.05 0-2.05.4-1 .4-1.8 1.2L9.6 26.9l-2.45-2.4 3.55-3.6q1.35-1.3 2.975-1.95Q15.3 18.3 17 18.3q1.7 0 3.3.65 1.6.65 2.95 1.95L27 24.65q.8.85 1.825 1.25t2.125.4q1.1 0 2.1-.4t1.8-1.25l3.55-3.55 2.45 2.45Zm-.05 10.95Q35.9 39.35 34.3 40q-1.6.65-3.35.65T27.575 40q-1.625-.65-2.975-1.95l-3.8-3.75q-.8-.85-1.8-1.225-1-.375-2.05-.375-1.05 0-2.05.375-1 .375-1.8 1.225l-3.55 3.55-2.4-2.4 3.55-3.6q1.35-1.3 2.95-1.95 1.6-.65 3.3-.65 1.7 0 3.325.65 1.625.65 2.975 1.95L27 35.6q.8.85 1.825 1.25t2.125.4q1.1 0 2.1-.4t1.8-1.25l3.55-3.55 2.4 2.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Navbar tab icons
const SrCompIconAutoAwesome = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.5999 16.5L36.4 11.35L31 8.94995L36.4 6.59995L38.5999 1.69995L40.8499 6.59995L46.25 8.94995L40.8499 11.35L38.5999 16.5ZM38.5999 46.25L36.4 41.2999L31 38.95L36.4 36.5999L38.5999 31.4L40.8499 36.5999L46.25 38.95L40.8499 41.2999L38.5999 46.25ZM16.7 38.65L12 28.5499L1.69995 23.95L12 19.35L16.7 9.29995L21.45 19.35L31.7 23.95L21.45 28.5499L16.7 38.65Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconGroup = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6001 40.45V35.45C1.6001 34.2167 1.91676 33.1 2.5501 32.1C3.18343 31.1 4.06676 30.35 5.2001 29.85C7.63343 28.7833 9.84176 28.0167 11.8251 27.55C13.8084 27.0833 15.8334 26.85 17.9001 26.85C20.0334 26.85 22.0751 27.0833 24.0251 27.55C25.9751 28.0167 28.1668 28.7833 30.6001 29.85C31.7334 30.35 32.6251 31.1 33.2751 32.1C33.9251 33.1 34.2501 34.2167 34.2501 35.45V40.45H1.6001ZM37.3501 40.45V35.45C37.3501 33.35 36.8251 31.6083 35.7751 30.225C34.7251 28.8417 33.3168 27.6833 31.5501 26.75C33.7834 27.0167 35.8918 27.4083 37.8751 27.925C39.8584 28.4417 41.4834 29.0167 42.7501 29.65C43.8501 30.2833 44.7334 31.1 45.4001 32.1C46.0668 33.1 46.4001 34.2333 46.4001 35.5V40.45H37.3501ZM17.9501 23.8C15.6834 23.8 13.8418 23.0833 12.4251 21.65C11.0084 20.2167 10.3001 18.3833 10.3001 16.15C10.3001 13.8833 11.0084 12.0417 12.4251 10.625C13.8418 9.20833 15.6668 8.5 17.9001 8.5C20.1668 8.5 22.0168 9.20833 23.4501 10.625C24.8834 12.0417 25.6001 13.8833 25.6001 16.15C25.6001 18.3833 24.8834 20.2167 23.4501 21.65C22.0168 23.0833 20.1834 23.8 17.9501 23.8ZM28.7001 23.8C28.3334 23.8 27.9251 23.775 27.4751 23.725C27.0251 23.675 26.6168 23.5667 26.2501 23.4C27.0501 22.5667 27.6584 21.5333 28.0751 20.3C28.4918 19.0667 28.7001 17.6833 28.7001 16.15C28.7001 14.6167 28.4918 13.2667 28.0751 12.1C27.6584 10.9333 27.0501 9.85 26.2501 8.85C26.6168 8.75 27.0251 8.66667 27.4751 8.6C27.9251 8.53333 28.3334 8.5 28.7001 8.5C30.9668 8.5 32.8084 9.21667 34.2251 10.65C35.6418 12.0833 36.3501 13.9167 36.3501 16.15C36.3501 18.3833 35.6418 20.2167 34.2251 21.65C32.8084 23.0833 30.9668 23.8 28.7001 23.8Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Account action icons
const SrCompIconLogin = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.4 42.2999V38.9H39V9.09995H24.4V5.69995H39C39.9334 5.69995 40.7417 6.03328 41.425 6.69995C42.1084 7.36662 42.4501 8.16662 42.4501 9.09995V38.9C42.4501 39.8 42.1084 40.5916 41.425 41.275C40.7417 41.9583 39.9334 42.2999 39 42.2999H24.4ZM20.3 33.2L17.85 30.75L22.9 25.7H5.55005V22.2999H22.8L17.75 17.25L20.2 14.8L29.4 24.0499L20.3 33.2Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconLogout = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00005 42.2999C8.06672 42.2999 7.25838 41.9583 6.57505 41.275C5.89172 40.5916 5.55005 39.8 5.55005 38.9V9.09995C5.55005 8.16662 5.89172 7.36662 6.57505 6.69995C7.25838 6.03328 8.06672 5.69995 9.00005 5.69995H23.6V9.09995H9.00005V38.9H23.6V42.2999H9.00005ZM33.3 33.2L30.85 30.75L35.9001 25.7H18.6V22.2999H35.8L30.75 17.25L33.2001 14.8L42.4501 24.0499L33.3 33.2Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// More and help action icons
const SrCompIconSupportAgent = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7999 42.3999V38.9999H39.15V23.4999C39.15 21.5332 38.7249 19.6582 37.875 17.8749C37.025 16.0916 35.8833 14.5082 34.45 13.1249C33.0166 11.7416 31.4 10.6416 29.6 9.8249C27.8 9.00824 25.9333 8.5999 24 8.5999C22.0666 8.5999 20.2 9.00824 18.4 9.8249C16.6 10.6416 14.9833 11.7416 13.55 13.1249C12.1166 14.5082 10.975 16.0916 10.125 17.8749C9.27495 19.6582 8.84995 21.5332 8.84995 23.4999V36.1999H7.64995C6.48328 36.1999 5.49162 35.7916 4.67495 34.9749C3.85828 34.1582 3.44995 33.1666 3.44995 31.9999V27.7999C3.44995 26.9999 3.62495 26.2999 3.97495 25.6999C4.32495 25.0999 4.81662 24.6166 5.44995 24.2499L5.54995 21.8499C5.81662 19.3499 6.49995 17.0666 7.59995 14.9999C8.69995 12.9332 10.0916 11.1749 11.775 9.7249C13.4583 8.2749 15.35 7.1499 17.45 6.3499C19.55 5.5499 21.7333 5.1499 24 5.1499C26.2666 5.1499 28.4583 5.5499 30.575 6.3499C32.6916 7.1499 34.5833 8.2749 36.25 9.7249C37.9166 11.1749 39.3 12.9249 40.4 14.9749C41.5 17.0249 42.1833 19.2999 42.45 21.7999L42.5499 24.1499C43.1833 24.4499 43.675 24.9082 44.025 25.5249C44.375 26.1416 44.5499 26.8166 44.5499 27.5499V32.2499C44.5499 33.0166 44.375 33.7082 44.025 34.3249C43.675 34.9416 43.1833 35.4166 42.5499 35.7499V38.9999C42.5499 39.9332 42.2166 40.7332 41.5499 41.3999C40.8833 42.0666 40.0833 42.3999 39.15 42.3999H21.7999ZM18 27.5499C17.5666 27.5499 17.2 27.3999 16.9 27.0999C16.6 26.7999 16.45 26.4166 16.45 25.9499C16.45 25.5166 16.6 25.1582 16.9 24.8749C17.2 24.5916 17.5833 24.4499 18.05 24.4499C18.4833 24.4499 18.8416 24.5916 19.125 24.8749C19.4083 25.1582 19.5499 25.5332 19.5499 25.9999C19.5499 26.4332 19.4083 26.7999 19.125 27.0999C18.8416 27.3999 18.4666 27.5499 18 27.5499ZM30 27.5499C29.5666 27.5499 29.1999 27.3999 28.9 27.0999C28.6 26.7999 28.45 26.4166 28.45 25.9499C28.45 25.5166 28.6 25.1582 28.9 24.8749C29.1999 24.5916 29.5833 24.4499 30.0499 24.4499C30.4833 24.4499 30.8416 24.5916 31.125 24.8749C31.4083 25.1582 31.5499 25.5332 31.5499 25.9999C31.5499 26.4332 31.4083 26.7999 31.125 27.0999C30.8416 27.3999 30.4666 27.5499 30 27.5499ZM11.85 24.4999C11.7166 22.5999 12 20.8499 12.7 19.2499C13.4 17.6499 14.3333 16.2832 15.5 15.1499C16.6666 14.0166 18.0083 13.1416 19.525 12.5249C21.0416 11.9082 22.5666 11.5999 24.1 11.5999C27.1333 11.5999 29.725 12.5749 31.875 14.5249C34.025 16.4749 35.3 18.8832 35.7 21.7499C32.5666 21.7166 29.7916 20.8916 27.375 19.2749C24.9583 17.6582 23.0833 15.5499 21.75 12.9499C21.2166 15.6166 20.0583 17.9749 18.275 20.0249C16.4916 22.0749 14.35 23.5666 11.85 24.4999Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconHelp = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2 35.65C24.7333 35.65 25.1916 35.4583 25.575 35.075C25.9583 34.6916 26.15 34.2166 26.15 33.65C26.15 33.0833 25.9583 32.6083 25.575 32.2249C25.1916 31.8416 24.7166 31.65 24.15 31.65C23.6166 31.65 23.1583 31.8416 22.775 32.2249C22.3916 32.6083 22.2 33.0833 22.2 33.65C22.2 34.2166 22.3916 34.6916 22.775 35.075C23.1583 35.4583 23.6333 35.65 24.2 35.65ZM22.35 28.35H25.45C25.45 27.4833 25.5583 26.6916 25.775 25.975C25.9916 25.2583 26.65 24.4499 27.75 23.5499C28.7833 22.7166 29.5166 21.875 29.95 21.025C30.3833 20.1749 30.6 19.25 30.6 18.25C30.6 16.45 30.0333 15.0166 28.9 13.95C27.7666 12.8833 26.2333 12.35 24.2999 12.35C22.6666 12.35 21.2083 12.7666 19.9249 13.6C18.6416 14.4333 17.7166 15.5833 17.15 17.05L19.95 18.15C20.35 17.2166 20.9083 16.4916 21.625 15.975C22.3416 15.4583 23.1833 15.2 24.15 15.2C25.1833 15.2 26.0333 15.4916 26.7 16.075C27.3666 16.6583 27.7 17.4166 27.7 18.35C27.7 19.05 27.4916 19.725 27.075 20.375C26.6583 21.025 26.0499 21.6666 25.25 22.2999C24.2833 23.1666 23.5583 24.0333 23.075 24.9C22.5916 25.7666 22.35 26.9166 22.35 28.35ZM24 44.2999C21.1666 44.2999 18.5083 43.7833 16.025 42.75C13.5416 41.7166 11.3916 40.2916 9.57495 38.4749C7.75828 36.6583 6.32495 34.5083 5.27495 32.025C4.22495 29.5416 3.69995 26.8666 3.69995 24C3.69995 21.1666 4.22495 18.5083 5.27495 16.025C6.32495 13.5416 7.75828 11.3916 9.57495 9.57495C11.3916 7.75828 13.5416 6.32495 16.025 5.27495C18.5083 4.22495 21.1666 3.69995 24 3.69995C26.7999 3.69995 29.4333 4.22495 31.9 5.27495C34.3666 6.32495 36.5166 7.75828 38.3499 9.57495C40.1833 11.3916 41.6333 13.5333 42.7 16C43.7666 18.4666 44.2999 21.1333 44.2999 24C44.2999 26.8666 43.7666 29.5416 42.7 32.025C41.6333 34.5083 40.1833 36.6583 38.3499 38.4749C36.5166 40.2916 34.3666 41.7166 31.9 42.75C29.4333 43.7833 26.7999 44.2999 24 44.2999ZM24 40.9C28.6666 40.9 32.65 39.25 35.95 35.95C39.25 32.65 40.9 28.6666 40.9 24C40.9 19.3666 39.25 15.3916 35.95 12.075C32.65 8.75828 28.6666 7.09995 24 7.09995C19.2333 7.09995 15.225 8.75828 11.975 12.075C8.72495 15.3916 7.09995 19.3666 7.09995 24C7.09995 28.6666 8.72495 32.65 11.975 35.95C15.225 39.25 19.2333 40.9 24 40.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconMoreVert = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 40.4001C23.3 40.4001 22.7 40.1501 22.2 39.6501C21.7 39.1501 21.45 38.5501 21.45 37.8501C21.45 37.1834 21.7 36.6001 22.2 36.1001C22.7 35.6001 23.3 35.3501 24 35.3501C24.7 35.3501 25.2999 35.6001 25.7999 36.1001C26.2999 36.6001 26.5499 37.2001 26.5499 37.9001C26.5499 38.5668 26.2999 39.1501 25.7999 39.6501C25.2999 40.1501 24.7 40.4001 24 40.4001ZM24 26.5501C23.3 26.5501 22.7 26.3001 22.2 25.8001C21.7 25.3001 21.45 24.7001 21.45 24.0001C21.45 23.3001 21.7 22.7001 22.2 22.2001C22.7 21.7001 23.3 21.4501 24 21.4501C24.7 21.4501 25.2999 21.7001 25.7999 22.2001C26.2999 22.7001 26.5499 23.3001 26.5499 24.0001C26.5499 24.7001 26.2999 25.3001 25.7999 25.8001C25.2999 26.3001 24.7 26.5501 24 26.5501ZM24 12.6501C23.3 12.6501 22.7 12.4001 22.2 11.9001C21.7 11.4001 21.45 10.8001 21.45 10.1001C21.45 9.4001 21.7 8.80843 22.2 8.3251C22.7 7.84176 23.3 7.6001 24 7.6001C24.7 7.6001 25.2999 7.8501 25.7999 8.3501C26.2999 8.8501 26.5499 9.4501 26.5499 10.1501C26.5499 10.8501 26.2999 11.4418 25.7999 11.9251C25.2999 12.4084 24.7 12.6501 24 12.6501Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSettings = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1501 44.2999L18.1001 37.9C17.5334 37.7 16.9168 37.4083 16.2501 37.025C15.5834 36.6416 15.0001 36.25 14.5001 35.8499L8.5501 38.5999L3.6001 29.9L9.1001 25.9C9.03343 25.6333 8.99177 25.3166 8.9751 24.95C8.95843 24.5833 8.9501 24.2666 8.9501 24C8.9501 23.7333 8.95843 23.4166 8.9751 23.0499C8.99177 22.6833 9.03343 22.3666 9.1001 22.1L3.6001 18.1L8.5501 9.39995L14.5501 12.15C15.0168 11.75 15.5834 11.3666 16.2501 11C16.9168 10.6333 17.5334 10.35 18.1001 10.15L19.1501 3.69995H28.8501L29.9001 10.1C30.4668 10.3333 31.0918 10.625 31.7751 10.975C32.4584 11.325 33.0334 11.7166 33.5001 12.15L39.5001 9.39995L44.4001 18.1L38.9001 22C38.9668 22.2999 39.0084 22.6333 39.0251 23C39.0418 23.3666 39.0501 23.7 39.0501 24C39.0501 24.2999 39.0418 24.625 39.0251 24.975C39.0084 25.325 38.9668 25.65 38.9001 25.95L44.4001 29.9L39.4501 38.5999L33.4501 35.8499C32.9834 36.25 32.4251 36.6499 31.7751 37.0499C31.1251 37.45 30.5001 37.7333 29.9001 37.9L28.8501 44.2999H19.1501ZM24.0001 30.5C25.8001 30.5 27.3334 29.8666 28.6001 28.6C29.8668 27.3333 30.5001 25.7999 30.5001 24C30.5001 22.2 29.8668 20.6666 28.6001 19.4C27.3334 18.1333 25.8001 17.5 24.0001 17.5C22.2001 17.5 20.6668 18.1333 19.4001 19.4C18.1334 20.6666 17.5001 22.2 17.5001 24C17.5001 25.7999 18.1334 27.3333 19.4001 28.6C20.6668 29.8666 22.2001 30.5 24.0001 30.5ZM24.0001 27.5C23.0001 27.5 22.1668 27.1583 21.5001 26.475C20.8334 25.7916 20.5001 24.9666 20.5001 24C20.5001 23.0333 20.8334 22.2083 21.5001 21.525C22.1668 20.8416 23.0001 20.5 24.0001 20.5C24.9668 20.5 25.7918 20.8416 26.4751 21.525C27.1584 22.2083 27.5001 23.0333 27.5001 24C27.5001 24.9666 27.1584 25.7916 26.4751 26.475C25.7918 27.1583 24.9668 27.5 24.0001 27.5ZM21.9001 40.9H26.1001L26.8001 35.2999C27.9001 35.0333 28.9501 34.6166 29.9501 34.0499C30.9501 33.4833 31.8501 32.7833 32.6501 31.95L37.9501 34.25L39.8501 30.7999L35.1501 27.4C35.2834 26.8333 35.4001 26.2666 35.5001 25.7C35.6001 25.1333 35.6501 24.5666 35.6501 24C35.6501 23.4333 35.6084 22.8666 35.5251 22.2999C35.4418 21.7333 35.3168 21.1666 35.1501 20.6L39.8501 17.2L37.9501 13.75L32.6501 16.05C31.8834 15.15 31.0084 14.4 30.0251 13.8C29.0418 13.2 27.9668 12.8333 26.8001 12.7L26.1001 7.09995H21.9001L21.2001 12.7C20.0668 12.9 19.0001 13.2916 18.0001 13.875C17.0001 14.4583 16.1001 15.1833 15.3001 16.05L10.0501 13.75L8.1501 17.2L12.8001 20.6C12.6668 21.1666 12.5584 21.7333 12.4751 22.2999C12.3918 22.8666 12.3501 23.4333 12.3501 24C12.3501 24.5666 12.3918 25.1333 12.4751 25.7C12.5584 26.2666 12.6668 26.8333 12.8001 27.4L8.1501 30.7999L10.0501 34.25L15.3001 31.95C16.1334 32.7833 17.0501 33.4833 18.0501 34.0499C19.0501 34.6166 20.1001 35.0333 21.2001 35.2999L21.9001 40.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconMenuBook = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 19.3V16.9C29.1 16.4333 30.225 16.0833 31.375 15.85C32.525 15.6167 33.7333 15.5 35 15.5C35.8667 15.5 36.7167 15.5667 37.55 15.7C38.3833 15.8333 39.2 16 40 16.2V18.4C39.2 18.1 38.3917 17.875 37.575 17.725C36.7583 17.575 35.9 17.5 35 17.5C33.7333 17.5 32.5167 17.6583 31.35 17.975C30.1833 18.2917 29.0667 18.7333 28 19.3ZM28 30.3V27.85C29.1 27.3833 30.225 27.0417 31.375 26.825C32.525 26.6083 33.7333 26.5 35 26.5C35.8667 26.5 36.7167 26.5667 37.55 26.7C38.3833 26.8333 39.2 27 40 27.2V29.4C39.2 29.1 38.3917 28.875 37.575 28.725C36.7583 28.575 35.9 28.5 35 28.5C33.7333 28.5 32.5167 28.65 31.35 28.95C30.1833 29.25 29.0667 29.7 28 30.3ZM28 24.8V22.4C29.1 21.9333 30.225 21.5833 31.375 21.35C32.525 21.1167 33.7333 21 35 21C35.8667 21 36.7167 21.0667 37.55 21.2C38.3833 21.3333 39.2 21.5 40 21.7V23.9C39.2 23.6 38.3917 23.375 37.575 23.225C36.7583 23.075 35.9 23 35 23C33.7333 23 32.5167 23.1583 31.35 23.475C30.1833 23.7917 29.0667 24.2333 28 24.8ZM12.4 33C14.2 33 15.9417 33.2083 17.625 33.625C19.3083 34.0417 20.9667 34.6667 22.6 35.5V14.15C21.1 13.15 19.475 12.375 17.725 11.825C15.975 11.275 14.2 11 12.4 11C11.1333 11 9.89167 11.1583 8.675 11.475C7.45833 11.7917 6.23333 12.1833 5 12.65V34.35C6.03333 33.8833 7.20833 33.5417 8.525 33.325C9.84167 33.1083 11.1333 33 12.4 33ZM25.6 35.5C27.2667 34.6667 28.9 34.0417 30.5 33.625C32.1 33.2083 33.8 33 35.6 33C36.8667 33 38.175 33.1 39.525 33.3C40.875 33.5 42.0333 33.7667 43 34.1V12.65C41.8667 12.0833 40.6667 11.6667 39.4 11.4C38.1333 11.1333 36.8667 11 35.6 11C33.8 11 32.0583 11.275 30.375 11.825C28.6917 12.375 27.1 13.15 25.6 14.15V35.5ZM24.1 40C22.4 38.7333 20.55 37.7583 18.55 37.075C16.55 36.3917 14.5 36.05 12.4 36.05C11.1667 36.05 9.96667 36.2 8.8 36.5C7.63333 36.8 6.46667 37.1667 5.3 37.6C4.53333 37.9667 3.79167 37.9167 3.075 37.45C2.35833 36.9833 2 36.3167 2 35.45V12.3C2 11.8 2.11667 11.3417 2.35 10.925C2.58333 10.5083 2.93333 10.1833 3.4 9.95C4.8 9.28333 6.25833 8.79167 7.775 8.475C9.29167 8.15833 10.8333 8 12.4 8C14.5 8 16.5417 8.28333 18.525 8.85C20.5083 9.41667 22.3667 10.2833 24.1 11.45C25.8 10.2833 27.625 9.41667 29.575 8.85C31.525 8.28333 33.5333 8 35.6 8C37.1667 8 38.7 8.15833 40.2 8.475C41.7 8.79167 43.15 9.28333 44.55 9.95C45.0167 10.1833 45.375 10.5083 45.625 10.925C45.875 11.3417 46 11.8 46 12.3V35.45C46 36.3833 45.625 37.0917 44.875 37.575C44.125 38.0583 43.3833 38.0667 42.65 37.6C41.5167 37.1333 40.3667 36.7583 39.2 36.475C38.0333 36.1917 36.8333 36.05 35.6 36.05C33.5 36.05 31.4833 36.4 29.55 37.1C27.6167 37.8 25.8 38.7667 24.1 40Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconForum = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 34.2V5.74995C3.5 5.21662 3.73333 4.69995 4.2 4.19995C4.66667 3.69995 5.16667 3.44995 5.7 3.44995H31.85C32.4167 3.44995 32.9333 3.69162 33.4 4.17495C33.8667 4.65828 34.1 5.18328 34.1 5.74995V23.75C34.1 24.2833 33.8667 24.7999 33.4 25.2999C32.9333 25.7999 32.4167 26.0499 31.85 26.0499H11.65L3.5 34.2ZM14.1 36.45C13.5667 36.45 13.0583 36.2 12.575 35.7C12.0917 35.2 11.85 34.6833 11.85 34.15V29.0499H37.1V11.8H42.3C42.8333 11.8 43.3333 12.05 43.8 12.55C44.2667 13.05 44.5 13.5833 44.5 14.15V44.5L36.5 36.45H14.1ZM30.7 6.84995H6.9V26.0499L10.35 22.65H30.7V6.84995ZM6.9 6.84995V26.0499V6.84995Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconCall = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.7492 42.3002C35.6492 42.3002 31.5742 41.2919 27.5242 39.2752C23.4742 37.2585 19.8326 34.6335 16.5992 31.4002C13.3659 28.1669 10.7409 24.5169 8.72422 20.4502C6.70755 16.3835 5.69922 12.3169 5.69922 8.2502C5.69922 7.51686 5.94089 6.90853 6.42422 6.4252C6.90755 5.94186 7.51589 5.7002 8.24922 5.7002H15.2492C15.8159 5.7002 16.3159 5.88353 16.7492 6.2502C17.1826 6.61686 17.4659 7.11686 17.5992 7.7502L18.9492 13.9002C19.0492 14.4669 19.0409 14.9752 18.9242 15.4252C18.8076 15.8752 18.5826 16.2502 18.2492 16.5502L13.1992 21.5502C15.0326 24.5169 17.0576 27.1085 19.2742 29.3252C21.4909 31.5419 23.9992 33.4169 26.7992 34.9502L31.6492 30.0002C32.0492 29.5669 32.4909 29.2669 32.9742 29.1002C33.4575 28.9335 33.9659 28.9169 34.4992 29.0502L40.1992 30.3502C40.8326 30.4835 41.3409 30.7835 41.7242 31.2502C42.1075 31.7169 42.2992 32.2669 42.2992 32.9002V39.7502C42.2992 40.4502 42.0576 41.0502 41.5742 41.5502C41.0909 42.0502 40.4826 42.3002 39.7492 42.3002ZM11.4992 18.4502L15.5492 14.4502L14.3992 9.1002H9.14922C9.11589 10.3669 9.29089 11.7502 9.67422 13.2502C10.0576 14.7502 10.6659 16.4835 11.4992 18.4502ZM29.9992 36.6002C31.2992 37.2335 32.7326 37.7502 34.2992 38.1502C35.8659 38.5502 37.3992 38.7835 38.8992 38.8502V33.5502L33.8992 32.5002L29.9992 36.6002Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconWhatsApp = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M36.7559 11.2559C33.3691 7.86914 28.8691 6 24.0762 6C14.1973 6 6.15234 14.0391 6.15234 23.918C6.14648 27.0762 6.97266 30.1582 8.54297 32.877L6 42.1641L15.5039 39.668C18.1172 41.0977 21.0703 41.8477 24.0703 41.8535H24.0762C33.9551 41.8535 41.9941 33.8145 42 23.9297C42 19.1426 40.1367 14.6426 36.7559 11.2559ZM24.0762 38.8242H24.0703C21.3984 38.8242 18.7734 38.1035 16.4883 36.75L15.9434 36.4277L10.3008 37.9043L11.8066 32.4082L11.4551 31.8457C9.96094 29.4727 9.17578 26.7305 9.17578 23.918C9.17578 15.709 15.8613 9.0293 24.082 9.0293C28.0605 9.0293 31.7988 10.582 34.6113 13.3945C37.4238 16.2129 38.9707 19.9512 38.9707 23.9297C38.9707 32.1445 32.2852 38.8242 24.0762 38.8242ZM32.2441 27.668C31.7988 27.4453 29.5957 26.3613 29.1855 26.2148C28.7754 26.0625 28.4766 25.9922 28.1777 26.4375C27.8789 26.8887 27.0234 27.8965 26.7598 28.1953C26.502 28.4883 26.2383 28.5293 25.793 28.3066C25.3418 28.084 23.9004 27.6094 22.1895 26.0801C20.8594 24.8965 19.957 23.4258 19.6992 22.9805C19.4355 22.5293 19.6699 22.2891 19.8926 22.0664C20.0977 21.8672 20.3438 21.5449 20.5664 21.2812C20.7891 21.0234 20.8652 20.8359 21.0176 20.5371C21.1641 20.2383 21.0879 19.9746 20.9766 19.752C20.8652 19.5293 19.9688 17.3203 19.5938 16.4238C19.2305 15.5508 18.8613 15.6738 18.5859 15.6562C18.3281 15.6445 18.0293 15.6445 17.7305 15.6445C17.4316 15.6445 16.9453 15.7559 16.5352 16.207C16.125 16.6523 14.9707 17.7363 14.9707 19.9395C14.9707 22.1426 16.5762 24.2754 16.7988 24.5742C17.0215 24.8672 19.957 29.3906 24.4512 31.3301C25.5176 31.793 26.3496 32.0684 27 32.2734C28.0723 32.6133 29.0508 32.5664 29.8242 32.4551C30.6855 32.3262 32.4727 31.3711 32.8477 30.3223C33.2168 29.2793 33.2168 28.3828 33.1055 28.1953C32.9941 28.0078 32.6953 27.8965 32.2441 27.668Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconInfo = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 34.15h3.3V22h-3.3ZM24 18.5q.8 0 1.325-.525.525-.525.525-1.275 0-.8-.525-1.35T24 14.8q-.8 0-1.325.55-.525.55-.525 1.35 0 .75.525 1.275.525.525 1.325.525Zm0 25.8q-4.2 0-7.9-1.6t-6.45-4.35Q6.9 35.6 5.3 31.9 3.7 28.2 3.7 24q0-4.25 1.6-7.95t4.35-6.425Q12.4 6.9 16.1 5.3T24 3.7q4.25 0 7.95 1.6t6.425 4.325Q41.1 12.35 42.7 16.05q1.6 3.7 1.6 7.95 0 4.2-1.6 7.9t-4.325 6.45Q35.65 41.1 31.95 42.7q-3.7 1.6-7.95 1.6Zm.05-3.4q7 0 11.925-4.95Q40.9 31 40.9 23.95q0-7-4.925-11.925Q31.05 7.1 24 7.1q-7 0-11.95 4.925Q7.1 16.95 7.1 24q0 7 4.95 11.95 4.95 4.95 12 4.95ZM24 24Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Input action icons
const SrCompIconCalendarToday = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.09995 44.2999C8.19995 44.2999 7.40828 43.9583 6.72495 43.275C6.04162 42.5916 5.69995 41.8 5.69995 40.9V10.1C5.69995 9.16662 6.04162 8.36662 6.72495 7.69995C7.40828 7.03328 8.19995 6.69995 9.09995 6.69995H12.25V3.69995H15.7V6.69995H32.2999V3.69995H35.75V6.69995H38.9C39.8333 6.69995 40.6333 7.03328 41.2999 7.69995C41.9666 8.36662 42.2999 9.16662 42.2999 10.1V40.9C42.2999 41.8 41.9666 42.5916 41.2999 43.275C40.6333 43.9583 39.8333 44.2999 38.9 44.2999H9.09995ZM9.09995 40.9H38.9V19.5H9.09995V40.9ZM9.09995 16.5H38.9V10.1H9.09995V16.5ZM9.09995 16.5V10.1V16.5Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconCalendarViewMonth = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 96 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M142.152 901.978q-27.599 0-47.865-20.265-20.265-20.266-20.265-47.865V318.152q0-27.697 20.265-48.033 20.266-20.337 47.865-20.337h675.696q27.697 0 48.033 20.337 20.337 20.336 20.337 48.033v515.696q0 27.599-20.337 47.865-20.336 20.265-48.033 20.265H142.152Zm0-355.978h184.565V318.152H142.152V546Zm244.565 0h186.566V318.152H386.717V546Zm246.566 0h184.565V318.152H633.283V546ZM326.717 833.848V606H142.152v227.848h184.565Zm60 0h186.566V606H386.717v227.848Zm246.566 0h184.565V606H633.283v227.848Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconChatUnfilled = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 96 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M240 657h313v-60H240v60Zm0-130h480v-60H240v60Zm0-130h480v-60H240v60ZM74.022 981.978V238.152q0-26.697 20.265-47.533 20.266-20.837 47.865-20.837h675.696q26.697 0 47.533 20.837 20.837 20.836 20.837 47.533v515.696q0 26.599-20.837 47.365-20.836 20.765-47.533 20.765H234.022l-160 160Zm68.13-159.587 68.544-68.543h607.152V238.152H142.152v584.239Zm0-584.239v584.239-584.239Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSchedule = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.2 33.7L33.65 31.25L25.7999 23.35V13.4H22.5V24.65L31.2 33.7ZM24 44.2999C21.2333 44.2999 18.6083 43.7666 16.125 42.7C13.6416 41.6333 11.4833 40.1833 9.64995 38.3499C7.81662 36.5166 6.36662 34.3583 5.29995 31.875C4.23328 29.3916 3.69995 26.7666 3.69995 24C3.69995 21.2333 4.23328 18.6083 5.29995 16.125C6.36662 13.6416 7.81662 11.4833 9.64995 9.64995C11.4833 7.81662 13.6416 6.36662 16.125 5.29995C18.6083 4.23328 21.2333 3.69995 24 3.69995C26.7666 3.69995 29.3916 4.23328 31.875 5.29995C34.3583 6.36662 36.5166 7.81662 38.3499 9.64995C40.1833 11.4833 41.6333 13.6416 42.7 16.125C43.7666 18.6083 44.2999 21.2333 44.2999 24C44.2999 26.7666 43.7666 29.3916 42.7 31.875C41.6333 34.3583 40.1833 36.5166 38.3499 38.3499C36.5166 40.1833 34.3666 41.6333 31.9 42.7C29.4333 43.7666 26.7999 44.2999 24 44.2999ZM24 40.9C28.6333 40.9 32.6083 39.25 35.9249 35.95C39.2416 32.65 40.9 28.6666 40.9 24C40.9 19.3666 39.2416 15.3916 35.9249 12.075C32.6083 8.75828 28.6333 7.09995 24 7.09995C19.3666 7.09995 15.3916 8.75828 12.075 12.075C8.75828 15.3916 7.09995 19.3666 7.09995 24C7.09995 28.6666 8.75828 32.65 12.075 35.95C15.3916 39.25 19.3666 40.9 24 40.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconChatFilled = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 96 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M240 657h313v-60H240v60Zm0-130h480v-60H240v60Zm0-130h480v-60H240v60ZM74.022 981.978V238.152q0-26.697 20.265-47.533 20.266-20.837 47.865-20.837h675.696q26.697 0 47.533 20.837 20.837 20.836 20.837 47.533v515.696q0 26.599-20.837 47.365-20.836 20.765-47.533 20.765H234.022l-160 160Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconContentPasteGo = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.09995 41.6499C8.16662 41.6499 7.36662 41.3166 6.69995 40.6499C6.03328 39.9832 5.69995 39.1666 5.69995 38.1999V9.3499C5.69995 8.41657 5.99995 7.60824 6.59995 6.9249C7.19995 6.24157 7.73328 5.8999 8.19995 5.8999H17.95C18.2166 4.73324 18.8333 3.7749 19.8 3.0249C20.7666 2.2749 21.8666 1.8999 23.1 1.8999C24.3333 1.8999 25.4249 2.2749 26.375 3.0249C27.325 3.7749 27.95 4.73324 28.25 5.8999H38C38.9333 5.8999 39.7333 6.24157 40.4 6.9249C41.0666 7.60824 41.4 8.41657 41.4 9.3499V24.1999H38V9.3499H32.7V15.8499H14.4V9.3499H9.09995V38.1999H22.4V41.6499H9.09995ZM36.9 42.4499L34.5999 40.1999L38.2999 36.4999H25.4V33.1999H38.2999L34.5999 29.4999L36.9 27.1999L44.5499 34.8499L36.9 42.4499ZM24 8.9999C24.5666 8.9999 25.0416 8.80824 25.4249 8.4249C25.8083 8.04157 26 7.56657 26 6.9999C26 6.43324 25.8083 5.95824 25.4249 5.5749C25.0416 5.19157 24.5666 4.9999 24 4.9999C23.4333 4.9999 22.9583 5.19157 22.575 5.5749C22.1916 5.95824 22 6.43324 22 6.9999C22 7.56657 22.1916 8.04157 22.575 8.4249C22.9583 8.80824 23.4333 8.9999 24 8.9999Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconContentCopy = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3 38.0499C14.4 38.0499 13.6083 37.7083 12.925 37.025C12.2417 36.3416 11.9 35.55 11.9 34.65V6.84995C11.9 5.91662 12.2417 5.11662 12.925 4.44995C13.6083 3.78328 14.4 3.44995 15.3 3.44995H37.1C38.0333 3.44995 38.8333 3.78328 39.5 4.44995C40.1667 5.11662 40.5 5.91662 40.5 6.84995V34.65C40.5 35.55 40.1667 36.3416 39.5 37.025C38.8333 37.7083 38.0333 38.0499 37.1 38.0499H15.3ZM15.3 34.65H37.1V6.84995H15.3V34.65ZM8.9 44.45C7.96667 44.45 7.16667 44.1166 6.5 43.45C5.83333 42.7833 5.5 41.9833 5.5 41.0499V11H8.9V41.0499H32.5V44.45H8.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconCheckCircle = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0499 33.2999L35.2999 19L32.75 16.5L21.0499 28.25L15.15 22.35L12.65 24.85L21.0499 33.2999ZM24 44.2999C21.2333 44.2999 18.6083 43.7666 16.125 42.7C13.6416 41.6333 11.4833 40.1833 9.64995 38.3499C7.81662 36.5166 6.36662 34.3666 5.29995 31.9C4.23328 29.4333 3.69995 26.7999 3.69995 24C3.69995 21.2 4.23328 18.5583 5.29995 16.075C6.36662 13.5916 7.81662 11.4416 9.64995 9.62495C11.4833 7.80828 13.6333 6.36662 16.1 5.29995C18.5666 4.23328 21.2 3.69995 24 3.69995C26.7999 3.69995 29.4416 4.23328 31.9249 5.29995C34.4083 6.36662 36.5583 7.80828 38.375 9.62495C40.1916 11.4416 41.6333 13.5833 42.7 16.05C43.7666 18.5166 44.2999 21.1666 44.2999 24C44.2999 26.7999 43.7666 29.4333 42.7 31.9C41.6333 34.3666 40.1916 36.5166 38.375 38.3499C36.5583 40.1833 34.4166 41.6333 31.95 42.7C29.4833 43.7666 26.8333 44.2999 24 44.2999ZM24 40.9C28.7 40.9 32.6916 39.25 35.9749 35.95C39.2583 32.65 40.9 28.6666 40.9 24C40.9 19.3 39.2583 15.3083 35.9749 12.025C32.6916 8.74162 28.7 7.09995 24 7.09995C19.3333 7.09995 15.35 8.74162 12.05 12.025C8.74995 15.3083 7.09995 19.3 7.09995 24C7.09995 28.6666 8.74995 32.65 12.05 35.95C15.35 39.25 19.3333 40.9 24 40.9Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconShare = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.3499 44.2999C34.6833 44.2999 33.2666 43.7083 32.0999 42.525C30.9333 41.3416 30.35 39.9333 30.35 38.2999C30.35 38.0666 30.375 37.7833 30.4249 37.45C30.4749 37.1166 30.55 36.8166 30.65 36.5499L15.95 28C15.45 28.6 14.8166 29.0833 14.05 29.45C13.2833 29.8166 12.5 30 11.7 30C10.0333 30 8.61662 29.4166 7.44995 28.25C6.28328 27.0833 5.69995 25.6666 5.69995 24C5.69995 22.3333 6.28328 20.9166 7.44995 19.75C8.61662 18.5833 10.0333 18 11.7 18C12.5 18 13.2666 18.1583 14 18.475C14.7333 18.7916 15.3833 19.25 15.95 19.85L30.65 11.4C30.55 11.1666 30.4749 10.8916 30.4249 10.575C30.375 10.2583 30.35 9.96662 30.35 9.69995C30.35 8.03328 30.9333 6.61662 32.0999 5.44995C33.2666 4.28328 34.6833 3.69995 36.3499 3.69995C38.0166 3.69995 39.4333 4.28328 40.5999 5.44995C41.7666 6.61662 42.3499 8.03328 42.3499 9.69995C42.3499 11.3666 41.7666 12.7833 40.5999 13.95C39.4333 15.1166 38.0166 15.7 36.3499 15.7C35.5499 15.7 34.775 15.5666 34.025 15.3C33.275 15.0333 32.65 14.6166 32.15 14.05L17.45 22.15C17.5166 22.4166 17.575 22.7333 17.625 23.1C17.675 23.4666 17.7 23.7666 17.7 24C17.7 24.2333 17.675 24.4833 17.625 24.75C17.575 25.0166 17.5166 25.3 17.45 25.6L32.15 33.9C32.65 33.4333 33.25 33.0499 33.95 32.75C34.65 32.45 35.4499 32.2999 36.3499 32.2999C38.0166 32.2999 39.4333 32.8833 40.5999 34.0499C41.7666 35.2166 42.3499 36.6333 42.3499 38.2999C42.3499 39.9666 41.7666 41.3833 40.5999 42.5499C39.4333 43.7166 38.0166 44.2999 36.3499 44.2999ZM36.3499 12.4C37.1166 12.4 37.7583 12.1416 38.275 11.625C38.7916 11.1083 39.0499 10.4666 39.0499 9.69995C39.0499 8.93328 38.7916 8.29162 38.275 7.77495C37.7583 7.25828 37.1166 6.99995 36.3499 6.99995C35.5833 6.99995 34.9416 7.25828 34.4249 7.77495C33.9083 8.29162 33.65 8.93328 33.65 9.69995C33.65 10.4666 33.9083 11.1083 34.4249 11.625C34.9416 12.1416 35.5833 12.4 36.3499 12.4ZM11.7 26.7C12.4666 26.7 13.1083 26.4416 13.625 25.9249C14.1416 25.4083 14.4 24.7666 14.4 24C14.4 23.2333 14.1416 22.5916 13.625 22.075C13.1083 21.5583 12.4666 21.2999 11.7 21.2999C10.9333 21.2999 10.2916 21.5583 9.77495 22.075C9.25828 22.5916 8.99995 23.2333 8.99995 24C8.99995 24.7666 9.25828 25.4083 9.77495 25.9249C10.2916 26.4416 10.9333 26.7 11.7 26.7ZM36.3499 41C37.1166 41 37.7583 40.7416 38.275 40.2249C38.7916 39.7083 39.0499 39.0666 39.0499 38.2999C39.0499 37.5333 38.7916 36.8916 38.275 36.375C37.7583 35.8583 37.1166 35.5999 36.3499 35.5999C35.5833 35.5999 34.9416 35.8583 34.4249 36.375C33.9083 36.8916 33.65 37.5333 33.65 38.2999C33.65 39.0666 33.9083 39.7083 34.4249 40.2249C34.9416 40.7416 35.5833 41 36.3499 41Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconVisibility = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 31.5C26.3666 31.5 28.375 30.675 30.025 29.025C31.6749 27.375 32.5 25.3666 32.5 23C32.5 20.6333 31.6749 18.625 30.025 16.975C28.375 15.325 26.3666 14.5 24 14.5C21.6333 14.5 19.625 15.325 17.975 16.975C16.325 18.625 15.5 20.6333 15.5 23C15.5 25.3666 16.325 27.375 17.975 29.025C19.625 30.675 21.6333 31.5 24 31.5ZM24 28.4C22.5 28.4 21.2249 27.875 20.1749 26.825C19.125 25.775 18.6 24.5 18.6 23C18.6 21.5 19.125 20.225 20.1749 19.175C21.2249 18.125 22.5 17.6 24 17.6C25.5 17.6 26.775 18.125 27.825 19.175C28.875 20.225 29.4 21.5 29.4 23C29.4 24.5 28.875 25.775 27.825 26.825C26.775 27.875 25.5 28.4 24 28.4ZM24 38.2999C19.0666 38.2999 14.6083 36.8833 10.625 34.0499C6.64162 31.2166 3.66662 27.5333 1.69995 23C3.66662 18.4666 6.64162 14.7833 10.625 11.95C14.6083 9.11662 19.0666 7.69995 24 7.69995C28.9333 7.69995 33.3916 9.11662 37.375 11.95C41.3583 14.7833 44.3333 18.4666 46.2999 23C44.3333 27.5333 41.3583 31.2166 37.375 34.0499C33.3916 36.8833 28.9333 38.2999 24 38.2999ZM24 35C28.0333 35 31.7416 33.9083 35.125 31.725C38.5083 29.5416 41.0833 26.6333 42.8499 23C41.0833 19.3666 38.5083 16.4583 35.125 14.275C31.7416 12.0916 28.0333 11 24 11C19.9666 11 16.2583 12.0916 12.875 14.275C9.49162 16.4583 6.89995 19.3666 5.09995 23C6.89995 26.6333 9.49162 29.5416 12.875 31.725C16.2583 33.9083 19.9666 35 24 35Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconVisibilityOff = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.5 26.9001L28.9 24.3001C29.7333 22.1668 29.3416 20.4001 27.725 19.0001C26.1083 17.6001 24.4 17.2668 22.6 18.0001L20.1 15.5001C20.6666 15.1668 21.2833 14.9168 21.95 14.7501C22.6166 14.5834 23.2999 14.5001 24 14.5001C26.3666 14.5001 28.375 15.3251 30.025 16.9751C31.6749 18.6251 32.5 20.6334 32.5 23.0001C32.5 23.7001 32.4166 24.4001 32.25 25.1001C32.0833 25.8001 31.8333 26.4001 31.5 26.9001ZM38.2 33.6001L36 31.4001C37.5999 30.2001 38.9916 28.8751 40.1749 27.4251C41.3583 25.9751 42.25 24.5001 42.8499 23.0001C41.1499 19.3001 38.6416 16.3751 35.325 14.2251C32.0083 12.0751 28.4 11.0001 24.5 11.0001C23.1 11.0001 21.6833 11.1334 20.25 11.4001C18.8166 11.6668 17.7 11.9668 16.9 12.3001L14.4 9.7001C15.5666 9.16676 17.0666 8.7001 18.9 8.3001C20.7333 7.9001 22.5166 7.7001 24.25 7.7001C29.0499 7.7001 33.45 9.0751 37.45 11.8251C41.45 14.5751 44.3999 18.3001 46.2999 23.0001C45.4333 25.1334 44.3083 27.1001 42.9249 28.9001C41.5416 30.7001 39.9666 32.2668 38.2 33.6001ZM40.7 44.9001L32.45 36.8001C31.2833 37.2668 29.9666 37.6334 28.5 37.9001C27.0333 38.1668 25.5333 38.3001 24 38.3001C19.1 38.3001 14.6416 36.9251 10.625 34.1751C6.60828 31.4251 3.63328 27.7001 1.69995 23.0001C2.36662 21.2668 3.29995 19.5668 4.49995 17.9001C5.69995 16.2334 7.13329 14.6334 8.79995 13.1001L2.54995 6.9001L4.74995 4.6001L42.75 42.6001L40.7 44.9001ZM11.05 15.4001C9.84995 16.3001 8.69162 17.4668 7.57495 18.9001C6.45828 20.3334 5.63328 21.7001 5.09995 23.0001C6.83328 26.7001 9.39995 29.6251 12.8 31.7751C16.2 33.9251 20.0666 35.0001 24.4 35.0001C25.4666 35.0001 26.5166 34.9334 27.5499 34.8001C28.5833 34.6668 29.3666 34.4668 29.9 34.2001L26.7 31.0001C26.3666 31.1668 25.9416 31.2918 25.4249 31.3751C24.9083 31.4584 24.4333 31.5001 24 31.5001C21.6666 31.5001 19.6666 30.6834 18 29.0501C16.3333 27.4168 15.5 25.4001 15.5 23.0001C15.5 22.5334 15.5416 22.0584 15.625 21.5751C15.7083 21.0918 15.8166 20.6668 15.95 20.3001L11.05 15.4001Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconTimer = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7 4.99995V1.69995H30.2999V4.99995H17.7ZM22.35 27.6H25.65V16.1H22.35V27.6ZM24 44.5C21.4666 44.5 19.0916 44.0166 16.875 43.0499C14.6583 42.0833 12.725 40.775 11.075 39.125C9.42495 37.4749 8.11662 35.5416 7.14995 33.325C6.18328 31.1083 5.69995 28.7333 5.69995 26.2C5.69995 23.7 6.18328 21.3333 7.14995 19.1C8.11662 16.8666 9.42495 14.925 11.075 13.275C12.725 11.625 14.6583 10.3166 16.875 9.34995C19.0916 8.38329 21.4666 7.89995 24 7.89995C26.2333 7.89995 28.35 8.27495 30.35 9.02495C32.35 9.77495 34.1166 10.8166 35.65 12.15L38.2999 9.49995L40.5999 11.8L37.95 14.45C39.15 15.8166 40.175 17.4583 41.025 19.375C41.875 21.2916 42.2999 23.5666 42.2999 26.2C42.2999 28.7333 41.8166 31.1083 40.8499 33.325C39.8833 35.5416 38.575 37.4749 36.9249 39.125C35.275 40.775 33.3333 42.0833 31.1 43.0499C28.8666 44.0166 26.5 44.5 24 44.5ZM24 41.0999C28.1333 41.0999 31.65 39.65 34.5499 36.75C37.4499 33.8499 38.9 30.3333 38.9 26.2C38.9 22.0666 37.4499 18.55 34.5499 15.65C31.65 12.75 28.1333 11.3 24 11.3C19.8666 11.3 16.35 12.75 13.45 15.65C10.55 18.55 9.09995 22.0666 9.09995 26.2C9.09995 30.3333 10.55 33.8499 13.45 36.75C16.35 39.65 19.8666 41.0999 24 41.0999Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconAddAPhoto = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.5999 15.3499V10.9999H34.2V7.8499H38.5999V3.3999H41.75V7.8499H46.2V10.9999H41.75V15.3499H38.5999ZM4.89995 44.2999C3.96662 44.2999 3.15828 43.9582 2.47495 43.2749C1.79162 42.5916 1.44995 41.7999 1.44995 40.8999V15.4499C1.44995 14.5499 1.79162 13.7582 2.47495 13.0749C3.15828 12.3916 3.96662 12.0499 4.89995 12.0499H12.05L15.85 7.5499H29.5499V10.9999H17.4L13.65 15.4499H4.89995V40.8999H38.65V20.1999H42.0499V40.8999C42.0499 41.7999 41.7083 42.5916 41.025 43.2749C40.3416 43.9582 39.55 44.2999 38.65 44.2999H4.89995ZM21.75 36.6999C24.15 36.6999 26.1666 35.8832 27.7999 34.2499C29.4333 32.6166 30.25 30.5832 30.25 28.1499C30.25 25.7499 29.4333 23.7416 27.7999 22.1249C26.1666 20.5082 24.15 19.6999 21.75 19.6999C19.3166 19.6999 17.2916 20.5082 15.675 22.1249C14.0583 23.7416 13.25 25.7499 13.25 28.1499C13.25 30.5832 14.0583 32.6166 15.675 34.2499C17.2916 35.8832 19.3166 36.6999 21.75 36.6999V36.6999ZM21.75 33.6999C20.15 33.6999 18.8333 33.1749 17.7999 32.1249C16.7666 31.0749 16.25 29.7499 16.25 28.1499C16.25 26.5832 16.7666 25.2832 17.7999 24.2499C18.8333 23.2166 20.15 22.6999 21.75 22.6999C23.3166 22.6999 24.6249 23.2166 25.6749 24.2499C26.7249 25.2832 27.25 26.5832 27.25 28.1499C27.25 29.7499 26.7249 31.0749 25.6749 32.1249C24.6249 33.1749 23.3166 33.6999 21.75 33.6999V33.6999Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconLocation = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.0008 23.55C24.9674 23.55 25.8008 23.2 26.5008 22.5C27.2008 21.8 27.5508 20.9667 27.5508 20C27.5508 19.0334 27.2008 18.2 26.5008 17.5C25.8008 16.8 24.9674 16.45 24.0008 16.45C23.0341 16.45 22.2008 16.8 21.5008 17.5C20.8008 18.2 20.4508 19.0334 20.4508 20C20.4508 20.9667 20.8008 21.8 21.5008 22.5C22.2008 23.2 23.0341 23.55 24.0008 23.55ZM24.0008 39.75C28.3674 35.7834 31.5924 32.1834 33.6758 28.9501C35.7591 25.7167 36.8008 22.8667 36.8008 20.4C36.8008 16.5334 35.5674 13.3667 33.1008 10.9C30.6341 8.43338 27.6008 7.20005 24.0008 7.20005C20.4008 7.20005 17.3674 8.43338 14.9008 10.9C12.4341 13.3667 11.2008 16.5334 11.2008 20.4C11.2008 22.8667 12.2674 25.7167 14.4008 28.9501C16.5341 32.1834 19.7341 35.7834 24.0008 39.75ZM24.0008 44.25C18.5674 39.65 14.5091 35.3667 11.8258 31.4C9.14245 27.4334 7.80078 23.7667 7.80078 20.4C7.80078 15.3334 9.42578 11.3 12.6758 8.30005C15.9258 5.30005 19.7008 3.80005 24.0008 3.80005C28.3008 3.80005 32.0758 5.30005 35.3258 8.30005C38.5758 11.3 40.2008 15.3334 40.2008 20.4C40.2008 23.7667 38.8591 27.4334 36.1758 31.4C33.4924 35.3667 29.4341 39.65 24.0008 44.25Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconMail = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.09922 40.3002C6.19922 40.3002 5.40755 39.9585 4.72422 39.2752C4.04089 38.5919 3.69922 37.8002 3.69922 36.9002V11.1002C3.69922 10.1669 4.04089 9.36686 4.72422 8.7002C5.40755 8.03353 6.19922 7.7002 7.09922 7.7002H40.8992C41.8326 7.7002 42.6326 8.03353 43.2992 8.7002C43.9659 9.36686 44.2992 10.1669 44.2992 11.1002V36.9002C44.2992 37.8002 43.9659 38.5919 43.2992 39.2752C42.6326 39.9585 41.8326 40.3002 40.8992 40.3002H7.09922ZM23.9992 25.3002L7.09922 14.1502V36.9002H40.8992V14.1502L23.9992 25.3002ZM23.9992 22.0002L40.6992 11.1002H7.34922L23.9992 22.0002ZM7.09922 14.1502V11.1002V36.9002V14.1502Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Inhouse icons
const SrCompIconShram = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 1.5C11.5736 1.5 1.5 11.5736 1.5 24C1.5 36.4264 11.5736 46.5 24 46.5C36.4264 46.5 46.5 36.4264 46.5 24C46.5 11.5736 36.4264 1.5 24 1.5ZM0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
        fill={props.color ? props.color : "black"}
      />
      <path
        d="M14.3439 19.322H21.1983L25.5874 13.056C26.0103 12.4474 26.1755 11.6963 26.0468 10.9664C25.9181 10.2365 25.5061 9.58716 24.9005 9.15988L24.6571 8.98948C24.0485 8.56679 23.2974 8.4018 22.5676 8.53046C21.8378 8.65912 21.1884 9.07101 20.761 9.67636L13.9963 19.3349C14.112 19.3268 14.2267 19.322 14.3439 19.322Z"
        fill={props.color ? props.color : "black"}
      />
      <path
        d="M29.942 21.2291C29.9958 21.1523 30.0519 21.0779 30.1095 21.0054H14.3439C13.5626 21.0054 12.8132 21.3158 12.2606 21.8683C11.7081 22.4208 11.3977 23.1702 11.3977 23.9516C11.3977 24.733 11.7081 25.4824 12.2606 26.0349C12.8132 26.5874 13.5626 26.8979 14.3439 26.8979H25.9729L29.942 21.2291Z"
        fill={props.color ? props.color : "black"}
      />
      <path
        d="M27.2864 38.2291L36.1472 25.5744C36.5701 24.9658 36.7353 24.2147 36.6066 23.4848C36.4779 22.7549 36.0659 22.1055 35.4603 21.6783L35.217 21.5079C34.6089 21.0831 33.8573 20.917 33.1269 21.0457C32.3965 21.1745 31.7469 21.5877 31.3208 22.1947L22.46 34.848C22.0353 35.456 21.8691 36.2077 21.9979 36.9381C22.1266 37.6685 22.5399 38.318 23.1469 38.7442L23.3902 38.9146C23.9981 39.3394 24.7496 39.5059 25.48 39.3774C26.2104 39.2489 26.86 38.8359 27.2864 38.2291V38.2291Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconAccountCircle = (props) => {
  return (
    <div
      style={{
        alignItems: "center",
        justifyContent: "center",
        width: props.size,
        height: props.size,
        borderRadius: props.size * 0.5,
        backgroundColor: props.color ? props.color : "black"
      }}
    >
      <svg
        width={props.size ? props.size * 0.72 : 20 * 0.72}
        height={props.size ? props.size * 0.72 : 20 * 0.72}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.15 35.1002C13.25 33.6669 15.325 32.5585 17.375 31.7752C19.425 30.9919 21.6333 30.6002 24 30.6002C26.3666 30.6002 28.5916 30.9919 30.6749 31.7752C32.7583 32.5585 34.8333 33.6669 36.9 35.1002C38.3666 33.3002 39.4 31.5002 40 29.7002C40.5999 27.9002 40.9 26.0002 40.9 24.0002C40.9 19.2002 39.2833 15.1835 36.0499 11.9502C32.8166 8.71686 28.7999 7.1002 24 7.1002C19.2 7.1002 15.1833 8.71686 11.95 11.9502C8.71662 15.1835 7.09995 19.2002 7.09995 24.0002C7.09995 26.0002 7.40828 27.9002 8.02495 29.7002C8.64162 31.5002 9.68328 33.3002 11.15 35.1002ZM24 25.6002C22.0333 25.6002 20.3916 24.9335 19.075 23.6002C17.7583 22.2669 17.1 20.6169 17.1 18.6502C17.1 16.7169 17.7666 15.0835 19.1 13.7502C20.4333 12.4169 22.0666 11.7502 24 11.7502C25.9666 11.7502 27.6083 12.4169 28.9249 13.7502C30.2416 15.0835 30.9 16.7335 30.9 18.7002C30.9 20.6335 30.2333 22.2669 28.9 23.6002C27.5666 24.9335 25.9333 25.6002 24 25.6002ZM24 44.3002C21.2333 44.3002 18.6166 43.7669 16.15 42.7002C13.6833 41.6335 11.525 40.1752 9.67495 38.3252C7.82495 36.4752 6.36662 34.3252 5.29995 31.8752C4.23328 29.4252 3.69995 26.8002 3.69995 24.0002C3.69995 21.2002 4.23328 18.5752 5.29995 16.1252C6.36662 13.6752 7.82495 11.5252 9.67495 9.6752C11.525 7.8252 13.675 6.36686 16.125 5.3002C18.575 4.23353 21.2 3.7002 24 3.7002C26.7999 3.7002 29.4249 4.23353 31.875 5.3002C34.325 6.36686 36.475 7.8252 38.325 9.6752C40.1749 11.5252 41.6333 13.6752 42.7 16.1252C43.7666 18.5752 44.2999 21.2002 44.2999 24.0002C44.2999 26.7669 43.7666 29.3835 42.7 31.8502C41.6333 34.3169 40.1749 36.4752 38.325 38.3252C36.475 40.1752 34.325 41.6335 31.875 42.7002C29.4249 43.7669 26.7999 44.3002 24 44.3002ZM24 40.9002C25.7999 40.9002 27.5583 40.6419 29.275 40.1252C30.9916 39.6085 32.7 38.7002 34.4 37.4002C32.7 36.2002 30.9916 35.2919 29.275 34.6752C27.5583 34.0585 25.7999 33.7502 24 33.7502C22.2 33.7502 20.45 34.0585 18.75 34.6752C17.05 35.2919 15.3333 36.2002 13.6 37.4002C15.3 38.7002 17.0083 39.6085 18.725 40.1252C20.4416 40.6419 22.2 40.9002 24 40.9002ZM24 22.4502C25.1 22.4502 26.0083 22.1002 26.725 21.4002C27.4416 20.7002 27.7999 19.7835 27.7999 18.6502C27.7999 17.5502 27.4416 16.6502 26.725 15.9502C26.0083 15.2502 25.1 14.9002 24 14.9002C22.9 14.9002 21.9916 15.2502 21.275 15.9502C20.5583 16.6502 20.2 17.5502 20.2 18.6502C20.2 19.7835 20.5583 20.7002 21.275 21.4002C21.9916 22.1002 22.9 22.4502 24 22.4502Z"
          fill={"white"}
        />
      </svg>
    </div>
  );
};

const SrCompIconRocketLaunch = (props) => {
  return (
    <div
      style={{
        alignItems: "center",
        justifyContent: "center",
        width: props.size,
        height: props.size,
        borderRadius: props.size * 0.5,
        backgroundColor: props.color ? props.color : "black"
      }}
    >
      <svg
        width={props.size ? props.size * 0.72 : 20 * 0.72}
        height={props.size ? props.size * 0.72 : 20 * 0.72}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.45 20.1496L14.55 22.3496C15.1167 21.2163 15.725 20.0913 16.375 18.9746C17.025 17.858 17.7 16.7996 18.4 15.7996L14.6 14.9996L9.45 20.1496ZM17.25 24.3496L23.85 30.9496C25.7833 30.0163 27.5667 29.0163 29.2 27.9496C30.8333 26.883 32.1667 25.833 33.2 24.7996C35.8667 22.133 37.825 19.408 39.075 16.6246C40.325 13.8413 41.0167 10.6496 41.15 7.04962C37.55 7.18296 34.3583 7.87462 31.575 9.12462C28.7917 10.3746 26.0667 12.333 23.4 14.9996C22.3667 16.033 21.3167 17.3663 20.25 18.9996C19.1833 20.633 18.1833 22.4163 17.25 24.3496ZM28.8 19.3996C28.1667 18.733 27.85 17.9163 27.85 16.9496C27.85 15.983 28.1667 15.1663 28.8 14.4996C29.4667 13.8663 30.2833 13.5496 31.25 13.5496C32.2167 13.5496 33.0333 13.8663 33.7 14.4996C34.3333 15.1663 34.65 15.983 34.65 16.9496C34.65 17.9163 34.3333 18.733 33.7 19.3996C33.0333 20.033 32.2167 20.3496 31.25 20.3496C30.2833 20.3496 29.4667 20.033 28.8 19.3996ZM28.05 38.7496L33.2 33.5996L32.4 29.7996C31.4 30.4996 30.3417 31.1746 29.225 31.8246C28.1083 32.4746 26.9833 33.083 25.85 33.6496L28.05 38.7496ZM44.6 3.59962C44.8667 8.39962 44.275 12.6913 42.825 16.4746C41.375 20.258 39.0167 23.7996 35.75 27.0996C35.6833 27.133 35.625 27.183 35.575 27.2496C35.525 27.3163 35.4833 27.3663 35.45 27.3996L36.55 32.8996C36.65 33.4996 36.6167 34.0663 36.45 34.5996C36.2833 35.133 36 35.5996 35.6 35.9996L26.9 44.7496L22.45 34.3996L13.8 25.7496L3.45 21.2996L12.2 12.5996C12.6333 12.1996 13.1083 11.9163 13.625 11.7496C14.1417 11.583 14.7 11.5496 15.3 11.6496L20.8 12.7496C20.8333 12.7163 20.875 12.683 20.925 12.6496C20.975 12.6163 21.0333 12.583 21.1 12.5496C24.4 9.24962 27.95 6.86629 31.75 5.39962C35.55 3.93296 39.8333 3.33296 44.6 3.59962ZM7.1 31.7996C8.3 30.5663 9.78333 29.9413 11.55 29.9246C13.3167 29.908 14.8 30.5163 16 31.7496C17.2333 32.9496 17.8417 34.433 17.825 36.1996C17.8083 37.9663 17.1833 39.4663 15.95 40.6996C15.05 41.5996 13.6333 42.3496 11.7 42.9496C9.76667 43.5496 6.95 44.083 3.25 44.5496C3.71667 40.883 4.24167 38.0663 4.825 36.0996C5.40833 34.133 6.16667 32.6996 7.1 31.7996ZM9.5 34.2496C9.03333 34.7163 8.625 35.458 8.275 36.4746C7.925 37.4913 7.61667 38.7996 7.35 40.3996C8.98333 40.133 10.3 39.8246 11.3 39.4746C12.3 39.1246 13.05 38.733 13.55 38.2996C14.15 37.7663 14.4583 37.0913 14.475 36.2746C14.4917 35.458 14.2 34.7496 13.6 34.1496C13 33.583 12.3 33.308 11.5 33.3246C10.7 33.3413 10.0333 33.6496 9.5 34.2496Z"
          fill={"white"}
        />
      </svg>
    </div>
  );
};

// Team icons
// Business strategy
const SrCompIconMonitoring = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 41.0004V38.5004L8.55 36.9504V41.0004H7ZM15.15 41.0004V30.5004L16.65 28.9504V41.0004H15.15ZM23.25 41.0004V28.9504L24.75 30.5504V41.0004H23.25ZM31.35 41.0004V30.5504L32.9 29.0004V41.0004H31.35ZM39.45 41.0004V22.5004L41 20.9504V41.0004H39.45ZM7 28.5504V26.4004L20 13.4504L28 21.4504L41 8.40039V10.6004L28 23.6004L20 15.6004L7 28.5504Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconConversionPath = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.15 41C36.9167 41 35.8417 40.6083 34.925 39.825C34.0083 39.0417 33.4833 38.0667 33.35 36.9H22.05C20.1167 36.9 18.5 36.25 17.2 34.95C15.9 33.65 15.25 32.0167 15.25 30.05C15.25 28.1167 15.9 26.5 17.2 25.2C18.5 23.9 20.1167 23.25 22.05 23.25H26C27.5 23.25 28.7583 22.7333 29.775 21.7C30.7917 20.6667 31.3 19.4 31.3 17.9C31.3 16.4333 30.7917 15.1833 29.775 14.15C28.7583 13.1167 27.5 12.6 26 12.6H14.65C14.5167 13.7667 13.9833 14.7417 13.05 15.525C12.1167 16.3083 11.05 16.7 9.85 16.7C8.51667 16.7 7.375 16.2333 6.425 15.3C5.475 14.3667 5 13.2167 5 11.85C5 10.5167 5.475 9.375 6.425 8.425C7.375 7.475 8.51667 7 9.85 7C11.05 7 12.1167 7.39167 13.05 8.175C13.9833 8.95833 14.5167 9.93333 14.65 11.1H26C27.9333 11.1 29.5583 11.75 30.875 13.05C32.1917 14.35 32.85 15.9833 32.85 17.95C32.85 19.8833 32.1917 21.5 30.875 22.8C29.5583 24.1 27.9333 24.75 26 24.75H22.05C20.5833 24.75 19.3333 25.2667 18.3 26.3C17.2667 27.3333 16.75 28.6 16.75 30.1C16.75 31.5667 17.2667 32.8167 18.3 33.85C19.3333 34.8833 20.5833 35.4 22.05 35.4H33.35C33.5167 34.2333 34.05 33.2583 34.95 32.475C35.85 31.6917 36.9167 31.3 38.15 31.3C39.4833 31.3 40.625 31.7667 41.575 32.7C42.525 33.6333 43 34.7833 43 36.15C43 37.4833 42.525 38.625 41.575 39.575C40.625 40.525 39.4833 41 38.15 41ZM9.85 15.15C10.7833 15.15 11.5667 14.8333 12.2 14.2C12.8333 13.5667 13.15 12.7833 13.15 11.85C13.15 10.9167 12.8333 10.1333 12.2 9.5C11.5667 8.86667 10.7833 8.55 9.85 8.55C8.91667 8.55 8.13333 8.86667 7.5 9.5C6.86667 10.1333 6.55 10.9167 6.55 11.85C6.55 12.7833 6.86667 13.5667 7.5 14.2C8.13333 14.8333 8.91667 15.15 9.85 15.15Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconBusinessCenter = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.25 13.8V10.75C18.25 9.98333 18.5167 9.33333 19.05 8.8C19.5833 8.26667 20.2333 8 21 8H27C27.7667 8 28.4167 8.26667 28.95 8.8C29.4833 9.33333 29.75 9.98333 29.75 10.75V13.8H39.25C40.0167 13.8 40.6667 14.0667 41.2 14.6C41.7333 15.1333 42 15.7833 42 16.55V37.25C42 38.0167 41.7333 38.6667 41.2 39.2C40.6667 39.7333 40.0167 40 39.25 40H8.75C7.98333 40 7.33333 39.7333 6.8 39.2C6.26667 38.6667 6 38.0167 6 37.25V16.55C6 15.7833 6.26667 15.1333 6.8 14.6C7.33333 14.0667 7.98333 13.8 8.75 13.8H18.25ZM19.75 13.8H28.25V10.75C28.25 10.45 28.1167 10.175 27.85 9.925C27.5833 9.675 27.3 9.55 27 9.55H21C20.7 9.55 20.4167 9.675 20.15 9.925C19.8833 10.175 19.75 10.45 19.75 10.75V13.8ZM40.45 28.75H27.3V31.3H20.7V28.75H7.55V37.25C7.55 37.55 7.675 37.825 7.925 38.075C8.175 38.325 8.45 38.45 8.75 38.45H39.25C39.55 38.45 39.825 38.325 40.075 38.075C40.325 37.825 40.45 37.55 40.45 37.25V28.75ZM22.25 29.75H25.8V26.2H22.25V29.75ZM7.55 27.2H20.7V24.7H27.3V27.2H40.45V16.55C40.45 16.25 40.325 15.9667 40.075 15.7C39.825 15.4333 39.55 15.3 39.25 15.3H8.75C8.45 15.3 8.175 15.4333 7.925 15.7C7.675 15.9667 7.55 16.25 7.55 16.55V27.2Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconStorefront = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.9996 21.8V38.25C40.9996 39.0167 40.7329 39.6667 40.1996 40.2C39.6663 40.7333 39.0163 41 38.2496 41H9.69961C8.93294 41 8.28294 40.7333 7.74961 40.2C7.21628 39.6667 6.94961 39.0167 6.94961 38.25V21.7C6.04961 21.0333 5.43294 20.1833 5.09961 19.15C4.76628 18.1167 4.76628 17.05 5.09961 15.95L7.09961 9.55C7.36628 8.68333 7.79128 8.04167 8.37461 7.625C8.95794 7.20833 9.66628 7 10.4996 7H37.2996C38.1329 7 38.8663 7.20833 39.4996 7.625C40.1329 8.04167 40.5663 8.65 40.7996 9.45L42.8996 15.95C43.2329 17.05 43.2246 18.125 42.8746 19.175C42.5246 20.225 41.8996 21.1 40.9996 21.8ZM28.3996 21.25C29.7329 21.25 30.7579 20.875 31.4746 20.125C32.1913 19.375 32.4996 18.6 32.3996 17.8L30.9996 8.55H24.7496V17.35C24.7496 18.3833 25.1079 19.2917 25.8246 20.075C26.5413 20.8583 27.3996 21.25 28.3996 21.25ZM19.2496 21.25C20.3829 21.25 21.3329 20.8667 22.0996 20.1C22.8663 19.3333 23.2496 18.4167 23.2496 17.35V8.55H16.9496L15.5496 17.95C15.4829 18.6167 15.7829 19.3333 16.4496 20.1C17.1163 20.8667 18.0496 21.25 19.2496 21.25ZM10.2996 21.25C11.2329 21.25 12.0496 20.9167 12.7496 20.25C13.4496 19.5833 13.8663 18.7833 13.9996 17.85L15.3496 8.55H10.2496C9.81628 8.55 9.46628 8.64167 9.19961 8.825C8.93294 9.00833 8.74961 9.3 8.64961 9.7L6.64961 16.3C6.24961 17.5 6.39961 18.625 7.09961 19.675C7.79961 20.725 8.86628 21.25 10.2996 21.25ZM37.6496 21.25C38.9163 21.25 39.9496 20.7583 40.7496 19.775C41.5496 18.7917 41.7329 17.6333 41.2996 16.3L39.2996 9.6C39.1996 9.23333 39.0079 8.96667 38.7246 8.8C38.4413 8.63333 38.0829 8.55 37.6496 8.55H32.6496L33.9496 17.85C34.1163 18.7833 34.5413 19.5833 35.2246 20.25C35.9079 20.9167 36.7163 21.25 37.6496 21.25ZM9.69961 39.45H38.2496C38.5829 39.45 38.8663 39.3333 39.0996 39.1C39.3329 38.8667 39.4496 38.5833 39.4496 38.25V22.55C39.2496 22.6167 38.9913 22.6667 38.6746 22.7C38.3579 22.7333 38.0163 22.75 37.6496 22.75C36.8163 22.75 36.0413 22.5667 35.3246 22.2C34.6079 21.8333 33.9163 21.25 33.2496 20.45C32.7496 21.1167 32.1163 21.6667 31.3496 22.1C30.5829 22.5333 29.6163 22.75 28.4496 22.75C27.6163 22.75 26.8496 22.575 26.1496 22.225C25.4496 21.875 24.7329 21.3167 23.9996 20.55C23.3329 21.2833 22.5913 21.8333 21.7746 22.2C20.9579 22.5667 20.1663 22.75 19.3996 22.75C18.4996 22.75 17.6496 22.5917 16.8496 22.275C16.0496 21.9583 15.3663 21.35 14.7996 20.45C13.7663 21.4167 12.8663 22.0417 12.0996 22.325C11.3329 22.6083 10.7329 22.75 10.2996 22.75C9.96628 22.75 9.64128 22.7333 9.32461 22.7C9.00794 22.6667 8.73294 22.6167 8.49961 22.55V38.25C8.49961 38.5833 8.61628 38.8667 8.84961 39.1C9.08294 39.3333 9.36628 39.45 9.69961 39.45ZM38.2496 39.45H9.69961H38.2496Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconShoppingBag = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 42C11.9833 42 11.3333 41.7333 10.8 41.2C10.2667 40.6667 10 40.0167 10 39.25V16.75C10 15.9833 10.2667 15.3333 10.8 14.8C11.3333 14.2667 11.9833 14 12.75 14H17.25V12.75C17.25 10.8833 17.9 9.29167 19.2 7.975C20.5 6.65833 22.1 6 24 6C25.9 6 27.5 6.65833 28.8 7.975C30.1 9.29167 30.75 10.8833 30.75 12.75V14H35.25C36.0167 14 36.6667 14.2667 37.2 14.8C37.7333 15.3333 38 15.9833 38 16.75V39.25C38 40.0167 37.7333 40.6667 37.2 41.2C36.6667 41.7333 36.0167 42 35.25 42H12.75ZM12.75 40.45H35.25C35.55 40.45 35.825 40.325 36.075 40.075C36.325 39.825 36.45 39.55 36.45 39.25V16.75C36.45 16.45 36.325 16.175 36.075 15.925C35.825 15.675 35.55 15.55 35.25 15.55H30.75V20.75C30.75 20.9833 30.675 21.175 30.525 21.325C30.375 21.475 30.2 21.55 30 21.55C29.7667 21.55 29.5833 21.475 29.45 21.325C29.3167 21.175 29.25 20.9833 29.25 20.75V15.55H18.75V20.75C18.75 20.9833 18.675 21.175 18.525 21.325C18.375 21.475 18.2 21.55 18 21.55C17.7667 21.55 17.5833 21.475 17.45 21.325C17.3167 21.175 17.25 20.9833 17.25 20.75V15.55H12.75C12.45 15.55 12.175 15.675 11.925 15.925C11.675 16.175 11.55 16.45 11.55 16.75V39.25C11.55 39.55 11.675 39.825 11.925 40.075C12.175 40.325 12.45 40.45 12.75 40.45ZM18.75 14H29.25V12.75C29.25 11.2833 28.7417 10.05 27.725 9.05C26.7083 8.05 25.4667 7.55 24 7.55C22.5333 7.55 21.2917 8.05 20.275 9.05C19.2583 10.05 18.75 11.2833 18.75 12.75V14ZM11.55 40.45V15.55V40.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Construction
const SrCompIconHandyman = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.1496 41.9502C36.9496 41.9502 36.7746 41.9169 36.6246 41.8502C36.4746 41.7835 36.3329 41.6835 36.1996 41.5502L25.3496 30.7502V28.7502L28.6496 25.5002H30.6496L41.4496 36.3002C41.5829 36.4669 41.6746 36.6335 41.7246 36.8002C41.7746 36.9669 41.7996 37.1502 41.7996 37.3502C41.7996 37.5502 41.7746 37.7252 41.7246 37.8752C41.6746 38.0252 41.5663 38.1669 41.3996 38.3002L38.1496 41.5502C37.9829 41.6835 37.8246 41.7835 37.6746 41.8502C37.5246 41.9169 37.3496 41.9502 37.1496 41.9502ZM37.1496 40.4002L40.2496 37.3002L29.8996 26.9002L26.7996 30.0002L37.1496 40.4002ZM10.7996 41.9502C10.5996 41.9502 10.4163 41.9169 10.2496 41.8502C10.0829 41.7835 9.93294 41.6835 9.79961 41.5502L6.49961 38.2502C6.36628 38.1169 6.26628 37.9752 6.19961 37.8252C6.13294 37.6752 6.09961 37.5002 6.09961 37.3002C6.09961 37.1002 6.13294 36.9169 6.19961 36.7502C6.26628 36.5835 6.36628 36.4335 6.49961 36.3002L17.0996 25.7002H21.2496L22.8996 24.0502L14.1996 15.3502H11.3496L6.19961 10.2002L10.1496 6.2502L15.2996 11.4002V14.2502L23.9996 22.9502L30.3496 16.6002L26.0996 12.3502L28.3496 10.1002H23.8496L23.2496 9.5502L28.5996 4.2002L29.1496 4.7502V9.3002L31.3996 7.0502L39.9996 15.5502C40.4329 15.9835 40.7663 16.4835 40.9996 17.0502C41.2329 17.6169 41.3496 18.2335 41.3496 18.9002C41.3496 19.3335 41.2913 19.7419 41.1746 20.1252C41.0579 20.5085 40.8996 20.9169 40.6996 21.3502L36.5996 17.2502L33.7996 20.0502L31.3996 17.7002L22.2996 26.8002V31.0502L11.7496 41.5502C11.6163 41.6835 11.4746 41.7835 11.3246 41.8502C11.1746 41.9169 10.9996 41.9502 10.7996 41.9502ZM10.7996 40.3502L21.3496 29.8002L18.1996 26.7002L7.69961 37.2502L10.7996 40.3502Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconEngineering = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.0496 18.4504L37.8496 17.0504C37.4829 16.9504 37.0579 16.7587 36.5746 16.4754C36.0913 16.1921 35.7329 15.8837 35.4996 15.5504L33.9496 16.2504L33.2496 15.0504L34.6496 14.1004C34.5829 13.9337 34.5246 13.7254 34.4746 13.4754C34.4246 13.2254 34.3996 13.0004 34.3996 12.8004C34.3996 12.6004 34.4246 12.3754 34.4746 12.1254C34.5246 11.8754 34.5829 11.6504 34.6496 11.4504L33.2496 10.5504L33.9496 9.35039L35.4996 10.0004C35.7329 9.66706 36.0913 9.35872 36.5746 9.07539C37.0579 8.79206 37.4829 8.61706 37.8496 8.55039L38.0496 7.15039H39.3996L39.5496 8.55039C39.9496 8.61706 40.3829 8.79206 40.8496 9.07539C41.3163 9.35872 41.6829 9.66706 41.9496 10.0004L43.4496 9.35039L44.1496 10.5504L42.7996 11.4504C42.8663 11.6504 42.9246 11.8754 42.9746 12.1254C43.0246 12.3754 43.0496 12.6004 43.0496 12.8004C43.0496 13.0004 43.0246 13.2254 42.9746 13.4754C42.9246 13.7254 42.8663 13.9337 42.7996 14.1004L44.1496 15.0504L43.4496 16.2504L41.9496 15.5504C41.6829 15.8837 41.3163 16.1921 40.8496 16.4754C40.3829 16.7587 39.9496 16.9504 39.5496 17.0504L39.3996 18.4504H38.0496ZM38.7496 15.7004C39.5829 15.7004 40.2746 15.4254 40.8246 14.8754C41.3746 14.3254 41.6496 13.6337 41.6496 12.8004C41.6496 11.9671 41.3746 11.2754 40.8246 10.7254C40.2746 10.1754 39.5829 9.90039 38.7496 9.90039C37.8829 9.90039 37.1746 10.1754 36.6246 10.7254C36.0746 11.2754 35.7996 11.9671 35.7996 12.8004C35.7996 13.6337 36.0746 14.3254 36.6246 14.8754C37.1746 15.4254 37.8829 15.7004 38.7496 15.7004ZM32.8496 29.7004L32.7996 28.2504C32.5663 28.1837 32.2913 28.0504 31.9746 27.8504C31.6579 27.6504 31.3996 27.4671 31.1996 27.3004L29.8996 27.9504L29.0996 26.7004L30.3496 25.9004C30.2829 25.7337 30.2413 25.5754 30.2246 25.4254C30.2079 25.2754 30.1996 25.1337 30.1996 25.0004C30.1996 24.8337 30.2079 24.6837 30.2246 24.5504C30.2413 24.4171 30.2829 24.2671 30.3496 24.1004L29.0996 23.2504L29.8996 22.0004L31.1996 22.6504C31.4329 22.4504 31.6996 22.2671 31.9996 22.1004C32.2996 21.9337 32.5663 21.7837 32.7996 21.6504L32.8496 20.3004H34.3996L34.4496 21.6504C34.7163 21.7837 34.9996 21.9337 35.2996 22.1004C35.5996 22.2671 35.8663 22.4504 36.0996 22.6504L37.3496 22.0004L38.1496 23.2504L36.8996 24.1004C36.9663 24.2671 36.9996 24.4171 36.9996 24.5504V25.4254C36.9996 25.5754 36.9663 25.7337 36.8996 25.9004L38.1496 26.7004L37.3496 27.9504L36.0996 27.3004C35.8996 27.4671 35.6413 27.6504 35.3246 27.8504C35.0079 28.0504 34.7163 28.1837 34.4496 28.2504L34.3996 29.7004H32.8496ZM33.5996 26.9504C34.1663 26.9504 34.6496 26.7671 35.0496 26.4004C35.4496 26.0337 35.6496 25.5671 35.6496 25.0004C35.6496 24.4337 35.4496 23.9504 35.0496 23.5504C34.6496 23.1504 34.1663 22.9504 33.5996 22.9504C33.0663 22.9504 32.6079 23.1504 32.2246 23.5504C31.8413 23.9504 31.6496 24.4337 31.6496 25.0004C31.6496 25.5671 31.8413 26.0337 32.2246 26.4004C32.6079 26.7671 33.0663 26.9504 33.5996 26.9504ZM17.7496 26.2504C16.0496 26.2504 14.6663 25.7171 13.5996 24.6504C12.5329 23.5837 11.9996 22.1171 11.9996 20.2504H11.5496C11.3496 20.2504 11.1746 20.1754 11.0246 20.0254C10.8746 19.8754 10.7996 19.7004 10.7996 19.5004C10.7996 19.3004 10.8746 19.1171 11.0246 18.9504C11.1746 18.7837 11.3496 18.7004 11.5496 18.7004H11.9996C11.9996 17.8004 12.1829 16.9587 12.5496 16.1754C12.9163 15.3921 13.4829 14.6504 14.2496 13.9504V15.8504C14.2496 16.0171 14.3163 16.1671 14.4496 16.3004C14.5829 16.4337 14.7329 16.5004 14.8996 16.5004C15.0996 16.5004 15.2579 16.4337 15.3746 16.3004C15.4913 16.1671 15.5496 16.0171 15.5496 15.8504V13.3004C15.8163 13.2004 16.1579 13.1087 16.5746 13.0254C16.9913 12.9421 17.3829 12.9004 17.7496 12.9004C18.1496 12.9004 18.5579 12.9421 18.9746 13.0254C19.3913 13.1087 19.7329 13.2004 19.9996 13.3004V15.8504C19.9996 16.0171 20.0579 16.1671 20.1746 16.3004C20.2913 16.4337 20.4329 16.5004 20.5996 16.5004C20.7663 16.5004 20.9246 16.4337 21.0746 16.3004C21.2246 16.1671 21.2996 16.0171 21.2996 15.8504V13.9504C22.0663 14.6504 22.6163 15.3921 22.9496 16.1754C23.2829 16.9587 23.4663 17.8004 23.4996 18.7004H23.9496C24.1496 18.7004 24.3246 18.7837 24.4746 18.9504C24.6246 19.1171 24.6996 19.3004 24.6996 19.5004C24.6996 19.7004 24.6246 19.8754 24.4746 20.0254C24.3246 20.1754 24.1496 20.2504 23.9496 20.2504H23.4996C23.4996 22.1171 22.9663 23.5837 21.8996 24.6504C20.8329 25.7171 19.4496 26.2504 17.7496 26.2504ZM17.7496 24.7004C19.0163 24.7004 20.0413 24.3087 20.8246 23.5254C21.6079 22.7421 21.9996 21.7337 21.9996 20.5004H13.4996C13.4996 21.7337 13.8913 22.7421 14.6746 23.5254C15.4579 24.3087 16.4829 24.7004 17.7496 24.7004ZM3.84961 40.4004V37.5504C3.84961 36.6837 4.06628 35.9587 4.49961 35.3754C4.93294 34.7921 5.56628 34.2837 6.39961 33.8504C8.09961 33.0504 9.91628 32.4004 11.8496 31.9004C13.7829 31.4004 15.7496 31.1504 17.7496 31.1504C19.7163 31.1504 21.6746 31.4004 23.6246 31.9004C25.5746 32.4004 27.3829 33.0504 29.0496 33.8504C29.8829 34.2837 30.5246 34.7921 30.9746 35.3754C31.4246 35.9587 31.6496 36.6837 31.6496 37.5504V40.4004H3.84961ZM5.34961 38.8504H30.0996V37.5504C30.0996 36.9504 29.9246 36.4671 29.5746 36.1004C29.2246 35.7337 28.7996 35.4337 28.2996 35.2004C26.9329 34.5671 25.3329 33.9921 23.4996 33.4754C21.6663 32.9587 19.7496 32.7004 17.7496 32.7004C15.7496 32.7004 13.8246 32.9587 11.9746 33.4754C10.1246 33.9921 8.53294 34.5671 7.19961 35.2004C6.69961 35.4337 6.26628 35.7337 5.89961 36.1004C5.53294 36.4671 5.34961 36.9504 5.34961 37.5504V38.8504Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSquareFoot = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.3496 38.8998H12.6996C11.6329 38.8998 10.7663 38.5665 10.0996 37.8998C9.43294 37.2331 9.09961 36.3665 9.09961 35.2998V15.4498C9.09961 14.4831 9.45794 13.8581 10.1746 13.5748C10.8913 13.2915 11.5663 13.4498 12.1996 14.0498L14.1496 15.9998L12.8496 17.2498L13.7496 18.1998L15.0496 16.8998L19.6496 21.4998L18.3496 22.7998L19.2496 23.6498L20.4996 22.3998L25.2996 27.1498L23.9996 28.4498L24.9496 29.3498L26.1996 28.0998L30.7996 32.6498L29.4996 33.8998L30.4496 34.8498L31.6996 33.5998L33.6996 35.5998C34.4996 36.3665 34.7413 37.1081 34.4246 37.8248C34.1079 38.5415 33.4163 38.8998 32.3496 38.8998ZM11.0996 17.2998V35.6998C11.0996 36.0665 11.2079 36.3581 11.4246 36.5748C11.6413 36.7915 11.9329 36.8998 12.2996 36.8998H30.6996L11.0996 17.2998Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconCottage = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0004 40V21.1L5.85039 24.3L4.90039 23.1L10.0004 19.2V14.15H11.5504V18L24.0004 8.5L43.1004 23.1L42.1504 24.3L38.0004 21.1V40H10.0004ZM11.5504 38.45H21.4504V28.9H26.5504V38.45H36.4504V19.95L24.0004 10.45L11.5504 19.95V38.45ZM10.0004 11.55C10.0004 10.3833 10.3671 9.4 11.1004 8.6C11.8337 7.8 12.8837 7.4 14.2504 7.4C15.1837 7.4 15.8587 7.14167 16.2754 6.625C16.6921 6.10833 16.9004 5.48333 16.9004 4.75H18.4504C18.4504 5.91667 18.0921 6.9 17.3754 7.7C16.6587 8.5 15.6171 8.9 14.2504 8.9C13.3171 8.9 12.6337 9.15833 12.2004 9.675C11.7671 10.1917 11.5504 10.8167 11.5504 11.55H10.0004ZM11.5504 38.45H36.4504H11.5504Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconHolidayVillage = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 37.9996V20.8496L18.75 10.8496L28.75 20.8496V37.9996H8.75ZM10.3 36.4496H17.45V31.8496H20.1V36.4496H27.25V21.4996L18.75 12.9996L10.3 21.4996V36.4496ZM17.45 25.2996V22.6996H20.1V25.2996H17.45ZM32.45 38.0496V19.4996L23.8 10.8496H26.2L34 18.6496V38.0496H32.45ZM37.7 38.0496V17.2996L31.2 10.8496H33.65L39.25 16.4996V38.0496H37.7ZM10.3 36.4496H27.25H10.3Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconChair = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.9 38.7002C9.7 38.7002 9.525 38.6252 9.375 38.4752C9.225 38.3252 9.15 38.1335 9.15 37.9002V35.8502H7.75C6.68333 35.8502 5.79167 35.4919 5.075 34.7752C4.35833 34.0585 4 33.1669 4 32.1002V21.1002C4 19.8002 4.4 18.8669 5.2 18.3002C6 17.7335 6.8 17.4502 7.6 17.4502V14.1002C7.6 13.0335 7.95 12.1585 8.65 11.4752C9.35 10.7919 10.2167 10.4502 11.25 10.4502H36.75C37.8167 10.4502 38.6917 10.7919 39.375 11.4752C40.0583 12.1585 40.4 13.0335 40.4 14.1002V17.4502C41.3333 17.4502 42.1667 17.7502 42.9 18.3502C43.6333 18.9502 44 19.8669 44 21.1002V32.1002C44 33.1669 43.6417 34.0585 42.925 34.7752C42.2083 35.4919 41.3167 35.8502 40.25 35.8502H38.85V37.9002C38.85 38.1335 38.7917 38.3252 38.675 38.4752C38.5583 38.6252 38.3833 38.7002 38.15 38.7002C37.95 38.7002 37.775 38.6252 37.625 38.4752C37.475 38.3252 37.4 38.1335 37.4 37.9002V35.8502H10.7V37.9002C10.7 38.1335 10.625 38.3252 10.475 38.4752C10.325 38.6252 10.1333 38.7002 9.9 38.7002ZM7.75 34.3002H40.25C40.85 34.3002 41.3667 34.0835 41.8 33.6502C42.2333 33.2169 42.45 32.7002 42.45 32.1002V21.1002C42.45 20.5002 42.25 20.0002 41.85 19.6002C41.45 19.2002 40.95 19.0002 40.35 19.0002C39.75 19.0002 39.2583 19.2002 38.875 19.6002C38.4917 20.0002 38.3 20.5002 38.3 21.1002V28.4502H9.7V21.1002C9.7 20.5002 9.50833 20.0002 9.125 19.6002C8.74167 19.2002 8.25 19.0002 7.65 19.0002C7.05 19.0002 6.55 19.2002 6.15 19.6002C5.75 20.0002 5.55 20.5002 5.55 21.1002V32.1002C5.55 32.7002 5.76667 33.2169 6.2 33.6502C6.63333 34.0835 7.15 34.3002 7.75 34.3002ZM11.25 26.9002H36.75V21.1002C36.75 20.3002 36.95 19.6169 37.35 19.0502C37.75 18.4835 38.25 18.0502 38.85 17.7502V14.1002C38.85 13.4669 38.65 12.9585 38.25 12.5752C37.85 12.1919 37.35 12.0002 36.75 12.0002H11.25C10.65 12.0002 10.15 12.1919 9.75 12.5752C9.35 12.9585 9.15 13.4669 9.15 14.1002V17.7502C9.75 18.0502 10.25 18.4835 10.65 19.0502C11.05 19.6169 11.25 20.3002 11.25 21.1002V26.9002Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconGrass = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.09961 36.9V35.4H17.0496C16.4496 32.9 15.2329 30.725 13.3996 28.875C11.5663 27.025 9.46628 25.8 7.09961 25.2C7.63294 25.0667 8.17461 24.9583 8.72461 24.875C9.27461 24.7917 9.84961 24.75 10.4496 24.75C14.2163 24.75 17.4163 25.8333 20.0496 28C22.6829 30.1667 23.9996 33.1333 23.9996 36.9H7.09961ZM25.5496 36.9C25.5496 36.2333 25.4996 35.6083 25.3996 35.025C25.2996 34.4417 25.1663 33.8333 24.9996 33.2C26.0663 30.7667 27.6913 28.75 29.8746 27.15C32.0579 25.55 34.6163 24.75 37.5496 24.75C38.1496 24.75 38.7246 24.7917 39.2746 24.875C39.8246 24.9583 40.3663 25.0667 40.8996 25.2C38.5329 25.8 36.4246 27.0333 34.5746 28.9C32.7246 30.7667 31.5163 32.9333 30.9496 35.4H40.8996V36.9H25.5496ZM24.4996 31.65C24.0996 29.3167 24.1329 27.15 24.5996 25.15C25.0663 23.15 25.8829 21.3917 27.0496 19.875C28.2163 18.3583 29.6663 17.1417 31.3996 16.225C33.1329 15.3083 35.0163 14.7833 37.0496 14.65C34.9496 16.0167 33.2663 17.6583 31.9996 19.575C30.7329 21.4917 29.9496 23.4333 29.6496 25.4C28.5829 25.9667 27.5329 26.8667 26.4996 28.1C25.4663 29.3333 24.7996 30.5167 24.4996 31.65ZM22.7996 28.85C22.2663 28.2167 21.6079 27.55 20.8246 26.85C20.0413 26.15 19.2996 25.6333 18.5996 25.3C18.6996 24.9333 18.7746 24.4917 18.8246 23.975C18.8746 23.4583 18.8996 22.9833 18.8996 22.55C18.8996 20.4167 18.5579 18.3917 17.8746 16.475C17.1913 14.5583 16.2329 12.8167 14.9996 11.25C17.0996 12.0833 18.9829 13.4583 20.6496 15.375C22.3163 17.2917 23.4329 19.65 23.9996 22.45C23.5996 23.3833 23.2996 24.4333 23.0996 25.6C22.8996 26.7667 22.7996 27.85 22.7996 28.85Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Customer support
const SrCompIconSupport = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.55 40.9249V39.375H37.25C37.5833 39.375 37.8667 39.2583 38.1 39.025C38.3333 38.7916 38.45 38.5083 38.45 38.175V23.025C38.45 21.0916 38.0583 19.2583 37.275 17.525C36.4917 15.7916 35.4417 14.2666 34.125 12.95C32.8083 11.6333 31.275 10.5916 29.525 9.82495C27.775 9.05828 25.9333 8.67495 24 8.67495C22.0667 8.67495 20.225 9.05828 18.475 9.82495C16.725 10.5916 15.1917 11.6333 13.875 12.95C12.5583 14.2666 11.5083 15.7916 10.725 17.525C9.94167 19.2583 9.55 21.0916 9.55 23.025V35.075H9C8.16667 35.075 7.45833 34.7833 6.875 34.2C6.29167 33.6166 6 32.9083 6 32.075V28.075C6 27.5083 6.18333 26.9833 6.55 26.5C6.91667 26.0166 7.4 25.5916 8 25.225L8.05 22.575C8.11667 20.4083 8.58333 18.3833 9.45 16.5C10.3167 14.6166 11.475 12.975 12.925 11.575C14.375 10.175 16.05 9.07495 17.95 8.27495C19.85 7.47495 21.8667 7.07495 24 7.07495C26.1333 7.07495 28.1583 7.46662 30.075 8.24995C31.9917 9.03328 33.6667 10.125 35.1 11.525C36.5333 12.925 37.6833 14.5666 38.55 16.45C39.4167 18.3333 39.8833 20.375 39.95 22.575L40 25.125C40.6 25.425 41.0833 25.8083 41.45 26.275C41.8167 26.7416 42 27.2416 42 27.775V32.375C42 32.9083 41.8167 33.4083 41.45 33.875C41.0833 34.3416 40.6 34.725 40 35.025V38.175C40 38.9083 39.725 39.55 39.175 40.1C38.625 40.65 37.9833 40.9249 37.25 40.9249H23.55ZM18.75 27.025C18.4167 27.025 18.1167 26.8916 17.85 26.625C17.5833 26.3583 17.45 26.0416 17.45 25.675C17.45 25.3416 17.5833 25.0416 17.85 24.775C18.1167 24.5083 18.4333 24.375 18.8 24.375C19.1333 24.375 19.4333 24.5083 19.7 24.775C19.9667 25.0416 20.1 25.3416 20.1 25.675C20.1 26.0416 19.9667 26.3583 19.7 26.625C19.4333 26.8916 19.1167 27.025 18.75 27.025ZM29.25 27.025C28.8833 27.025 28.5667 26.8916 28.3 26.625C28.0333 26.3583 27.9 26.0416 27.9 25.675C27.9 25.3416 28.0333 25.0416 28.3 24.775C28.5667 24.5083 28.8833 24.375 29.25 24.375C29.5833 24.375 29.8833 24.5083 30.15 24.775C30.4167 25.0416 30.55 25.3416 30.55 25.675C30.55 26.0416 30.4167 26.3583 30.15 26.625C29.8833 26.8916 29.5833 27.025 29.25 27.025ZM13.45 23.875C13.3167 22.1416 13.55 20.5583 14.15 19.125C14.75 17.6916 15.5583 16.4833 16.575 15.5C17.5917 14.5166 18.7667 13.7583 20.1 13.225C21.4333 12.6916 22.7667 12.425 24.1 12.425C26.7667 12.425 29.0417 13.275 30.925 14.975C32.8083 16.675 33.9667 18.7916 34.4 21.325C31.6333 21.2916 29.1667 20.5416 27 19.075C24.8333 17.6083 23.1667 15.725 22 13.425C21.5333 15.7916 20.5333 17.9 19 19.75C17.4667 21.6 15.6167 22.975 13.45 23.875V23.875Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconLiveHelp = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 42.5751L18.85 37.425H10.75C9.98333 37.425 9.33333 37.1584 8.8 36.625C8.26667 36.0917 8 35.4417 8 34.675V8.17505C8 7.40838 8.26667 6.75838 8.8 6.22505C9.33333 5.69172 9.98333 5.42505 10.75 5.42505H37.25C38.0167 5.42505 38.6667 5.69172 39.2 6.22505C39.7333 6.75838 40 7.40838 40 8.17505V34.675C40 35.4417 39.7333 36.0917 39.2 36.625C38.6667 37.1584 38.0167 37.425 37.25 37.425H29.15L24 42.5751ZM10.75 35.875H19.5L24 40.375L28.5 35.875H37.25C37.5833 35.875 37.8667 35.7584 38.1 35.525C38.3333 35.2917 38.45 35.0084 38.45 34.675V8.17505C38.45 7.84172 38.3333 7.55838 38.1 7.32505C37.8667 7.09172 37.5833 6.97505 37.25 6.97505H10.75C10.4167 6.97505 10.1333 7.09172 9.9 7.32505C9.66667 7.55838 9.55 7.84172 9.55 8.17505V34.675C9.55 35.0084 9.66667 35.2917 9.9 35.525C10.1333 35.7584 10.4167 35.875 10.75 35.875ZM24.05 31.375C24.3833 31.375 24.6833 31.25 24.95 31C25.2167 30.75 25.35 30.4417 25.35 30.075C25.35 29.7417 25.225 29.4417 24.975 29.175C24.725 28.9084 24.4167 28.775 24.05 28.775C23.6833 28.775 23.3667 28.9084 23.1 29.175C22.8333 29.4417 22.7 29.7417 22.7 30.075C22.7 30.4417 22.8333 30.75 23.1 31C23.3667 31.25 23.6833 31.375 24.05 31.375ZM24.65 24.875C24.65 24.075 24.8167 23.3917 25.15 22.825C25.4833 22.2584 26.0167 21.5917 26.75 20.825C27.7167 19.8584 28.4 19.0084 28.8 18.275C29.2 17.5417 29.4 16.7417 29.4 15.875C29.4 14.3084 28.8833 13.0667 27.85 12.15C26.8167 11.2334 25.55 10.775 24.05 10.775C22.6833 10.775 21.5 11.125 20.5 11.825C19.5 12.525 18.75 13.375 18.25 14.375L19.8 15.075C20.2333 14.275 20.7667 13.625 21.4 13.125C22.0333 12.625 22.9 12.375 24 12.375C25.3333 12.375 26.3083 12.7334 26.925 13.45C27.5417 14.1667 27.85 14.9917 27.85 15.925C27.85 16.625 27.6667 17.25 27.3 17.8C26.9333 18.35 26.4167 18.9417 25.75 19.575C24.6167 20.675 23.8917 21.6084 23.575 22.375C23.2583 23.1417 23.1 23.975 23.1 24.875H24.65Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Design
const SrCompIconDesignServices = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.7502 40.2502V34.2502L17.1002 24.8502L7.4502 15.1002C7.28353 14.9669 7.15853 14.8002 7.0752 14.6002C6.99186 14.4002 6.9502 14.2002 6.9502 14.0002C6.9502 13.8335 6.99186 13.6502 7.0752 13.4502C7.15853 13.2502 7.28353 13.0669 7.4502 12.9002L12.1502 8.2002C12.2835 8.06686 12.4502 7.9502 12.6502 7.8502C12.8502 7.7502 13.0502 7.7002 13.2502 7.7002C13.4169 7.7002 13.6085 7.7502 13.8252 7.8502C14.0419 7.9502 14.2169 8.06686 14.3502 8.2002L24.1002 17.9502L33.4502 8.6502C33.5835 8.48353 33.7419 8.3752 33.9252 8.3252C34.1085 8.2752 34.2835 8.2502 34.4502 8.2502C34.6502 8.2502 34.8252 8.2752 34.9752 8.3252C35.1252 8.3752 35.2669 8.48353 35.4002 8.6502L39.3502 12.6502C39.5169 12.7835 39.6252 12.9252 39.6752 13.0752C39.7252 13.2252 39.7502 13.4002 39.7502 13.6002C39.7502 13.8002 39.7252 13.9752 39.6752 14.1252C39.6252 14.2752 39.5169 14.4169 39.3502 14.5502L30.1002 23.9002L39.8502 33.6502C39.9835 33.7835 40.0919 33.9585 40.1752 34.1752C40.2585 34.3919 40.3002 34.5835 40.3002 34.7502C40.3002 34.9502 40.2585 35.1419 40.1752 35.3252C40.0919 35.5085 39.9835 35.6835 39.8502 35.8502L35.1002 40.5502C34.9669 40.6835 34.8002 40.7919 34.6002 40.8752C34.4002 40.9585 34.2002 41.0002 34.0002 41.0002C33.8002 41.0002 33.6002 40.9585 33.4002 40.8752C33.2002 40.7919 33.0502 40.6835 32.9502 40.5502L23.1502 30.8502L13.7002 40.2502H7.7502ZM18.2502 23.7502L23.0002 19.0002L18.6002 14.6002L16.2502 17.0002L15.1502 15.9002L17.5002 13.5002L13.2502 9.2502L8.5002 14.0002L18.2502 23.7502ZM33.9502 39.5002L38.7002 34.7002L34.4502 30.4502L32.0502 32.8002L30.9502 31.7002L33.3502 29.3502L28.9502 24.9502L24.2002 29.7502L33.9502 39.5002ZM9.2502 38.7002H13.0502L33.2002 18.5002L29.4502 14.7502L9.2502 34.9002V38.7002ZM34.3002 17.4502L38.1502 13.6002L34.4002 9.8502L30.5502 13.7002L34.3002 17.4502Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconPalette = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9 42C21.4667 42 19.1583 41.525 16.975 40.575C14.7917 39.625 12.8917 38.3417 11.275 36.725C9.65833 35.1083 8.375 33.2 7.425 31C6.475 28.8 6 26.4667 6 24C6 21.4667 6.48333 19.1083 7.45 16.925C8.41667 14.7417 9.73333 12.8417 11.4 11.225C13.0667 9.60833 15.025 8.33333 17.275 7.4C19.525 6.46667 21.9333 6 24.5 6C26.8333 6 29.05 6.38333 31.15 7.15C33.25 7.91667 35.1 8.99167 36.7 10.375C38.3 11.7583 39.5833 13.4083 40.55 15.325C41.5167 17.2417 42 19.3167 42 21.55C42 24.55 41.1583 26.9917 39.475 28.875C37.7917 30.7583 35.3833 31.7 32.25 31.7H28.65C27.6833 31.7 26.8417 32.05 26.125 32.75C25.4083 33.45 25.05 34.3 25.05 35.3C25.05 36.3667 25.3 37.1667 25.8 37.7C26.3 38.2333 26.55 38.85 26.55 39.55C26.55 40.3167 26.325 40.9167 25.875 41.35C25.425 41.7833 24.7667 42 23.9 42ZM12.7 24.7C13.1667 24.7 13.575 24.5167 13.925 24.15C14.275 23.7833 14.45 23.3667 14.45 22.9C14.45 22.4333 14.275 22.025 13.925 21.675C13.575 21.325 13.1667 21.15 12.7 21.15C12.2333 21.15 11.825 21.325 11.475 21.675C11.125 22.025 10.95 22.4333 10.95 22.9C10.95 23.3667 11.125 23.7833 11.475 24.15C11.825 24.5167 12.2333 24.7 12.7 24.7ZM18.85 16.45C19.3167 16.45 19.725 16.275 20.075 15.925C20.425 15.575 20.6 15.1667 20.6 14.7C20.6 14.2333 20.425 13.8167 20.075 13.45C19.725 13.0833 19.3167 12.9 18.85 12.9C18.3833 12.9 17.9667 13.0833 17.6 13.45C17.2333 13.8167 17.05 14.2333 17.05 14.7C17.05 15.1667 17.2333 15.575 17.6 15.925C17.9667 16.275 18.3833 16.45 18.85 16.45ZM29.15 16.45C29.6167 16.45 30.0333 16.275 30.4 15.925C30.7667 15.575 30.95 15.1667 30.95 14.7C30.95 14.2333 30.7667 13.8167 30.4 13.45C30.0333 13.0833 29.6167 12.9 29.15 12.9C28.6833 12.9 28.275 13.0833 27.925 13.45C27.575 13.8167 27.4 14.2333 27.4 14.7C27.4 15.1667 27.575 15.575 27.925 15.925C28.275 16.275 28.6833 16.45 29.15 16.45ZM35.4 24.7C35.8667 24.7 36.275 24.5167 36.625 24.15C36.975 23.7833 37.15 23.3667 37.15 22.9C37.15 22.4333 36.975 22.025 36.625 21.675C36.275 21.325 35.8667 21.15 35.4 21.15C34.9333 21.15 34.525 21.325 34.175 21.675C33.825 22.025 33.65 22.4333 33.65 22.9C33.65 23.3667 33.825 23.7833 34.175 24.15C34.525 24.5167 34.9333 24.7 35.4 24.7ZM23.9 40.45C24.2667 40.45 24.5417 40.375 24.725 40.225C24.9083 40.075 25 39.85 25 39.55C25 39.0833 24.75 38.6333 24.25 38.2C23.75 37.7667 23.5 36.9333 23.5 35.7C23.5 34.1667 23.9917 32.8583 24.975 31.775C25.9583 30.6917 27.1833 30.15 28.65 30.15H32.25C34.8833 30.15 36.9083 29.3667 38.325 27.8C39.7417 26.2333 40.45 24.15 40.45 21.55C40.45 17.35 38.8333 13.9667 35.6 11.4C32.3667 8.83333 28.6667 7.55 24.5 7.55C19.7333 7.55 15.7167 9.14167 12.45 12.325C9.18333 15.5083 7.55 19.4 7.55 24C7.55 28.5333 9.15 32.4083 12.35 35.625C15.55 38.8417 19.4 40.45 23.9 40.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconShapeLine = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20C9.8 20 7.91667 19.2167 6.35 17.65C4.78333 16.0833 4 14.2 4 12C4 9.76667 4.78333 7.875 6.35 6.325C7.91667 4.775 9.8 4 12 4C14.2333 4 16.125 4.775 17.675 6.325C19.225 7.875 20 9.76667 20 12C20 14.2 19.225 16.0833 17.675 17.65C16.125 19.2167 14.2333 20 12 20ZM12 18.45C13.8333 18.45 15.3667 17.825 16.6 16.575C17.8333 15.325 18.45 13.8 18.45 12C18.45 10.1667 17.8333 8.63333 16.6 7.4C15.3667 6.16667 13.8333 5.55 12 5.55C10.2 5.55 8.675 6.16667 7.425 7.4C6.175 8.63333 5.55 10.1667 5.55 12C5.55 13.8 6.175 15.325 7.425 16.575C8.675 17.825 10.2 18.45 12 18.45ZM32.75 44C32.0167 44 31.375 43.725 30.825 43.175C30.275 42.625 30 41.9833 30 41.25V32.75C30 32.0167 30.275 31.375 30.825 30.825C31.375 30.275 32.0167 30 32.75 30H41.25C41.9833 30 42.625 30.275 43.175 30.825C43.725 31.375 44 32.0167 44 32.75V41.25C44 41.9833 43.725 42.625 43.175 43.175C42.625 43.725 41.9833 44 41.25 44H32.75ZM32.75 42.45H41.25C41.5833 42.45 41.8667 42.3333 42.1 42.1C42.3333 41.8667 42.45 41.5833 42.45 41.25V32.75C42.45 32.4167 42.3333 32.1333 42.1 31.9C41.8667 31.6667 41.5833 31.55 41.25 31.55H32.75C32.4167 31.55 32.1333 31.6667 31.9 31.9C31.6667 32.1333 31.55 32.4167 31.55 32.75V41.25C31.55 41.5833 31.6667 41.8667 31.9 42.1C32.1333 42.3333 32.4167 42.45 32.75 42.45ZM34.6 14.5L14.5 34.55C14.7333 34.85 14.9 35.1833 15 35.55C15.1 35.9167 15.15 36.2833 15.15 36.65C15.15 37.6833 14.7833 38.5667 14.05 39.3C13.3167 40.0333 12.4333 40.4 11.4 40.4C10.3333 40.4 9.43333 40.0333 8.7 39.3C7.96667 38.5667 7.6 37.6833 7.6 36.65C7.6 35.5833 7.96667 34.6833 8.7 33.95C9.43333 33.2167 10.3167 32.85 11.35 32.85C11.7167 32.85 12.0833 32.9 12.45 33C12.8167 33.1 13.15 33.2667 13.45 33.5L33.5 13.4C33.2667 13.1 33.1 12.7833 33 12.45C32.9 12.1167 32.85 11.75 32.85 11.35C32.85 10.2833 33.225 9.39167 33.975 8.675C34.725 7.95833 35.6167 7.6 36.65 7.6C37.7167 7.6 38.6083 7.95833 39.325 8.675C40.0417 9.39167 40.4 10.2833 40.4 11.35C40.4 12.3833 40.0417 13.275 39.325 14.025C38.6083 14.775 37.7167 15.15 36.65 15.15C36.25 15.15 35.8833 15.1 35.55 15C35.2167 14.9 34.9 14.7333 34.6 14.5Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconFormatPaint = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9498 42.3996C21.5165 42.3996 21.1498 42.2496 20.8498 41.9496C20.5498 41.6496 20.3998 41.2829 20.3998 40.8496V29.1496H13.0998C12.2998 29.1496 11.6331 28.8829 11.0998 28.3496C10.5665 27.8163 10.2998 27.1663 10.2998 26.3996V12.2996C10.2998 11.0329 10.7581 9.93294 11.6748 8.99961C12.5915 8.06628 13.6998 7.59961 14.9998 7.59961H37.6998V26.3996C37.6998 27.1663 37.4331 27.8163 36.8998 28.3496C36.3665 28.8829 35.6998 29.1496 34.8998 29.1496H27.5998V40.8496C27.5998 41.2829 27.4498 41.6496 27.1498 41.9496C26.8498 42.2496 26.4831 42.3996 26.0498 42.3996H21.9498ZM11.8498 20.9996H36.1498V9.14961H32.5998V16.9996H31.0998V9.14961H26.8498V13.2496H25.2998V9.14961H14.9998C14.0665 9.14961 13.3081 9.45794 12.7248 10.0746C12.1415 10.6913 11.8498 11.4329 11.8498 12.2996V20.9996ZM13.0998 27.5996H34.8998C35.2665 27.5996 35.5665 27.4829 35.7998 27.2496C36.0331 27.0163 36.1498 26.7329 36.1498 26.3996V22.5496H11.8498V26.3996C11.8498 26.7329 11.9665 27.0163 12.1998 27.2496C12.4331 27.4829 12.7331 27.5996 13.0998 27.5996ZM11.8498 22.5496V27.5996V26.3996V22.5496Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconBrush = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1996 39.2999C11.5663 39.2999 10.9496 39.2416 10.3496 39.1249C9.74961 39.0082 9.16628 38.7832 8.59961 38.4499C9.43294 37.8499 9.98294 37.1582 10.2496 36.3749C10.5163 35.5916 10.6496 34.6666 10.6496 33.5999C10.6496 32.5999 10.9996 31.7499 11.6996 31.0499C12.3996 30.3499 13.2663 29.9999 14.2996 29.9999C15.3329 29.9999 16.2079 30.3499 16.9246 31.0499C17.6413 31.7499 17.9996 32.5999 17.9996 33.5999C17.9996 35.2332 17.4329 36.5916 16.2996 37.6749C15.1663 38.7582 13.7996 39.2999 12.1996 39.2999ZM12.1996 37.7499C13.3329 37.7499 14.3246 37.3499 15.1746 36.5499C16.0246 35.7499 16.4496 34.7666 16.4496 33.5999C16.4496 33.0332 16.2496 32.5416 15.8496 32.1249C15.4496 31.7082 14.9329 31.4999 14.2996 31.4999C13.6663 31.4999 13.1579 31.7082 12.7746 32.1249C12.3913 32.5416 12.1996 33.0332 12.1996 33.5999C12.1996 34.6332 12.0829 35.4666 11.8496 36.0999C11.6163 36.7332 11.2496 37.2332 10.7496 37.5999C10.8829 37.6332 11.1163 37.6666 11.4496 37.6999C11.7829 37.7332 12.0329 37.7499 12.1996 37.7499ZM21.9496 29.1499L18.9996 26.0499L35.7496 9.29989C36.1496 8.86655 36.6329 8.64155 37.1996 8.62489C37.7663 8.60822 38.2663 8.83322 38.6996 9.29989H38.7496C39.1829 9.76655 39.3996 10.2749 39.3996 10.8249C39.3996 11.3749 39.1829 11.8666 38.7496 12.2999L21.9496 29.1499Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconArchitecture = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 39.85L14 38.3L19.45 23.2C19.6833 23.3667 19.9083 23.5083 20.125 23.625C20.3417 23.7417 20.5667 23.8333 20.8 23.9L15.45 38.7L14.25 39.85ZM33.75 39.85L32.55 38.7L27.15 23.95L27.85 23.65C28.0833 23.55 28.3 23.4 28.5 23.2L34 38.3L33.75 39.85ZM24 21C22.6 21 21.4167 20.5167 20.45 19.55C19.4833 18.5833 19 17.4 19 16C19 14.6667 19.425 13.5417 20.275 12.625C21.125 11.7083 22.1167 11.2 23.25 11.1V6H24.75V11.1C25.8833 11.2 26.875 11.7083 27.725 12.625C28.575 13.5417 29 14.6667 29 16C29 17.4 28.5167 18.5833 27.55 19.55C26.5833 20.5167 25.4 21 24 21ZM24 19.45C24.9667 19.45 25.7833 19.1167 26.45 18.45C27.1167 17.7833 27.45 16.9667 27.45 16C27.45 15.0333 27.1167 14.2167 26.45 13.55C25.7833 12.8833 24.9667 12.55 24 12.55C23.0333 12.55 22.2167 12.8833 21.55 13.55C20.8833 14.2167 20.55 15.0333 20.55 16C20.55 16.9667 20.8833 17.7833 21.55 18.45C22.2167 19.1167 23.0333 19.45 24 19.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconDraw = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 41C27.7667 41 27.5833 40.925 27.45 40.775C27.3167 40.625 27.25 40.45 27.25 40.25C27.25 40.0167 27.3167 39.825 27.45 39.675C27.5833 39.525 27.7667 39.45 28 39.45C30.1 39.45 31.8667 39.025 33.3 38.175C34.7333 37.325 35.45 36.2667 35.45 35C35.45 34.0333 34.9167 33.125 33.85 32.275C32.7833 31.425 31.3 30.7833 29.4 30.35L30.65 29.1C32.8167 29.6333 34.4167 30.4333 35.45 31.5C36.4833 32.5667 37 33.7333 37 35C37 36.9333 36.0667 38.4167 34.2 39.45C32.3333 40.4833 30.2667 41 28 41ZM12.7 26.8C10.7 26.2667 9.25 25.5583 8.35 24.675C7.45 23.7917 7 22.9 7 22C7 21 7.425 20.0917 8.275 19.275C9.125 18.4583 10.9 17.5 13.6 16.4C15.8667 15.5 17.375 14.75 18.125 14.15C18.875 13.55 19.25 12.8333 19.25 12C19.25 11.0333 18.7917 10.2167 17.875 9.55C16.9583 8.88333 15.6667 8.55 14 8.55C13.0333 8.55 12.1583 8.7 11.375 9C10.5917 9.3 9.93333 9.71667 9.4 10.25C9.26667 10.3833 9.09167 10.4667 8.875 10.5C8.65833 10.5333 8.46667 10.4833 8.3 10.35C8.13333 10.2167 8.04167 10.05 8.025 9.85C8.00833 9.65 8.06667 9.46667 8.2 9.3C8.66667 8.63333 9.44167 8.08333 10.525 7.65C11.6083 7.21667 12.7667 7 14 7C16 7 17.625 7.475 18.875 8.425C20.125 9.375 20.75 10.5667 20.75 12C20.75 13.1333 20.3 14.1333 19.4 15C18.5 15.8667 16.7833 16.8 14.25 17.8C12.0167 18.7 10.5083 19.45 9.725 20.05C8.94167 20.65 8.55 21.3 8.55 22C8.55 22.6667 8.99167 23.3 9.875 23.9C10.7583 24.5 12.1333 25.05 14 25.55L12.7 26.8ZM36.05 17.7L31.8 13.45L33.65 11.65C34.0833 11.2167 34.5417 10.9917 35.025 10.975C35.5083 10.9583 35.9667 11.1667 36.4 11.6L37.9 13.1C38.3333 13.5333 38.5417 13.9917 38.525 14.475C38.5083 14.9583 38.2833 15.4167 37.85 15.85L36.05 17.7ZM11.2 38.3H13.2L30.75 20.75L28.75 18.75L11.2 36.3V38.3ZM9.65 39.85V35.7L28.75 16.55L32.95 20.75L13.8 39.85H9.65ZM28.75 18.75L30.75 20.75L28.75 18.75Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Facilities
const SrCompIconRealEstateAgent = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.2496 29.5V14.05L27.9996 6.2L16.7496 14.05V21.05H15.2496V13.35L27.9996 4.25L40.7496 13.35V29.5H39.2496ZM29.1996 16.25H30.7996V14.65H29.1996V16.25ZM25.1996 16.25H26.7996V14.65H25.1996V16.25ZM29.1996 20.25H30.7996V18.65H29.1996V20.25ZM25.1996 20.25H26.7996V18.65H25.1996V20.25ZM27.4496 42.1L11.4996 37.4V40H4.09961V24.75H16.5996L28.8496 29.3C29.4829 29.5333 30.0413 29.9417 30.5246 30.525C31.0079 31.1083 31.2496 31.9833 31.2496 33.15H38.0496C39.1163 33.15 39.9246 33.55 40.4746 34.35C41.0246 35.15 41.2996 36.2333 41.2996 37.6V37.85L27.4496 42.1ZM5.59961 38.45H9.94961V26.3H5.59961V38.45ZM27.2996 40.5L39.6996 36.7C39.6329 36.0667 39.4663 35.575 39.1996 35.225C38.9329 34.875 38.5496 34.7 38.0496 34.7H28.3496C27.4496 34.7 26.5496 34.6417 25.6496 34.525C24.7496 34.4083 23.9829 34.25 23.3496 34.05L19.1996 32.75L19.8996 31.2L23.4996 32.45C24.2996 32.7167 25.1079 32.9 25.9246 33C26.7413 33.1 27.9663 33.15 29.5996 33.15C29.5996 32.55 29.4996 32.0417 29.2996 31.625C29.0996 31.2083 28.7829 30.9167 28.3496 30.75L16.3996 26.3H11.4996V35.75L27.2996 40.5Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconKey = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 26.15C13.4 26.15 12.8917 25.9417 12.475 25.525C12.0583 25.1083 11.85 24.6 11.85 24C11.85 23.4 12.0583 22.8917 12.475 22.475C12.8917 22.0583 13.4 21.85 14 21.85C14.6 21.85 15.1083 22.0583 15.525 22.475C15.9417 22.8917 16.15 23.4 16.15 24C16.15 24.6 15.9417 25.1083 15.525 25.525C15.1083 25.9417 14.6 26.15 14 26.15ZM14 34C11.2333 34 8.875 33.025 6.925 31.075C4.975 29.125 4 26.7667 4 24C4 21.2333 4.975 18.875 6.925 16.925C8.875 14.975 11.2333 14 14 14C16.1333 14 18.025 14.5667 19.675 15.7C21.325 16.8333 22.5167 18.4 23.25 20.4H41.75L45.6 24.25L39.5 29.9L35.9 27.25L32.1 30L28.75 27.6H23.25C22.5833 29.4667 21.4333 31 19.8 32.2C18.1667 33.4 16.2333 34 14 34ZM14 32.45C16 32.45 17.7417 31.825 19.225 30.575C20.7083 29.325 21.65 27.8167 22.05 26.05H29.3L32.1 28.1L35.95 25.35L39.45 28L43.4 24.15L41.15 21.95H22.1C21.7 20.25 20.7667 18.7583 19.3 17.475C17.8333 16.1917 16.0667 15.55 14 15.55C11.6667 15.55 9.675 16.3667 8.025 18C6.375 19.6333 5.55 21.6333 5.55 24C5.55 26.3333 6.36667 28.325 8 29.975C9.63333 31.625 11.6333 32.45 14 32.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Finance
const SrCompIconSavings = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32 21.55C32.4 21.55 32.7583 21.3917 33.075 21.075C33.3917 20.7583 33.55 20.4 33.55 20C33.55 19.6 33.3917 19.2417 33.075 18.925C32.7583 18.6083 32.4 18.45 32 18.45C31.6 18.45 31.2417 18.6083 30.925 18.925C30.6083 19.2417 30.45 19.6 30.45 20C30.45 20.4 30.6083 20.7583 30.925 21.075C31.2417 21.3917 31.6 21.55 32 21.55ZM16 16.55H26V15H16V16.55ZM10.5 40C9.53333 36.5333 8.75833 33.6917 8.175 31.475C7.59167 29.2583 7.14167 27.3917 6.825 25.875C6.50833 24.3583 6.29167 23.0917 6.175 22.075C6.05833 21.0583 6 20.0333 6 19C6 16.5 6.875 14.375 8.625 12.625C10.375 10.875 12.5 10 15 10H26C26.9 8.8 27.9583 7.83333 29.175 7.1C30.3917 6.36667 31.6667 6 33 6C33.2667 6 33.5 6.1 33.7 6.3C33.9 6.5 34 6.73333 34 7C34 7.06667 33.9917 7.13333 33.975 7.2C33.9583 7.26667 33.9333 7.33333 33.9 7.4C33.7333 7.83333 33.575 8.325 33.425 8.875C33.275 9.425 33.1167 10.1833 32.95 11.15L38.8 17H42V27.5L36.75 29.2L33.5 40H26V36H18V40H10.5ZM11.65 38.45H16.45V34.45H27.55V38.45H32.35L35.5 28.1L40.45 26.35V18.55H38.15L31.45 11.85C31.45 11.2833 31.5167 10.6167 31.65 9.85C31.7833 9.08333 31.9667 8.33333 32.2 7.6C31.1 7.9 30.0833 8.425 29.15 9.175C28.2167 9.925 27.5167 10.7167 27.05 11.55H15C12.9333 11.55 11.175 12.275 9.725 13.725C8.275 15.175 7.55 16.9333 7.55 19C7.55 20.3667 7.90833 22.75 8.625 26.15C9.34167 29.55 10.35 33.65 11.65 38.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconAccountBalance = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2996 34.9002V17.5502H14.8496V34.9002H13.2996ZM23.2996 34.9002V17.5502H24.8496V34.9002H23.2996ZM7.09961 40.0002V38.4502H40.8996V40.0002H7.09961ZM33.1496 34.9002V17.5502H34.6996V34.9002H33.1496ZM7.09961 14.0002V12.9502L23.9996 4.2002L40.8996 12.9502V14.0002H7.09961ZM11.3496 12.4502H36.6496H11.3496ZM11.3496 12.4502H36.6496L23.9996 6.0002L11.3496 12.4502Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconCalculate = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.45 35.7H18V31.45H22.2V29.95H18V25.75H16.45V29.95H12.3V31.45H16.45V35.7ZM26.85 34.05H35.6V32.5H26.85V34.05ZM26.85 28.9H35.6V27.35H26.85V28.9ZM28.25 20.75L31.15 17.8L34.1 20.75L35.2 19.6L32.25 16.75L35.2 13.8L34.1 12.7L31.15 15.6L28.25 12.7L27.1 13.8L30.05 16.75L27.1 19.6L28.25 20.75ZM12.9 17.5H21.6V15.95H12.9V17.5ZM10.75 40C9.98333 40 9.33333 39.7333 8.8 39.2C8.26667 38.6667 8 38.0167 8 37.25V10.75C8 9.98333 8.26667 9.33333 8.8 8.8C9.33333 8.26667 9.98333 8 10.75 8H37.25C38.0167 8 38.6667 8.26667 39.2 8.8C39.7333 9.33333 40 9.98333 40 10.75V37.25C40 38.0167 39.7333 38.6667 39.2 39.2C38.6667 39.7333 38.0167 40 37.25 40H10.75ZM10.75 38.45H37.25C37.55 38.45 37.825 38.325 38.075 38.075C38.325 37.825 38.45 37.55 38.45 37.25V10.75C38.45 10.45 38.325 10.175 38.075 9.925C37.825 9.675 37.55 9.55 37.25 9.55H10.75C10.45 9.55 10.175 9.675 9.925 9.925C9.675 10.175 9.55 10.45 9.55 10.75V37.25C9.55 37.55 9.675 37.825 9.925 38.075C10.175 38.325 10.45 38.45 10.75 38.45ZM9.55 9.55V38.45V9.55Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconAttachMoney = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.1996 41V37C21.4329 36.8 19.9496 36.225 18.7496 35.275C17.5496 34.325 16.6663 33.0667 16.0996 31.5L17.4996 30.85C18.1329 32.35 18.9746 33.4917 20.0246 34.275C21.0746 35.0583 22.4329 35.45 24.0996 35.45C25.6996 35.45 27.1579 35.0333 28.4746 34.2C29.7913 33.3667 30.4496 32.0833 30.4496 30.35C30.4496 28.7833 29.9413 27.5417 28.9246 26.625C27.9079 25.7083 26.1663 24.85 23.6996 24.05C21.2996 23.2833 19.5496 22.3667 18.4496 21.3C17.3496 20.2333 16.7996 18.8333 16.7996 17.1C16.7996 15.3667 17.4663 13.9417 18.7996 12.825C20.1329 11.7083 21.5996 11.1167 23.1996 11.05V7H24.7496V11.05C26.0496 11.1167 27.1996 11.4333 28.1996 12C29.1996 12.5667 30.0329 13.4 30.6996 14.5L29.3496 15.25C28.8496 14.3833 28.1663 13.7 27.2996 13.2C26.4329 12.7 25.3496 12.45 24.0496 12.45C22.5163 12.45 21.1829 12.8583 20.0496 13.675C18.9163 14.4917 18.3496 15.6167 18.3496 17.05C18.3496 18.35 18.7829 19.425 19.6496 20.275C20.5163 21.125 22.3163 21.9833 25.0496 22.85C27.4829 23.65 29.2413 24.6167 30.3246 25.75C31.4079 26.8833 31.9496 28.3833 31.9496 30.25C31.9496 32.15 31.2829 33.7 29.9496 34.9C28.6163 36.1 26.8829 36.7833 24.7496 36.95V41H23.1996Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconCurrencyRupee = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.45 40L15.25 27.3V25H21C23.1 25 25.0083 24.3417 26.725 23.025C28.4417 21.7083 29.3167 19.75 29.35 17.15H13V15.6H29.3C28.9333 13.8667 27.9833 12.425 26.45 11.275C24.9167 10.125 23.1 9.55 21 9.55H13V8H35V9.55H26.55C27.65 10.1167 28.5833 10.975 29.35 12.125C30.1167 13.275 30.6 14.4333 30.8 15.6H35V17.15H30.85C30.85 20.0833 29.8583 22.3833 27.875 24.05C25.8917 25.7167 23.6 26.55 21 26.55H16.65L29.6 40H27.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Logistics
const SrCompIconLocalShipping = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0004 38.2C9.56706 38.2 8.35039 37.7 7.35039 36.7C6.35039 35.7 5.85039 34.4667 5.85039 33H3.40039V12.75C3.40039 11.9833 3.66706 11.3333 4.20039 10.8C4.73372 10.2667 5.38372 10 6.15039 10H33.0504V17.4H37.3004L44.6004 27.15V33H41.6004C41.6004 34.4667 41.0921 35.7 40.0754 36.7C39.0587 37.7 37.8337 38.2 36.4004 38.2C34.9671 38.2 33.7504 37.7 32.7504 36.7C31.7504 35.7 31.2504 34.4667 31.2504 33H16.2004C16.2004 34.4667 15.6921 35.7 14.6754 36.7C13.6587 37.7 12.4337 38.2 11.0004 38.2ZM11.0504 36.7C12.0504 36.7 12.9087 36.3417 13.6254 35.625C14.3421 34.9083 14.7004 34.05 14.7004 33.05C14.7004 32.0167 14.3421 31.15 13.6254 30.45C12.9087 29.75 12.0504 29.4 11.0504 29.4C10.0171 29.4 9.15039 29.75 8.45039 30.45C7.75039 31.15 7.40039 32.0167 7.40039 33.05C7.40039 34.05 7.75039 34.9083 8.45039 35.625C9.15039 36.3417 10.0171 36.7 11.0504 36.7ZM4.90039 31.45H6.00039C6.26706 30.45 6.87539 29.6 7.82539 28.9C8.77539 28.2 9.83372 27.85 11.0004 27.85C12.1337 27.85 13.1837 28.2 14.1504 28.9C15.1171 29.6 15.7337 30.45 16.0004 31.45H31.5504V11.55H6.15039C5.85039 11.55 5.56706 11.675 5.30039 11.925C5.03372 12.175 4.90039 12.45 4.90039 12.75V31.45ZM36.4004 36.7C37.4337 36.7 38.3004 36.3417 39.0004 35.625C39.7004 34.9083 40.0504 34.05 40.0504 33.05C40.0504 32.0167 39.7004 31.15 39.0004 30.45C38.3004 29.75 37.4337 29.4 36.4004 29.4C35.4004 29.4 34.5421 29.75 33.8254 30.45C33.1087 31.15 32.7504 32.0167 32.7504 33.05C32.7504 34.05 33.1087 34.9083 33.8254 35.625C34.5421 36.3417 35.4004 36.7 36.4004 36.7ZM33.0504 27.35H42.8504L36.4504 18.95H33.0504V27.35Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconModeOfTravel = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 42.7C19.0667 38.3667 15.3333 34.375 12.8 30.725C10.2667 27.075 9 23.6333 9 20.4C9 15.7 10.5167 11.9583 13.55 9.175C16.5833 6.39167 20.0667 5 24 5C28.4333 5 32.15 6.6 35.15 9.8C38.15 13 39.45 17.5167 39.05 23.35L44.5 17.95L45.5 19L38.3 26.25L31.05 19L32.1 17.95L37.5 23.35C37.9 18.1833 36.8167 14.0917 34.25 11.075C31.6833 8.05833 28.2667 6.55 24 6.55C20.2 6.55 17.0083 7.84167 14.425 10.425C11.8417 13.0083 10.55 16.3333 10.55 20.4C10.55 23.0667 11.6667 26.0833 13.9 29.45C16.1333 32.8167 19.5 36.55 24 40.65C24.6667 40.05 25.5083 39.2583 26.525 38.275C27.5417 37.2917 28.3333 36.5167 28.9 35.95C28.6 35.5167 28.375 35.075 28.225 34.625C28.075 34.175 28 33.7333 28 33.3C28 32.2 28.3917 31.2583 29.175 30.475C29.9583 29.6917 30.9 29.3 32 29.3C33.1 29.3 34.0417 29.6917 34.825 30.475C35.6083 31.2583 36 32.2 36 33.3C36 34.4 35.6083 35.3417 34.825 36.125C34.0417 36.9083 33.1 37.3 32 37.3C31.7 37.3 31.375 37.2667 31.025 37.2C30.675 37.1333 30.35 37.0333 30.05 36.9C29.1167 37.8667 28.15 38.825 27.15 39.775C26.15 40.725 25.1 41.7 24 42.7Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Legal
const SrCompIconBalance = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 40.25V38.7H23.25V15.25C22.2833 15.0833 21.425 14.65 20.675 13.95C19.925 13.25 19.4667 12.3667 19.3 11.3H11.65L17.55 26.25C17.45 27.4833 16.85 28.5417 15.75 29.425C14.65 30.3083 13.3167 30.75 11.75 30.75C10.2167 30.75 8.9 30.3083 7.8 29.425C6.7 28.5417 6.1 27.4833 6 26.25L11.9 11.3H8V9.75H19.3C19.5 8.65 20.0333 7.70833 20.9 6.925C21.7667 6.14167 22.8 5.75 24 5.75C25.2 5.75 26.2333 6.14167 27.1 6.925C27.9667 7.70833 28.5 8.65 28.7 9.75H40V11.3H36.15L42 26.25C41.9 27.4833 41.3 28.5417 40.2 29.425C39.1 30.3083 37.7833 30.75 36.25 30.75C34.6833 30.75 33.35 30.3083 32.25 29.425C31.15 28.5417 30.55 27.4833 30.45 26.25L36.35 11.3H28.7C28.5333 12.3667 28.075 13.25 27.325 13.95C26.575 14.65 25.7167 15.0833 24.75 15.25V38.7H42V40.25H6ZM32.2 26H40.25L36.25 15.7L32.2 26ZM7.75 26H15.8L11.75 15.7L7.75 26ZM24 13.75C24.9 13.75 25.6667 13.4333 26.3 12.8C26.9333 12.1667 27.25 11.4167 27.25 10.55C27.25 9.65 26.9333 8.88333 26.3 8.25C25.6667 7.61667 24.9 7.3 24 7.3C23.1333 7.3 22.375 7.61667 21.725 8.25C21.075 8.88333 20.75 9.65 20.75 10.55C20.75 11.4167 21.075 12.1667 21.725 12.8C22.375 13.4333 23.1333 13.75 24 13.75Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconAssuredWorkload = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2996 34.9002V17.5502H14.8496V34.9002H13.2996ZM23.2996 34.9002V17.5502H24.8496V34.9002H23.2996ZM7.09961 14.0002V12.9502L23.9996 4.2002L40.8996 12.9502V14.0002H7.09961ZM11.3496 12.4502H36.6996L23.9996 6.0002L11.3496 12.4502ZM7.09961 40.0002V38.4502H29.6996C29.6996 38.7169 29.7246 38.9669 29.7746 39.2002C29.8246 39.4335 29.8829 39.7002 29.9496 40.0002H7.09961ZM33.1496 28.9502V17.5502H34.6996V28.1502L33.1496 28.9502ZM39.9996 46.4502C38.0329 45.9835 36.4163 44.8752 35.1496 43.1252C33.8829 41.3752 33.2496 39.4169 33.2496 37.2502V32.9002L39.9996 29.5502L46.7496 32.9002V37.2502C46.7496 39.4169 46.1163 41.3752 44.8496 43.1252C43.5829 44.8752 41.9663 45.9835 39.9996 46.4502ZM38.6996 41.1502L44.8496 35.0002L43.9496 34.1002L38.6996 39.3002L36.2996 36.9002L35.3996 37.8002L38.6996 41.1502ZM11.3496 12.4502H36.6996H11.3496Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconGavel = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 41V39.45H30.25V41H8.25ZM20.05 29.65L10.25 19.85L12.75 17.25L22.65 27.05L20.05 29.65ZM31.05 18.65L21.25 8.75L23.85 6.25L33.65 16.05L31.05 18.65ZM41.5 38.6L16.5 13.6L17.6 12.5L42.6 37.5L41.5 38.6Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Manufacturing
const SrCompIconPrecisionManufacturing = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.6998 38.8998V36.2998H15.7998L10.5498 18.6998C9.61647 18.2665 8.88314 17.6831 8.3498 16.9498C7.81647 16.2165 7.5498 15.2831 7.5498 14.1498C7.5498 12.7831 8.0248 11.6248 8.9748 10.6748C9.9248 9.72481 11.0831 9.2498 12.4498 9.2498C13.7165 9.2498 14.7831 9.63314 15.6498 10.3998C16.5165 11.1665 17.0831 12.1665 17.3498 13.3998H25.0498V9.9498C25.0498 9.71647 25.1331 9.5248 25.2998 9.3748C25.4665 9.2248 25.6498 9.1498 25.8498 9.1498C26.1165 9.1498 26.3248 9.25814 26.4748 9.47481C26.6248 9.69147 26.6665 9.91647 26.5998 10.1498V10.6998L30.4498 7.1498C30.6831 6.91647 30.9665 6.76647 31.2998 6.6998C31.6331 6.63314 31.9831 6.6998 32.3498 6.8998L39.9498 10.4998C40.1498 10.5665 40.3081 10.6998 40.4248 10.8998C40.5415 11.0998 40.5331 11.3165 40.3998 11.5498C40.2998 11.7498 40.1498 11.8748 39.9498 11.9248C39.7498 11.9748 39.5498 11.9331 39.3498 11.7998L31.4498 8.04981L26.5998 12.7498V15.4498L31.4498 20.1498L39.3498 16.3998C39.5831 16.2665 39.7831 16.2248 39.9498 16.2748C40.1165 16.3248 40.2665 16.4498 40.3998 16.6498C40.4998 16.8831 40.4998 17.0998 40.3998 17.2998C40.2998 17.4998 40.1498 17.6665 39.9498 17.7998L32.4498 21.2998C32.0831 21.4665 31.7248 21.5331 31.3748 21.4998C31.0248 21.4665 30.6998 21.3165 30.3998 21.0498L26.5998 17.5998V18.1498C26.6665 18.4831 26.6248 18.7331 26.4748 18.8998C26.3248 19.0665 26.1165 19.1498 25.8498 19.1498C25.6498 19.1498 25.4665 19.0665 25.2998 18.8998C25.1331 18.7331 25.0498 18.5665 25.0498 18.3998V14.8998H17.2998C17.2331 15.3998 17.0581 15.9165 16.7748 16.4498C16.4915 16.9831 16.1998 17.3831 15.8998 17.6498L25.6998 36.2998H33.6998V38.8998H9.6998ZM12.3998 17.4998C13.3665 17.4998 14.1748 17.1748 14.8248 16.5248C15.4748 15.8748 15.7998 15.0831 15.7998 14.1498C15.7998 13.1831 15.4748 12.3748 14.8248 11.7248C14.1748 11.0748 13.3665 10.7498 12.3998 10.7498C11.4665 10.7498 10.6748 11.0748 10.0248 11.7248C9.3748 12.3748 9.0498 13.1831 9.0498 14.1498C9.0498 15.0831 9.3748 15.8748 10.0248 16.5248C10.6748 17.1748 11.4665 17.4998 12.3998 17.4998ZM17.5498 36.2998H23.9498L14.4998 18.3498C14.2998 18.5165 13.9665 18.6581 13.4998 18.7748C13.0331 18.8915 12.6165 18.9331 12.2498 18.8998L17.5498 36.2998Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSettings2 = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6496 42L19.8496 36.3C19.1163 36.0667 18.3079 35.7 17.4246 35.2C16.5413 34.7 15.7996 34.1667 15.1996 33.6L9.89961 36L6.59961 30.1L11.2996 26.6C11.2329 26.2 11.1746 25.775 11.1246 25.325C11.0746 24.875 11.0496 24.45 11.0496 24.05C11.0496 23.65 11.0746 23.2333 11.1246 22.8C11.1746 22.3667 11.2329 21.9 11.2996 21.4L6.59961 17.9L9.89961 12.05L15.1496 14.4C15.8496 13.8333 16.6163 13.3083 17.4496 12.825C18.2829 12.3417 19.0663 11.9833 19.7996 11.75L20.6496 6H27.3496L28.1496 11.75C28.9829 12.0833 29.7746 12.4583 30.5246 12.875C31.2746 13.2917 31.9996 13.8 32.6996 14.4L38.0996 12.05L41.3996 17.9L36.5496 21.45C36.6829 21.9167 36.7663 22.3583 36.7996 22.775C36.8329 23.1917 36.8496 23.6 36.8496 24C36.8496 24.3667 36.8246 24.7583 36.7746 25.175C36.7246 25.5917 36.6496 26.05 36.5496 26.55L41.3996 30.1L38.0496 36L32.6996 33.6C31.9663 34.2 31.2246 34.7333 30.4746 35.2C29.7246 35.6667 28.9496 36.0167 28.1496 36.25L27.3496 42H20.6496ZM23.8996 28.75C25.2329 28.75 26.3579 28.2917 27.2746 27.375C28.1913 26.4583 28.6496 25.3333 28.6496 24C28.6496 22.6667 28.1913 21.5417 27.2746 20.625C26.3579 19.7083 25.2329 19.25 23.8996 19.25C22.5663 19.25 21.4329 19.7083 20.4996 20.625C19.5663 21.5417 19.0996 22.6667 19.0996 24C19.0996 25.3333 19.5663 26.4583 20.4996 27.375C21.4329 28.2917 22.5663 28.75 23.8996 28.75ZM23.8996 27.25C22.9996 27.25 22.2329 26.9333 21.5996 26.3C20.9663 25.6667 20.6496 24.9 20.6496 24C20.6496 23.1 20.9663 22.3333 21.5996 21.7C22.2329 21.0667 22.9996 20.75 23.8996 20.75C24.7996 20.75 25.5579 21.0667 26.1746 21.7C26.7913 22.3333 27.0996 23.1 27.0996 24C27.0996 24.9 26.7913 25.6667 26.1746 26.3C25.5579 26.9333 24.7996 27.25 23.8996 27.25ZM21.8996 40.45H26.0496L26.7996 34.9C27.7996 34.6333 28.7329 34.2583 29.5996 33.775C30.4663 33.2917 31.3329 32.6333 32.1996 31.8L37.3496 34L39.3496 30.55L34.7996 27.15C34.9329 26.55 35.0329 26 35.0996 25.5C35.1663 25 35.1996 24.5 35.1996 24C35.1996 23.4667 35.1663 22.9583 35.0996 22.475C35.0329 21.9917 34.9329 21.4667 34.7996 20.9L39.3996 17.45L37.3996 14L32.1496 16.2C31.5163 15.5 30.6913 14.8333 29.6746 14.2C28.6579 13.5667 27.6829 13.2 26.7496 13.1L26.0996 7.55H21.8996L21.2996 13.05C20.1996 13.25 19.2163 13.6083 18.3496 14.125C17.4829 14.6417 16.6163 15.3167 15.7496 16.15L10.5996 14L8.59961 17.45L13.0996 20.8C12.9663 21.3 12.8579 21.8167 12.7746 22.35C12.6913 22.8833 12.6496 23.45 12.6496 24.05C12.6496 24.5833 12.6913 25.1083 12.7746 25.625C12.8579 26.1417 12.9663 26.65 13.0996 27.15L8.59961 30.55L10.5996 34L15.6996 31.85C16.4996 32.65 17.3496 33.3 18.2496 33.8C19.1496 34.3 20.1496 34.6833 21.2496 34.95L21.8996 40.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconFactory = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 41.9998V21.2998L16 17.0498V20.9498L26 16.9498V21.9998H42V41.9998H6ZM7.55 40.4498H40.45V23.5498H24.45V19.1998L14.45 23.1998V19.2998L7.55 22.3498V40.4498ZM22.7 35.0998H25.3V28.8998H22.7V35.0998ZM14.7 35.0998H17.3V28.8998H14.7V35.0998ZM30.7 35.0998H33.3V28.8998H30.7V35.0998ZM42 21.9998H36.25L38.25 7.5498H40.25L42 21.9998ZM7.55 40.4498H40.45H7.55Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Marketing
const SrCompIconTrendingUp = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.3002 35.0002L5.2002 33.9002L18.5002 20.5502L26.7002 28.7002L40.3002 15.2002H33.1002V13.7002H42.8002V23.3502H41.3002V16.3502L26.6502 31.0002L18.5002 22.8502L6.3002 35.0002Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconLoyalty = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.1 33.8L32.15 27.5C32.45 27.2333 32.6667 26.9167 32.8 26.55C32.9333 26.1833 33 25.7833 33 25.35C33 24.5167 32.7083 23.7917 32.125 23.175C31.5417 22.5583 30.8333 22.25 30 22.25C29.3 22.25 28.6333 22.4333 28 22.8C27.3667 23.1667 26.7333 23.8167 26.1 24.75C25.5 23.85 24.8667 23.2083 24.2 22.825C23.5333 22.4417 22.8667 22.25 22.2 22.25C21.3667 22.25 20.6583 22.5583 20.075 23.175C19.4917 23.7917 19.2 24.5167 19.2 25.35C19.2 25.75 19.2667 26.1417 19.4 26.525C19.5333 26.9083 19.7333 27.2333 20 27.5L26.1 33.8ZM25.75 42C25.55 42 25.35 41.9667 25.15 41.9C24.95 41.8333 24.7833 41.7167 24.65 41.55L6.5 23.45C6.33333 23.25 6.20833 23.05 6.125 22.85C6.04167 22.65 6 22.45 6 22.25V7.55C6 7.11667 6.15 6.75 6.45 6.45C6.75 6.15 7.11667 6 7.55 6H22.25C22.45 6 22.65 6.03333 22.85 6.1C23.05 6.16667 23.2333 6.28333 23.4 6.45L41.5 24.5C41.8667 24.8667 42.05 25.2667 42.05 25.7C42.05 26.1333 41.8833 26.5167 41.55 26.85L26.85 41.55C26.7167 41.7167 26.55 41.8333 26.35 41.9C26.15 41.9667 25.95 42 25.75 42ZM25.75 40.45L40.45 25.75L22.25 7.55H7.55V22.25L25.75 40.45ZM12.65 14.45C13.15 14.45 13.575 14.2667 13.925 13.9C14.275 13.5333 14.45 13.1 14.45 12.6C14.45 12.1333 14.275 11.725 13.925 11.375C13.575 11.025 13.15 10.85 12.65 10.85C12.15 10.85 11.725 11.025 11.375 11.375C11.025 11.725 10.85 12.1333 10.85 12.6C10.85 13.1 11.025 13.5333 11.375 13.9C11.725 14.2667 12.15 14.45 12.65 14.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconAdsClick = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8 33.9C20.3 33.6 18.2083 32.5167 16.525 30.65C14.8417 28.7833 14 26.5667 14 24C14 21.2 14.9667 18.8333 16.9 16.9C18.8333 14.9667 21.2 14 24 14C26.5667 14 28.7833 14.8333 30.65 16.5C32.5167 18.1667 33.6 20.2667 33.9 22.8L32.25 22.3C31.85 20.3333 30.8917 18.7167 29.375 17.45C27.8583 16.1833 26.0667 15.55 24 15.55C21.6667 15.55 19.675 16.375 18.025 18.025C16.375 19.675 15.55 21.6667 15.55 24C15.55 26.0667 16.1917 27.8667 17.475 29.4C18.7583 30.9333 20.3667 31.8833 22.3 32.25L22.8 33.9ZM25.2 41.95C25 41.9833 24.8 42 24.6 42H24C21.5 42 19.1583 41.525 16.975 40.575C14.7917 39.625 12.8917 38.3417 11.275 36.725C9.65833 35.1083 8.375 33.2083 7.425 31.025C6.475 28.8417 6 26.5 6 24C6 21.5 6.475 19.1583 7.425 16.975C8.375 14.7917 9.65833 12.8917 11.275 11.275C12.8917 9.65833 14.7917 8.375 16.975 7.425C19.1583 6.475 21.5 6 24 6C26.5 6 28.8417 6.475 31.025 7.425C33.2083 8.375 35.1083 9.65833 36.725 11.275C38.3417 12.8917 39.625 14.7917 40.575 16.975C41.525 19.1583 42 21.5 42 24V24.6C42 24.8 41.9833 25 41.95 25.2L40.45 24.75V24C40.45 19.4333 38.85 15.55 35.65 12.35C32.45 9.15 28.5667 7.55 24 7.55C19.4333 7.55 15.55 9.15 12.35 12.35C9.15 15.55 7.55 19.4333 7.55 24C7.55 28.5667 9.15 32.45 12.35 35.65C15.55 38.85 19.4333 40.45 24 40.45H24.75L25.2 41.95ZM39.5 41.6L29.9 31.95L28.1 37.55L24 24L37.55 28.1L31.95 29.9L41.6 39.5L39.5 41.6Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconBarChart = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 39V19H14.55V39H9ZM21.25 39V9H26.75V39H21.25ZM33.45 39V27H39V39H33.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Operations
const SrCompIconWarehouse = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.55 38.4504H14.45V22.4504H33.55V38.4504H40.45V16.4004L24 9.80039L7.55 16.4004V38.4504ZM6 40.0004V15.3504L24 8.15039L42 15.3504V40.0004H32V24.0004H16V40.0004H6ZM19.35 40.0004V37.4004H21.95V40.0004H19.35ZM22.7 34.0004V31.4004H25.3V34.0004H22.7ZM26.05 40.0004V37.4004H28.65V40.0004H26.05ZM14.45 22.4504H33.55H14.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconInventory = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 39.15V17.2C7.56667 17.1667 7.125 16.875 6.675 16.325C6.225 15.775 6 15.15 6 14.45V10.75C6 9.98333 6.26667 9.33333 6.8 8.8C7.33333 8.26667 7.98333 8 8.75 8H39.25C40.0167 8 40.6667 8.26667 41.2 8.8C41.7333 9.33333 42 9.98333 42 10.75V14.45C42 15.15 41.775 15.775 41.325 16.325C40.875 16.875 40.4333 17.1667 40 17.2V39.15C40 39.9167 39.7333 40.5833 39.2 41.15C38.6667 41.7167 38.0167 42 37.25 42H10.75C9.98333 42 9.33333 41.7167 8.8 41.15C8.26667 40.5833 8 39.9167 8 39.15ZM9.55 17.25V39.25C9.55 39.5833 9.66667 39.8667 9.9 40.1C10.1333 40.3333 10.4167 40.45 10.75 40.45H37.25C37.5833 40.45 37.8667 40.3333 38.1 40.1C38.3333 39.8667 38.45 39.5833 38.45 39.25V17.25H9.55ZM39.25 15.7C39.5833 15.7 39.8667 15.5833 40.1 15.35C40.3333 15.1167 40.45 14.8167 40.45 14.45V10.75C40.45 10.4167 40.3333 10.1333 40.1 9.9C39.8667 9.66667 39.5833 9.55 39.25 9.55H8.75C8.41667 9.55 8.13333 9.66667 7.9 9.9C7.66667 10.1333 7.55 10.4167 7.55 10.75V14.45C7.55 14.8167 7.66667 15.1167 7.9 15.35C8.13333 15.5833 8.41667 15.7 8.75 15.7H39.25ZM18.75 26.25H29.25V24.7H18.75V26.25ZM9.55 40.45V17.25V40.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// People
const SrCompIconDiversity1 = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.6 27.4C3.7 26.0667 3.04167 24.7 2.625 23.3C2.20833 21.9 2 20.5333 2 19.2C2 16.1 3.09167 13.4583 5.275 11.275C7.45833 9.09167 10.1 8 13.2 8C15.2333 8 17.1667 8.525 19 9.575C20.8333 10.625 22.5 12.1167 24 14.05C25.5 12.1167 27.1667 10.625 29 9.575C30.8333 8.525 32.7667 8 34.8 8C37.9 8 40.5417 9.09167 42.725 11.275C44.9083 13.4583 46 16.1 46 19.2C46 20.4667 45.7917 21.7833 45.375 23.15C44.9583 24.5167 44.3 25.9167 43.4 27.35C43.2 27.1833 42.9833 27.0417 42.75 26.925L42.1 26.6C42.8667 25.3 43.45 24.0333 43.85 22.8C44.25 21.5667 44.45 20.3667 44.45 19.2C44.45 16.5333 43.5083 14.2583 41.625 12.375C39.7417 10.4917 37.4667 9.55 34.8 9.55C33.1333 9.55 31.3833 10.075 29.55 11.125C27.7167 12.175 25.8667 13.95 24 16.45C22.1333 13.95 20.2833 12.175 18.45 11.125C16.6167 10.075 14.8667 9.55 13.2 9.55C10.5333 9.55 8.25833 10.4917 6.375 12.375C4.49167 14.2583 3.55 16.5333 3.55 19.2C3.55 20.4 3.75 21.625 4.15 22.875C4.55 24.125 5.13333 25.3833 5.9 26.65C5.66667 26.7833 5.44167 26.9083 5.225 27.025C5.00833 27.1417 4.8 27.2667 4.6 27.4ZM2 42.1V40.6C2 39.4333 2.63333 38.4667 3.9 37.7C5.16667 36.9333 6.8 36.55 8.8 36.55C9.2 36.55 9.56667 36.5667 9.9 36.6C10.2333 36.6333 10.55 36.6833 10.85 36.75C10.65 37.1833 10.5 37.6417 10.4 38.125C10.3 38.6083 10.25 39.1333 10.25 39.7V42.1H2ZM14 42.1V39.85C14 38.1833 14.925 36.8583 16.775 35.875C18.625 34.8917 21.0333 34.4 24 34.4C27 34.4 29.4167 34.8917 31.25 35.875C33.0833 36.8583 34 38.1833 34 39.85V42.1H14ZM37.75 42.1V39.7C37.75 39.1333 37.7083 38.6083 37.625 38.125C37.5417 37.6417 37.3833 37.1833 37.15 36.75C37.4833 36.6833 37.825 36.6333 38.175 36.6C38.525 36.5667 38.8833 36.55 39.25 36.55C41.2833 36.55 42.9167 36.9333 44.15 37.7C45.3833 38.4667 46 39.4333 46 40.6V42.1H37.75ZM24 35.95C21.4 35.95 19.3167 36.3167 17.75 37.05C16.1833 37.7833 15.4333 38.7667 15.5 40V40.55H32.5V39.95C32.5667 38.75 31.825 37.7833 30.275 37.05C28.725 36.3167 26.6333 35.95 24 35.95V35.95ZM8.8 34.9C8.06667 34.9 7.45 34.6417 6.95 34.125C6.45 33.6083 6.2 32.9833 6.2 32.25C6.2 31.55 6.45 30.95 6.95 30.45C7.45 29.95 8.06667 29.7 8.8 29.7C9.5 29.7 10.1083 29.95 10.625 30.45C11.1417 30.95 11.4 31.55 11.4 32.25C11.4 32.9833 11.1417 33.6083 10.625 34.125C10.1083 34.6417 9.5 34.9 8.8 34.9ZM39.25 34.9C38.5167 34.9 37.8917 34.6417 37.375 34.125C36.8583 33.6083 36.6 32.9833 36.6 32.25C36.6 31.55 36.8583 30.95 37.375 30.45C37.8917 29.95 38.5167 29.7 39.25 29.7C39.9833 29.7 40.6 29.95 41.1 30.45C41.6 30.95 41.85 31.55 41.85 32.25C41.85 32.9833 41.6 33.6083 41.1 34.125C40.6 34.6417 39.9833 34.9 39.25 34.9ZM24 32.9C22.8 32.9 21.7667 32.475 20.9 31.625C20.0333 30.775 19.6 29.75 19.6 28.55C19.6 27.2833 20.025 26.2333 20.875 25.4C21.725 24.5667 22.7667 24.15 24 24.15C25.2333 24.15 26.275 24.5667 27.125 25.4C27.975 26.2333 28.4 27.2667 28.4 28.5C28.4 29.7333 27.975 30.775 27.125 31.625C26.275 32.475 25.2333 32.9 24 32.9ZM24 25.7C23.2333 25.7 22.5667 25.9667 22 26.5C21.4333 27.0333 21.15 27.7167 21.15 28.55C21.15 29.3167 21.4333 29.9833 22 30.55C22.5667 31.1167 23.2333 31.4 24 31.4C24.8 31.4 25.475 31.1167 26.025 30.55C26.575 29.9833 26.85 29.3 26.85 28.5C26.85 27.7 26.5833 27.0333 26.05 26.5C25.5167 25.9667 24.8333 25.7 24 25.7Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconTransgender = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 31.45C26.3667 31.45 28.3667 30.6333 30 29C31.6333 27.3667 32.45 25.3667 32.45 23C32.45 20.6333 31.6333 18.6333 30 17C28.3667 15.3667 26.3667 14.55 24 14.55C21.6333 14.55 19.6333 15.3667 18 17C16.3667 18.6333 15.55 20.6333 15.55 23C15.55 25.3667 16.3667 27.3667 18 29C19.6333 30.6333 21.6333 31.45 24 31.45V31.45ZM23.25 45V41H19.25V39.45H23.25V33.05C20.6167 32.7167 18.4167 31.6083 16.65 29.725C14.8833 27.8417 14 25.6 14 23C14 21.8 14.2 20.6417 14.6 19.525C15 18.4083 15.5833 17.3833 16.35 16.45L13 13.05L10.2 15.85L9.1 14.85L11.9 12.05L5.55 5.65V12.55H4V3H13.55V4.55H6.65L13.05 10.9L15.85 8.1L16.9 9.2L14.1 12L17.5 15.4C18.4333 14.6333 19.45 14.0417 20.55 13.625C21.65 13.2083 22.8 13 24 13C25.2 13 26.35 13.2083 27.45 13.625C28.55 14.0417 29.5833 14.6167 30.55 15.35L41.35 4.55H34.45V3H44V12.55H42.45V5.65L31.65 16.5C32.3833 17.4333 32.9583 18.45 33.375 19.55C33.7917 20.65 34 21.8 34 23C34 25.6 33.1167 27.8417 31.35 29.725C29.5833 31.6083 27.3833 32.7167 24.75 33.05V39.45H28.75V41H24.75V45H23.25Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconPsychology = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1998 40V33.85H15.4998C15.0664 33.85 14.6998 33.7 14.3998 33.4C14.0998 33.1 13.9498 32.7333 13.9498 32.3V25.6H12.2998C11.8664 25.6 11.5164 25.3583 11.2498 24.875C10.9831 24.3917 10.9998 23.9 11.2998 23.4L14.0498 18.55C14.5831 15.3167 15.9748 12.75 18.2248 10.85C20.4748 8.95 23.0664 8 25.9998 8C29.2664 8 32.0831 9.16667 34.4498 11.5C36.8164 13.8333 37.9998 16.6333 37.9998 19.9C37.9998 22.4333 37.2331 24.6917 35.6998 26.675C34.1664 28.6583 32.1498 30.2333 29.6498 31.4V40H20.1998ZM21.7498 38.45H28.1498V30.4L29.0498 30C31.4498 28.9 33.2831 27.4333 34.5498 25.6C35.8164 23.7667 36.4498 21.9 36.4498 20C36.4498 17.1333 35.4248 14.675 33.3748 12.625C31.3248 10.575 28.8664 9.55 25.9998 9.55C23.1998 9.55 20.8164 10.4667 18.8498 12.3C16.8831 14.1333 15.8164 16.3167 15.6498 18.85L12.6998 24.05H15.4998V32.3H21.7498V38.45ZM25.1998 26H26.7498L26.8498 24.5C27.4498 24.4 27.9664 24.2167 28.3998 23.95C28.8331 23.6833 29.1831 23.3833 29.4498 23.05L30.8498 23.6L31.5498 22.35L30.4998 21.5C30.6998 20.9333 30.7998 20.3667 30.7998 19.8C30.7998 19.2333 30.6998 18.6667 30.4998 18.1L31.5498 17.25L30.8498 16L29.4498 16.6C29.1831 16.2667 28.8248 15.975 28.3748 15.725C27.9248 15.475 27.4164 15.3 26.8498 15.2L26.7498 13.65H25.1998L25.1498 15.2C24.5498 15.3 24.0248 15.475 23.5748 15.725C23.1248 15.975 22.7664 16.2667 22.4998 16.6L21.0998 16L20.3998 17.25L21.4998 18.1C21.2664 18.6667 21.1498 19.2333 21.1498 19.8C21.1498 20.3667 21.2664 20.9333 21.4998 21.5L20.3998 22.35L21.0998 23.6L22.4998 23.05C22.7664 23.3833 23.1164 23.6833 23.5498 23.95C23.9831 24.2167 24.5164 24.4 25.1498 24.5L25.1998 26ZM25.9998 23.15C25.0664 23.15 24.2831 22.8167 23.6498 22.15C23.0164 21.4833 22.6998 20.7167 22.6998 19.85C22.6998 18.9167 23.0164 18.125 23.6498 17.475C24.2831 16.825 25.0664 16.5 25.9998 16.5C26.8664 16.5 27.6331 16.825 28.2998 17.475C28.9664 18.125 29.2998 18.9167 29.2998 19.85C29.2998 20.7167 28.9664 21.4833 28.2998 22.15C27.6331 22.8167 26.8664 23.15 25.9998 23.15Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// R&D
const SrCompIconScience = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.35024 40C8.68358 40 8.20858 39.65 7.92524 38.95C7.64191 38.25 7.70024 37.6667 8.10024 37.2L20.3002 22.9V9.55H17.2502C17.0169 9.55 16.8252 9.475 16.6752 9.325C16.5252 9.175 16.4502 8.98333 16.4502 8.75C16.4502 8.55 16.5252 8.375 16.6752 8.225C16.8252 8.075 17.0169 8 17.2502 8H30.7502C30.9836 8 31.1752 8.075 31.3252 8.225C31.4752 8.375 31.5502 8.55 31.5502 8.75C31.5502 8.98333 31.4752 9.175 31.3252 9.325C31.1752 9.475 30.9836 9.55 30.7502 9.55H27.7002V22.9L39.9002 37.2C40.3002 37.6333 40.3586 38.2083 40.0752 38.925C39.7919 39.6417 39.3169 40 38.6502 40H9.35024ZM9.10024 38.45H38.9002L26.1502 23.5V9.55H21.8502V23.5L9.10024 38.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconTravelExplore = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5 42C21.0667 41.9 18.7833 41.375 16.65 40.425C14.5167 39.475 12.6667 38.1917 11.1 36.575C9.53333 34.9583 8.29167 33.075 7.375 30.925C6.45833 28.775 6 26.4667 6 24C6 21.5 6.475 19.1583 7.425 16.975C8.375 14.7917 9.65833 12.8917 11.275 11.275C12.8917 9.65833 14.7917 8.375 16.975 7.425C19.1583 6.475 21.5 6 24 6C28.7 6 32.75 7.55 36.15 10.65C39.55 13.75 41.4833 17.6167 41.95 22.25H40.4C40.0667 19.1833 39 16.425 37.2 13.975C35.4 11.525 33.05 9.73333 30.15 8.6V9.55C30.15 10.6833 29.7583 11.6583 28.975 12.475C28.1917 13.2917 27.2333 13.7 26.1 13.7H21.95V17.85C21.95 18.3833 21.7417 18.85 21.325 19.25C20.9083 19.65 20.4167 19.85 19.85 19.85H15.75V24H20.15V30.1H17.85L7.95 20.25C7.85 20.85 7.75833 21.4667 7.675 22.1C7.59167 22.7333 7.55 23.3667 7.55 24C7.55 28.4333 9.075 32.25 12.125 35.45C15.175 38.65 18.9667 40.3167 23.5 40.45V42ZM42.2 41.3L35.15 34.35C34.55 34.8167 33.8917 35.1667 33.175 35.4C32.4583 35.6333 31.7333 35.75 31 35.75C29.1333 35.75 27.5417 35.0917 26.225 33.775C24.9083 32.4583 24.25 30.8667 24.25 29C24.25 27.1333 24.9083 25.5417 26.225 24.225C27.5417 22.9083 29.1333 22.25 31 22.25C32.8667 22.25 34.4583 22.9083 35.775 24.225C37.0917 25.5417 37.75 27.1333 37.75 29C37.75 29.7667 37.625 30.5167 37.375 31.25C37.125 31.9833 36.75 32.65 36.25 33.25L43.3 40.2L42.2 41.3ZM31 34.25C32.4667 34.25 33.7083 33.7417 34.725 32.725C35.7417 31.7083 36.25 30.4667 36.25 29C36.25 27.5333 35.7417 26.2917 34.725 25.275C33.7083 24.2583 32.4667 23.75 31 23.75C29.5333 23.75 28.2917 24.2583 27.275 25.275C26.2583 26.2917 25.75 27.5333 25.75 29C25.75 30.4667 26.2583 31.7083 27.275 32.725C28.2917 33.7417 29.5333 34.25 31 34.25Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconBiotech = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.75 41.0004V39.4504H21.95V32.9004H20.6C18.1333 32.9004 16.0417 32.0504 14.325 30.3504C12.6083 28.6504 11.75 26.5504 11.75 24.0504C11.75 22.2171 12.2833 20.5421 13.35 19.0254C14.4167 17.5087 15.85 16.4337 17.65 15.8004C17.65 14.3337 18.2417 13.1921 19.425 12.3754C20.6083 11.5587 21.85 11.3837 23.15 11.8504L21.85 8.30039L23.8 7.60039L23.1 5.70039L25.2 4.90039L25.9 6.80039L27.75 6.20039L32.75 19.6004L30.9 20.3004L31.6 22.2004L29.55 22.9504L28.8 21.0504L26.8 21.9004L25.5 18.1504C25.1 18.7837 24.5833 19.2671 23.95 19.6004C23.3167 19.9337 22.6167 20.1004 21.85 20.1004C20.9833 20.1004 20.175 19.8421 19.425 19.3254C18.675 18.8087 18.15 18.1337 17.85 17.3004C16.4167 17.8671 15.3 18.7671 14.5 20.0004C13.7 21.2337 13.3 22.5837 13.3 24.0504C13.3 26.1171 14.0083 27.8587 15.425 29.2754C16.8417 30.6921 18.5667 31.4004 20.6 31.4004H36.25V32.9004H23.95V39.4504H36.25V41.0004H11.75ZM27.85 19.8504L30.8 18.7004L26.85 8.05039L23.8 9.10039L27.85 19.8504ZM21.9 18.5504C22.6667 18.5504 23.3083 18.3004 23.825 17.8004C24.3417 17.3004 24.6 16.6671 24.6 15.9004C24.6 15.1337 24.3417 14.4837 23.825 13.9504C23.3083 13.4171 22.6833 13.1504 21.95 13.1504C21.1833 13.1504 20.5333 13.4087 20 13.9254C19.4667 14.4421 19.2 15.0837 19.2 15.8504C19.2 16.6504 19.4583 17.3004 19.975 17.8004C20.4917 18.3004 21.1333 18.5504 21.9 18.5504Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Sales
const SrCompIconPayments = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.5504 25.3002C25.4171 25.3002 24.4671 24.9169 23.7004 24.1502C22.9337 23.3835 22.5504 22.4335 22.5504 21.3002C22.5504 20.1669 22.9337 19.2169 23.7004 18.4502C24.4671 17.6835 25.4171 17.3002 26.5504 17.3002C27.6837 17.3002 28.6337 17.6835 29.4004 18.4502C30.1671 19.2169 30.5504 20.1669 30.5504 21.3002C30.5504 22.4335 30.1671 23.3835 29.4004 24.1502C28.6337 24.9169 27.6837 25.3002 26.5504 25.3002ZM13.2504 32.1502C12.4837 32.1502 11.8254 31.8752 11.2754 31.3252C10.7254 30.7752 10.4504 30.1335 10.4504 29.4002V13.2502C10.4504 12.4835 10.7254 11.8252 11.2754 11.2752C11.8254 10.7252 12.4837 10.4502 13.2504 10.4502H39.8504C40.5837 10.4502 41.2254 10.7252 41.7754 11.2752C42.3254 11.8252 42.6004 12.4835 42.6004 13.2502V29.4002C42.6004 30.1335 42.3254 30.7752 41.7754 31.3252C41.2254 31.8752 40.5837 32.1502 39.8504 32.1502H13.2504ZM15.7004 30.6002H37.4004C37.4004 29.6002 37.7587 28.7335 38.4754 28.0002C39.1921 27.2669 40.0671 26.9002 41.1004 26.9002V15.7002C40.0671 15.7002 39.1921 15.3335 38.4754 14.6002C37.7587 13.8669 37.4004 13.0002 37.4004 12.0002H15.7004C15.7004 13.0002 15.3337 13.8669 14.6004 14.6002C13.8671 15.3335 13.0004 15.7002 12.0004 15.7002V26.9002C13.0004 26.9002 13.8671 27.2669 14.6004 28.0002C15.3337 28.7335 15.7004 29.6002 15.7004 30.6002ZM36.7004 37.2502H8.15039C7.41706 37.2502 6.77539 36.9669 6.22539 36.4002C5.67539 35.8335 5.40039 35.1835 5.40039 34.4502V16.4002H6.90039V34.4502C6.90039 34.7502 7.03372 35.0335 7.30039 35.3002C7.56706 35.5669 7.85039 35.7002 8.15039 35.7002H36.7004V37.2502ZM13.2504 30.6002H12.0004V12.0002H13.2504C12.9171 12.0002 12.6254 12.1252 12.3754 12.3752C12.1254 12.6252 12.0004 12.9169 12.0004 13.2502V29.4002C12.0004 29.7335 12.1254 30.0169 12.3754 30.2502C12.6254 30.4835 12.9171 30.6002 13.2504 30.6002Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSell = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.75 42C25.55 42 25.35 41.9667 25.15 41.9C24.95 41.8333 24.7833 41.7167 24.65 41.55L6.5 23.45C6.33333 23.25 6.20833 23.05 6.125 22.85C6.04167 22.65 6 22.45 6 22.25V7.55C6 7.11667 6.15 6.75 6.45 6.45C6.75 6.15 7.11667 6 7.55 6H22.25C22.45 6 22.65 6.03333 22.85 6.1C23.05 6.16667 23.2333 6.28333 23.4 6.45L41.5 24.5C41.8667 24.8667 42.05 25.2667 42.05 25.7C42.05 26.1333 41.8833 26.5167 41.55 26.85L26.85 41.55C26.7167 41.6833 26.55 41.7917 26.35 41.875C26.15 41.9583 25.95 42 25.75 42ZM25.8 40.5L40.5 25.8L22.25 7.55H7.55V22.25L25.8 40.5ZM12.65 14.45C13.15 14.45 13.575 14.2667 13.925 13.9C14.275 13.5333 14.45 13.1167 14.45 12.65C14.45 12.15 14.275 11.725 13.925 11.375C13.575 11.025 13.1667 10.85 12.7 10.85C12.1667 10.85 11.725 11.0167 11.375 11.35C11.025 11.6833 10.85 12.1 10.85 12.6C10.85 13.1 11.025 13.5333 11.375 13.9C11.725 14.2667 12.15 14.45 12.65 14.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconPointOfSale = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2996 15.5496C14.5663 15.5496 13.9246 15.2746 13.3746 14.7246C12.8246 14.1746 12.5496 13.5163 12.5496 12.7496V9.84961C12.5496 9.11628 12.8246 8.47461 13.3746 7.92461C13.9246 7.37461 14.5663 7.09961 15.2996 7.09961H32.6996C33.4329 7.09961 34.0746 7.37461 34.6246 7.92461C35.1746 8.47461 35.4496 9.11628 35.4496 9.84961V12.7496C35.4496 13.5163 35.1746 14.1746 34.6246 14.7246C34.0746 15.2746 33.4329 15.5496 32.6996 15.5496H15.2996ZM15.2996 13.9996H32.6996C33.0663 13.9996 33.3579 13.8829 33.5746 13.6496C33.7913 13.4163 33.8996 13.1163 33.8996 12.7496V9.84961C33.8996 9.48294 33.7913 9.18294 33.5746 8.94961C33.3579 8.71628 33.0663 8.59961 32.6996 8.59961H15.2996C14.9329 8.59961 14.6413 8.71628 14.4246 8.94961C14.2079 9.18294 14.0996 9.48294 14.0996 9.84961V12.7496C14.0996 13.1163 14.2079 13.4163 14.4246 13.6496C14.6413 13.8829 14.9329 13.9996 15.2996 13.9996ZM9.84961 39.2996C9.11628 39.2996 8.47461 39.0246 7.92461 38.4746C7.37461 37.9246 7.09961 37.2829 7.09961 36.5496V33.8496H40.8996V36.5496C40.8996 37.2829 40.6246 37.9246 40.0746 38.4746C39.5246 39.0246 38.8829 39.2996 38.1496 39.2996H9.84961ZM7.09961 32.5496L13.1496 18.9996C13.3829 18.4663 13.7246 18.0496 14.1746 17.7496C14.6246 17.4496 15.1163 17.2996 15.6496 17.2996H32.3496C32.8829 17.2996 33.3746 17.4496 33.8246 17.7496C34.2746 18.0496 34.6163 18.4663 34.8496 18.9996L40.8996 32.5496H7.09961ZM17.4496 29.2496H19.4496C19.6496 29.2496 19.8329 29.1663 19.9996 28.9996C20.1663 28.8329 20.2496 28.6496 20.2496 28.4496C20.2496 28.2496 20.1663 28.0746 19.9996 27.9246C19.8329 27.7746 19.6496 27.6996 19.4496 27.6996H17.4496C17.2496 27.6996 17.0746 27.7746 16.9246 27.9246C16.7746 28.0746 16.6996 28.2496 16.6996 28.4496C16.6996 28.6496 16.7746 28.8329 16.9246 28.9996C17.0746 29.1663 17.2496 29.2496 17.4496 29.2496ZM17.4496 25.6996H19.4496C19.6496 25.6996 19.8329 25.6246 19.9996 25.4746C20.1663 25.3246 20.2496 25.1329 20.2496 24.8996C20.2496 24.6996 20.1663 24.5246 19.9996 24.3746C19.8329 24.2246 19.6496 24.1496 19.4496 24.1496H17.4496C17.2496 24.1496 17.0746 24.2246 16.9246 24.3746C16.7746 24.5246 16.6996 24.6996 16.6996 24.8996C16.6996 25.1329 16.7746 25.3246 16.9246 25.4746C17.0746 25.6246 17.2496 25.6996 17.4496 25.6996ZM17.4496 22.1496H19.4496C19.6496 22.1496 19.8329 22.0746 19.9996 21.9246C20.1663 21.7746 20.2496 21.5996 20.2496 21.3996C20.2496 21.1996 20.1663 21.0163 19.9996 20.8496C19.8329 20.6829 19.6496 20.5996 19.4496 20.5996H17.4496C17.2496 20.5996 17.0746 20.6829 16.9246 20.8496C16.7746 21.0163 16.6996 21.1996 16.6996 21.3996C16.6996 21.5996 16.7746 21.7746 16.9246 21.9246C17.0746 22.0746 17.2496 22.1496 17.4496 22.1496ZM22.9996 29.2496H24.9996C25.1996 29.2496 25.3746 29.1663 25.5246 28.9996C25.6746 28.8329 25.7496 28.6496 25.7496 28.4496C25.7496 28.2496 25.6746 28.0746 25.5246 27.9246C25.3746 27.7746 25.1996 27.6996 24.9996 27.6996H22.9996C22.7996 27.6996 22.6246 27.7746 22.4746 27.9246C22.3246 28.0746 22.2496 28.2496 22.2496 28.4496C22.2496 28.6496 22.3246 28.8329 22.4746 28.9996C22.6246 29.1663 22.7996 29.2496 22.9996 29.2496ZM22.9996 25.6996H24.9996C25.1996 25.6996 25.3746 25.6246 25.5246 25.4746C25.6746 25.3246 25.7496 25.1329 25.7496 24.8996C25.7496 24.6996 25.6746 24.5246 25.5246 24.3746C25.3746 24.2246 25.1996 24.1496 24.9996 24.1496H22.9996C22.7996 24.1496 22.6246 24.2246 22.4746 24.3746C22.3246 24.5246 22.2496 24.6996 22.2496 24.8996C22.2496 25.1329 22.3246 25.3246 22.4746 25.4746C22.6246 25.6246 22.7996 25.6996 22.9996 25.6996ZM22.9996 22.1496H24.9996C25.1996 22.1496 25.3746 22.0746 25.5246 21.9246C25.6746 21.7746 25.7496 21.5996 25.7496 21.3996C25.7496 21.1996 25.6746 21.0163 25.5246 20.8496C25.3746 20.6829 25.1996 20.5996 24.9996 20.5996H22.9996C22.7996 20.5996 22.6246 20.6829 22.4746 20.8496C22.3246 21.0163 22.2496 21.1996 22.2496 21.3996C22.2496 21.5996 22.3246 21.7746 22.4746 21.9246C22.6246 22.0746 22.7996 22.1496 22.9996 22.1496ZM28.5496 29.2496H30.5496C30.7496 29.2496 30.9246 29.1663 31.0746 28.9996C31.2246 28.8329 31.2996 28.6496 31.2996 28.4496C31.2996 28.2496 31.2246 28.0746 31.0746 27.9246C30.9246 27.7746 30.7496 27.6996 30.5496 27.6996H28.5496C28.3496 27.6996 28.1663 27.7746 27.9996 27.9246C27.8329 28.0746 27.7496 28.2496 27.7496 28.4496C27.7496 28.6496 27.8329 28.8329 27.9996 28.9996C28.1663 29.1663 28.3496 29.2496 28.5496 29.2496ZM28.5496 25.6996H30.5496C30.7496 25.6996 30.9246 25.6246 31.0746 25.4746C31.2246 25.3246 31.2996 25.1329 31.2996 24.8996C31.2996 24.6996 31.2246 24.5246 31.0746 24.3746C30.9246 24.2246 30.7496 24.1496 30.5496 24.1496H28.5496C28.3496 24.1496 28.1663 24.2246 27.9996 24.3746C27.8329 24.5246 27.7496 24.6996 27.7496 24.8996C27.7496 25.1329 27.8329 25.3246 27.9996 25.4746C28.1663 25.6246 28.3496 25.6996 28.5496 25.6996ZM28.5496 22.1496H30.5496C30.7496 22.1496 30.9246 22.0746 31.0746 21.9246C31.2246 21.7746 31.2996 21.5996 31.2996 21.3996C31.2996 21.1996 31.2246 21.0163 31.0746 20.8496C30.9246 20.6829 30.7496 20.5996 30.5496 20.5996H28.5496C28.3496 20.5996 28.1663 20.6829 27.9996 20.8496C27.8329 21.0163 27.7496 21.1996 27.7496 21.3996C27.7496 21.5996 27.8329 21.7746 27.9996 21.9246C28.1663 22.0746 28.3496 22.1496 28.5496 22.1496Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Technology
const SrCompIconTenancy = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75039 40.9998C6.31706 40.9998 5.10872 40.5081 4.12539 39.5248C3.14206 38.5415 2.65039 37.3331 2.65039 35.8998C2.65039 34.4998 3.14206 33.3081 4.12539 32.3248C5.10872 31.3415 6.31706 30.8498 7.75039 30.8498C8.11706 30.8498 8.48372 30.8915 8.85039 30.9748C9.21706 31.0581 9.58372 31.1665 9.95039 31.2998L18.9004 19.0498C18.2671 18.4165 17.7754 17.6748 17.4254 16.8248C17.0754 15.9748 16.9004 15.0665 16.9004 14.0998C16.9004 12.1331 17.5921 10.4665 18.9754 9.0998C20.3587 7.73314 22.0337 7.0498 24.0004 7.0498C25.9671 7.0498 27.6421 7.73314 29.0254 9.0998C30.4087 10.4665 31.1004 12.1331 31.1004 14.0998C31.1004 15.0665 30.9171 15.9665 30.5504 16.7998C30.1837 17.6331 29.6837 18.3831 29.0504 19.0498L38.0504 31.3498C38.3837 31.1831 38.7337 31.0581 39.1004 30.9748C39.4671 30.8915 39.8504 30.8498 40.2504 30.8498C41.6837 30.8498 42.8921 31.3415 43.8754 32.3248C44.8587 33.3081 45.3504 34.4998 45.3504 35.8998C45.3504 37.3331 44.8587 38.5415 43.8754 39.5248C42.8921 40.5081 41.6837 40.9998 40.2504 40.9998C38.8504 40.9998 37.6587 40.5081 36.6754 39.5248C35.6921 38.5415 35.2004 37.3331 35.2004 35.8998C35.2004 35.1665 35.3421 34.4915 35.6254 33.8748C35.9087 33.2581 36.3004 32.7165 36.8004 32.2498L27.9004 19.9998C27.4337 20.3331 26.9421 20.5915 26.4254 20.7748C25.9087 20.9581 25.3504 21.0831 24.7504 21.1498V30.8498C25.9837 31.0498 27.0171 31.6165 27.8504 32.5498C28.6837 33.4831 29.1004 34.5998 29.1004 35.8998C29.1004 37.2998 28.6004 38.4915 27.6004 39.4748C26.6004 40.4581 25.4004 40.9498 24.0004 40.9498C22.6004 40.9498 21.4004 40.4581 20.4004 39.4748C19.4004 38.4915 18.9004 37.2998 18.9004 35.8998C18.9004 34.6331 19.3171 33.5165 20.1504 32.5498C20.9837 31.5831 22.0171 31.0165 23.2504 30.8498V21.1498C22.6504 21.0831 22.0921 20.9581 21.5754 20.7748C21.0587 20.5915 20.5671 20.3331 20.1004 19.9998L11.2004 32.2498C11.6671 32.7165 12.0504 33.2581 12.3504 33.8748C12.6504 34.4915 12.8004 35.1665 12.8004 35.8998C12.8004 37.3331 12.3087 38.5415 11.3254 39.5248C10.3421 40.5081 9.15039 40.9998 7.75039 40.9998ZM7.75039 39.4498C8.71706 39.4498 9.54206 39.1081 10.2254 38.4248C10.9087 37.7415 11.2504 36.8998 11.2504 35.8998C11.2504 34.9331 10.9087 34.1081 10.2254 33.4248C9.54206 32.7415 8.71706 32.3998 7.75039 32.3998C6.75039 32.3998 5.90872 32.7415 5.22539 33.4248C4.54206 34.1081 4.20039 34.9331 4.20039 35.8998C4.20039 36.8998 4.54206 37.7415 5.22539 38.4248C5.90872 39.1081 6.75039 39.4498 7.75039 39.4498ZM24.0004 39.3998C24.9671 39.3998 25.8004 39.0581 26.5004 38.3748C27.2004 37.6915 27.5504 36.8665 27.5504 35.8998C27.5504 34.8998 27.2004 34.0581 26.5004 33.3748C25.8004 32.6915 24.9671 32.3498 24.0004 32.3498C23.0337 32.3498 22.2004 32.6915 21.5004 33.3748C20.8004 34.0581 20.4504 34.8998 20.4504 35.8998C20.4504 36.8665 20.8004 37.6915 21.5004 38.3748C22.2004 39.0581 23.0337 39.3998 24.0004 39.3998ZM40.2504 39.4498C41.2504 39.4498 42.0921 39.1081 42.7754 38.4248C43.4587 37.7415 43.8004 36.8998 43.8004 35.8998C43.8004 34.9331 43.4587 34.1081 42.7754 33.4248C42.0921 32.7415 41.2504 32.3998 40.2504 32.3998C39.2837 32.3998 38.4587 32.7415 37.7754 33.4248C37.0921 34.1081 36.7504 34.9331 36.7504 35.8998C36.7504 36.8998 37.0921 37.7415 37.7754 38.4248C38.4587 39.1081 39.2837 39.4498 40.2504 39.4498ZM24.0004 19.6498C25.5004 19.6498 26.8004 19.1081 27.9004 18.0248C29.0004 16.9415 29.5504 15.6331 29.5504 14.0998C29.5504 12.5998 29.0004 11.3081 27.9004 10.2248C26.8004 9.14147 25.5004 8.5998 24.0004 8.5998C22.5004 8.5998 21.2004 9.14147 20.1004 10.2248C19.0004 11.3081 18.4504 12.5998 18.4504 14.0998C18.4504 15.6331 19.0004 16.9415 20.1004 18.0248C21.2004 19.1081 22.5004 19.6498 24.0004 19.6498Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconIntegrationInstructions = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2 29.75L20.3 28.7L15.7 24L20.3 19.35L19.2 18.25L13.45 24L19.2 29.75ZM28.8 29.75L34.55 24L28.8 18.25L27.7 19.35L32.35 24L27.7 28.7L28.8 29.75ZM10.75 40C10.0167 40 9.375 39.725 8.825 39.175C8.275 38.625 8 37.9833 8 37.25V10.75C8 10.0167 8.275 9.375 8.825 8.825C9.375 8.275 10.0167 8 10.75 8H21C20.7333 7 20.9083 6.08333 21.525 5.25C22.1417 4.41667 22.9667 4 24 4C25.0667 4 25.9083 4.41667 26.525 5.25C27.1417 6.08333 27.3 7 27 8H37.25C37.9833 8 38.625 8.275 39.175 8.825C39.725 9.375 40 10.0167 40 10.75V37.25C40 37.9833 39.725 38.625 39.175 39.175C38.625 39.725 37.9833 40 37.25 40H10.75ZM10.75 38.45H37.25C37.55 38.45 37.825 38.325 38.075 38.075C38.325 37.825 38.45 37.55 38.45 37.25V10.75C38.45 10.45 38.325 10.175 38.075 9.925C37.825 9.675 37.55 9.55 37.25 9.55H10.75C10.45 9.55 10.175 9.675 9.925 9.925C9.675 10.175 9.55 10.45 9.55 10.75V37.25C9.55 37.55 9.675 37.825 9.925 38.075C10.175 38.325 10.45 38.45 10.75 38.45ZM24 8.75C24.4333 8.75 24.8167 8.59167 25.15 8.275C25.4833 7.95833 25.65 7.56667 25.65 7.1C25.65 6.66667 25.4833 6.29167 25.15 5.975C24.8167 5.65833 24.4333 5.5 24 5.5C23.5667 5.5 23.1917 5.65833 22.875 5.975C22.5583 6.29167 22.4 6.66667 22.4 7.1C22.4 7.56667 22.5583 7.95833 22.875 8.275C23.1917 8.59167 23.5667 8.75 24 8.75ZM9.55 38.45V9.55V38.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconFingerprint = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.0502 4.25C26.1502 4.25 28.2169 4.50833 30.2502 5.025C32.2835 5.54167 34.2335 6.28333 36.1002 7.25C36.3002 7.35 36.4169 7.46667 36.4502 7.6C36.4835 7.73333 36.4669 7.86667 36.4002 8C36.3335 8.1 36.2335 8.18333 36.1002 8.25C35.9669 8.31667 35.8335 8.31667 35.7002 8.25C33.9335 7.25 32.0585 6.50833 30.0752 6.025C28.0919 5.54167 26.0835 5.3 24.0502 5.3C22.0169 5.3 20.0252 5.55833 18.0752 6.075C16.1252 6.59167 14.2502 7.31667 12.4502 8.25C12.3502 8.28333 12.2419 8.275 12.1252 8.225C12.0085 8.175 11.9169 8.1 11.8502 8C11.8169 7.93333 11.8002 7.825 11.8002 7.675C11.8002 7.525 11.8502 7.41667 11.9502 7.35C13.8169 6.31667 15.7752 5.54167 17.8252 5.025C19.8752 4.50833 21.9502 4.25 24.0502 4.25ZM23.9502 9.2C27.4835 9.2 30.8252 9.95833 33.9752 11.475C37.1252 12.9917 39.7502 15.1833 41.8502 18.05C41.9169 18.2167 41.9335 18.3583 41.9002 18.475C41.8669 18.5917 41.8002 18.7 41.7002 18.8C41.6002 18.8667 41.4669 18.9 41.3002 18.9C41.1335 18.9 41.0002 18.8167 40.9002 18.65C38.9335 15.9167 36.4585 13.8417 33.4752 12.425C30.4919 11.0083 27.3169 10.3 23.9502 10.3C20.6502 10.3 17.5252 11.0167 14.5752 12.45C11.6252 13.8833 9.18353 15.95 7.2502 18.65C7.08353 18.8167 6.93353 18.9 6.8002 18.9C6.66686 18.9 6.53353 18.8667 6.4002 18.8C6.26686 18.7 6.2002 18.5917 6.2002 18.475C6.2002 18.3583 6.23353 18.25 6.3002 18.15C8.36686 15.3167 10.9502 13.1167 14.0502 11.55C17.1502 9.98333 20.4502 9.2 23.9502 9.2ZM24.0502 18.9C27.0502 18.9 29.6335 19.9083 31.8002 21.925C33.9669 23.9417 35.0502 26.4167 35.0502 29.35C35.0502 29.55 35.0085 29.6917 34.9252 29.775C34.8419 29.8583 34.7169 29.9 34.5502 29.9C34.4169 29.9 34.2919 29.8583 34.1752 29.775C34.0585 29.6917 34.0002 29.55 34.0002 29.35C34.0002 26.7167 33.0169 24.5 31.0502 22.7C29.0835 20.9 26.7502 20 24.0502 20C21.3502 20 19.0252 20.9 17.0752 22.7C15.1252 24.5 14.1502 26.7167 14.1502 29.35C14.1502 32.1833 14.6419 34.575 15.6252 36.525C16.6085 38.475 18.0335 40.4333 19.9002 42.4C20.0335 42.5667 20.0835 42.725 20.0502 42.875C20.0169 43.025 19.9669 43.1333 19.9002 43.2C19.8002 43.3 19.6752 43.3583 19.5252 43.375C19.3752 43.3917 19.2335 43.3333 19.1002 43.2C17.2335 41.2 15.7585 39.1083 14.6752 36.925C13.5919 34.7417 13.0502 32.2167 13.0502 29.35C13.0502 26.4167 14.1335 23.9417 16.3002 21.925C18.4669 19.9083 21.0502 18.9 24.0502 18.9ZM23.9502 28.8C24.1169 28.8 24.2502 28.8583 24.3502 28.975C24.4502 29.0917 24.5002 29.2167 24.5002 29.35C24.5002 32.05 25.4585 34.25 27.3752 35.95C29.2919 37.65 31.5335 38.5 34.1002 38.5C34.4669 38.5 34.8335 38.4833 35.2002 38.45C35.5669 38.4167 35.9502 38.3667 36.3502 38.3C36.4502 38.3 36.5502 38.3333 36.6502 38.4C36.7502 38.4667 36.8169 38.5667 36.8502 38.7C36.9169 38.8667 36.9085 39 36.8252 39.1C36.7419 39.2 36.6169 39.2667 36.4502 39.3C36.0835 39.4 35.6835 39.475 35.2502 39.525C34.8169 39.575 34.4335 39.6 34.1002 39.6C31.2335 39.6 28.7335 38.6333 26.6002 36.7C24.4669 34.7667 23.4002 32.3167 23.4002 29.35C23.4002 29.2167 23.4502 29.0917 23.5502 28.975C23.6502 28.8583 23.7835 28.8 23.9502 28.8ZM24.0502 23.85C25.6169 23.85 26.9669 24.375 28.1002 25.425C29.2335 26.475 29.8002 27.7833 29.8002 29.35C29.8002 30.6167 30.2752 31.6667 31.2252 32.5C32.1752 33.3333 33.2669 33.75 34.5002 33.75C35.8002 33.75 36.9002 33.3333 37.8002 32.5C38.7002 31.6667 39.1502 30.6167 39.1502 29.35C39.1502 25.3167 37.6585 21.9333 34.6752 19.2C31.6919 16.4667 28.1335 15.1 24.0002 15.1C19.8335 15.1 16.2585 16.4667 13.2752 19.2C10.2919 21.9333 8.8002 25.3167 8.8002 29.35C8.8002 30.1833 8.9002 31.225 9.1002 32.475C9.3002 33.725 9.68353 35.1667 10.2502 36.8C10.3169 36.9667 10.3252 37.1 10.2752 37.2C10.2252 37.3 10.1335 37.3833 10.0002 37.45C9.83353 37.5167 9.68353 37.5333 9.5502 37.5C9.41686 37.4667 9.31686 37.3667 9.2502 37.2C8.78353 35.8333 8.41686 34.5167 8.1502 33.25C7.88353 31.9833 7.7502 30.6833 7.7502 29.35C7.7502 25.05 9.3502 21.4083 12.5502 18.425C15.7502 15.4417 19.5502 13.95 23.9502 13.95C28.4169 13.95 32.2585 15.4333 35.4752 18.4C38.6919 21.3667 40.3002 25.0167 40.3002 29.35C40.3002 30.8833 39.7335 32.1833 38.6002 33.25C37.4669 34.3167 36.1169 34.85 34.5502 34.85C32.9502 34.85 31.5752 34.3167 30.4252 33.25C29.2752 32.1833 28.7002 30.8833 28.7002 29.35C28.7002 28.1167 28.2419 27.075 27.3252 26.225C26.4085 25.375 25.3169 24.95 24.0502 24.95C22.7502 24.95 21.6335 25.375 20.7002 26.225C19.7669 27.075 19.3002 28.1167 19.3002 29.35C19.3002 32.7833 20.3252 35.6333 22.3752 37.9C24.4252 40.1667 27.0002 41.7667 30.1002 42.7C30.3002 42.7333 30.4252 42.8167 30.4752 42.95C30.5252 43.0833 30.5335 43.2167 30.5002 43.35C30.4669 43.5167 30.3919 43.6333 30.2752 43.7C30.1585 43.7667 30.0002 43.7833 29.8002 43.75C26.4669 42.85 23.7085 41.1417 21.5252 38.625C19.3419 36.1083 18.2502 33.0167 18.2502 29.35C18.2502 27.7833 18.8169 26.475 19.9502 25.425C21.0835 24.375 22.4502 23.85 24.0502 23.85Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconDeveloperMode = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2002 31.75L9.4502 24L17.2002 16.25L18.3002 17.4L11.7002 24L18.3002 30.6L17.2002 31.75ZM12.0002 34.3H13.5502V38.15H34.4502V34.3H36.0002V41.25C36.0002 42.0167 35.7335 42.6667 35.2002 43.2C34.6669 43.7333 34.0169 44 33.2502 44H14.7502C13.9835 44 13.3335 43.7333 12.8002 43.2C12.2669 42.6667 12.0002 42.0167 12.0002 41.25V34.3ZM13.5502 13.4H12.0002V6.75C12.0002 5.98333 12.2669 5.33333 12.8002 4.8C13.3335 4.26667 13.9835 4 14.7502 4H33.2502C34.0169 4 34.6669 4.26667 35.2002 4.8C35.7335 5.33333 36.0002 5.98333 36.0002 6.75V13.4H34.4502V9.85H13.5502V13.4ZM13.5502 39.7V41.25C13.5502 41.55 13.6752 41.825 13.9252 42.075C14.1752 42.325 14.4502 42.45 14.7502 42.45H33.2502C33.5502 42.45 33.8252 42.325 34.0752 42.075C34.3252 41.825 34.4502 41.55 34.4502 41.25V39.7H13.5502ZM13.5502 8.3H34.4502V6.75C34.4502 6.45 34.3252 6.175 34.0752 5.925C33.8252 5.675 33.5502 5.55 33.2502 5.55H14.7502C14.4502 5.55 14.1752 5.675 13.9252 5.925C13.6752 6.175 13.5502 6.45 13.5502 6.75V8.3ZM30.8002 31.75L29.7002 30.6L36.3002 24L29.7002 17.4L30.8002 16.25L38.5502 24L30.8002 31.75ZM13.5502 8.3V5.55V8.3ZM13.5502 39.7V42.45V41.25V39.7Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconDevices = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.9502 37.5504V35.2504H10.1002V12.7004C10.1002 11.9337 10.3669 11.2754 10.9002 10.7254C11.4335 10.1754 12.1002 9.90039 12.9002 9.90039H41.1002V11.4504H12.9002C12.5669 11.4504 12.2752 11.5837 12.0252 11.8504C11.7752 12.1171 11.6502 12.4004 11.6502 12.7004V35.2504H22.5002V37.5504H5.9502ZM30.6502 37.5504C30.2169 37.5504 29.8502 37.4004 29.5502 37.1004C29.2502 36.8004 29.1002 36.4004 29.1002 35.9004V18.0504C29.1002 17.6171 29.2502 17.2587 29.5502 16.9754C29.8502 16.6921 30.2169 16.5504 30.6502 16.5504H40.3002C40.8002 16.5504 41.2169 16.6921 41.5502 16.9754C41.8835 17.2587 42.0502 17.6171 42.0502 18.0504V35.9004C42.0502 36.4004 41.8835 36.8004 41.5502 37.1004C41.2169 37.4004 40.8002 37.5504 40.3002 37.5504H30.6502ZM30.6502 35.2504H40.5002V18.1004H30.6502V35.2504Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconDevicesOther = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6 38H8.75C7.98333 38 7.33333 37.7333 6.8 37.2C6.26667 36.6667 6 36.0167 6 35.25V12.75C6 11.9833 6.26667 11.3333 6.8 10.8C7.33333 10.2667 7.98333 10 8.75 10H40V11.55H8.75C8.45 11.55 8.175 11.675 7.925 11.925C7.675 12.175 7.55 12.45 7.55 12.75V35.25C7.55 35.55 7.675 35.825 7.925 36.075C8.175 36.325 8.45 36.45 8.75 36.45H14.6V38ZM20.6 38V35.25C19.9333 34.75 19.4333 34.175 19.1 33.525C18.7667 32.875 18.6 32.1833 18.6 31.45C18.6 30.7167 18.7667 30.025 19.1 29.375C19.4333 28.725 19.9333 28.1667 20.6 27.7V24.9H25.7V27.7C26.3667 28.1667 26.8667 28.725 27.2 29.375C27.5333 30.025 27.7 30.7167 27.7 31.45C27.7 32.1833 27.5333 32.875 27.2 33.525C26.8667 34.175 26.3667 34.75 25.7 35.25V38H20.6ZM23.15 34.7C24.0833 34.7 24.8583 34.3917 25.475 33.775C26.0917 33.1583 26.4 32.3833 26.4 31.45C26.4 30.55 26.0917 29.7917 25.475 29.175C24.8583 28.5583 24.0833 28.25 23.15 28.25C22.2167 28.25 21.4417 28.55 20.825 29.15C20.2083 29.75 19.9 30.5167 19.9 31.45C19.9 32.3833 20.2083 33.1583 20.825 33.775C21.4417 34.3917 22.2167 34.7 23.15 34.7ZM40.7 38H33C32.6333 38 32.325 37.875 32.075 37.625C31.825 37.375 31.7 37.0667 31.7 36.7V21C31.7 20.6333 31.825 20.325 32.075 20.075C32.325 19.825 32.6333 19.7 33 19.7H40.7C41.0667 19.7 41.375 19.825 41.625 20.075C41.875 20.325 42 20.6333 42 21V36.7C42 37.0667 41.875 37.375 41.625 37.625C41.375 37.875 41.0667 38 40.7 38ZM33.25 36.45H40.45V21.25H33.25V36.45Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSecurity = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 41.9004C19.9667 40.7337 16.625 38.2921 13.975 34.5754C11.325 30.8587 10 26.6837 10 22.0504V11.4004L24 6.15039L38 11.4004V22.0504C38 26.6837 36.675 30.8587 34.025 34.5754C31.375 38.2921 28.0333 40.7337 24 41.9004ZM24 40.3004C27.3667 39.2337 30.175 37.1837 32.425 34.1504C34.675 31.1171 35.9833 27.7337 36.35 24.0004H24V7.85039L11.55 12.4504V22.0504C11.55 22.4171 11.5583 22.7421 11.575 23.0254C11.5917 23.3087 11.6167 23.6337 11.65 24.0004H24V40.3004Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconWindPower = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6 43.9996C22.6 43.533 22.8333 43.158 23.3 42.8746C23.7667 42.5913 24.4167 42.4496 25.25 42.4496V30.2996C24.5833 30.1663 24 29.9163 23.5 29.5496C23 29.183 22.6 28.7163 22.3 28.1496L17.1 31.3996C16.8667 31.5663 16.6167 31.658 16.35 31.6746C16.0833 31.6913 15.8 31.6663 15.5 31.5996L6.5 29.0496C5.93333 28.883 5.48333 28.5663 5.15 28.0996C4.81667 27.633 4.65 27.1163 4.65 26.5496C4.65 25.8163 4.89167 25.208 5.375 24.7246C5.85833 24.2413 6.46667 23.9996 7.2 23.9996H22.2C22.5 23.4663 22.8833 22.9996 23.35 22.5996C23.8167 22.1996 24.3667 21.933 25 21.7996V14.7996C25 14.5663 25.05 14.3163 25.15 14.0496C25.25 13.783 25.4167 13.5663 25.65 13.3996L32.5 6.99963C32.9333 6.56629 33.4333 6.31629 34 6.24963C34.5667 6.18296 35.0833 6.29963 35.55 6.59963C36.15 6.99963 36.5417 7.54129 36.725 8.22463C36.9083 8.90796 36.8167 9.53296 36.45 10.0996L28.75 22.7996C29.35 23.1663 29.7917 23.758 30.075 24.5746C30.3583 25.3913 30.4 26.1663 30.2 26.8996L36.35 28.4496C36.65 28.5163 36.9 28.6246 37.1 28.7746C37.3 28.9246 37.4667 29.1163 37.6 29.3496L42.15 37.5996C42.4167 38.0996 42.5167 38.633 42.45 39.1996C42.3833 39.7663 42.1333 40.2496 41.7 40.6496C41.2 41.1496 40.6 41.3913 39.9 41.3746C39.2 41.358 38.6 41.0996 38.1 40.5996L27.6 30.0996C27.4667 30.1663 27.3333 30.2246 27.2 30.2746C27.0667 30.3246 26.9167 30.3663 26.75 30.3996V42.4496C27.5833 42.4496 28.2333 42.5913 28.7 42.8746C29.1667 43.158 29.4 43.533 29.4 43.9996H22.6ZM10 9.74963V8.24963H20V9.74963H10ZM26.55 14.5996V21.6496C26.7167 21.683 26.875 21.733 27.025 21.7996C27.175 21.8663 27.3167 21.933 27.45 21.9996L35.15 9.29963C35.2833 9.06629 35.3167 8.80796 35.25 8.52463C35.1833 8.24129 35.0167 8.04963 34.75 7.94963C34.55 7.81629 34.3333 7.76629 34.1 7.79963C33.8667 7.83296 33.6833 7.91629 33.55 8.04963L26.55 14.5996ZM4 17.7496V16.2496H12V17.7496H4ZM26 28.8496C26.8333 28.8496 27.5167 28.583 28.05 28.0496C28.5833 27.5163 28.85 26.833 28.85 25.9996C28.85 25.1663 28.5833 24.483 28.05 23.9496C27.5167 23.4163 26.8333 23.1496 26 23.1496C25.1667 23.1496 24.4833 23.4163 23.95 23.9496C23.4167 24.483 23.15 25.1663 23.15 25.9996C23.15 26.833 23.4167 27.5163 23.95 28.0496C24.4833 28.583 25.1667 28.8496 26 28.8496ZM16.1 30.1996L21.8 26.6496C21.7333 26.483 21.6917 26.2996 21.675 26.0996C21.6583 25.8996 21.6833 25.7163 21.75 25.5496H7.2C6.93333 25.5496 6.7 25.6496 6.5 25.8496C6.3 26.0496 6.2 26.283 6.2 26.5496C6.2 26.783 6.26667 26.9913 6.4 27.1746C6.53333 27.358 6.7 27.483 6.9 27.5496L16.1 30.1996ZM36.15 29.9496L29.6 28.3496C29.5 28.5163 29.3917 28.6663 29.275 28.7996C29.1583 28.933 29.0333 29.0663 28.9 29.1996L39.1 39.4496C39.3333 39.6496 39.5833 39.7496 39.85 39.7496C40.1167 39.7496 40.35 39.6496 40.55 39.4496C40.75 39.283 40.8583 39.0996 40.875 38.8996C40.8917 38.6996 40.85 38.483 40.75 38.2496L36.15 29.9496ZM8 39.7496V38.2496H16V39.7496H8Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconSunny = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9996 10.5996C23.7663 10.5996 23.5829 10.5246 23.4496 10.3746C23.3163 10.2246 23.2496 10.0496 23.2496 9.84961V4.84961C23.2496 4.61628 23.3246 4.43294 23.4746 4.29961C23.6246 4.16628 23.7996 4.09961 23.9996 4.09961C24.2329 4.09961 24.4163 4.16628 24.5496 4.29961C24.6829 4.43294 24.7496 4.61628 24.7496 4.84961V9.84961C24.7496 10.0496 24.6746 10.2246 24.5246 10.3746C24.3746 10.5246 24.1996 10.5996 23.9996 10.5996ZM33.4496 14.5496C33.2829 14.4163 33.2079 14.2413 33.2246 14.0246C33.2413 13.8079 33.3329 13.6163 33.4996 13.4496L36.9496 9.89961C37.1163 9.73294 37.3079 9.64961 37.5246 9.64961C37.7413 9.64961 37.9329 9.73294 38.0996 9.89961C38.2663 10.0663 38.3496 10.2496 38.3496 10.4496C38.3496 10.6496 38.2663 10.8329 38.0996 10.9996L34.5496 14.5496C34.3829 14.7163 34.1996 14.7996 33.9996 14.7996C33.7996 14.7996 33.6163 14.7163 33.4496 14.5496V14.5496ZM38.1496 24.7496C37.9496 24.7496 37.7746 24.6746 37.6246 24.5246C37.4746 24.3746 37.3996 24.1996 37.3996 23.9996C37.3996 23.7663 37.4746 23.5829 37.6246 23.4496C37.7746 23.3163 37.9496 23.2496 38.1496 23.2496H43.1496C43.3829 23.2496 43.5663 23.3246 43.6996 23.4746C43.8329 23.6246 43.8996 23.7996 43.8996 23.9996C43.8996 24.2329 43.8329 24.4163 43.6996 24.5496C43.5663 24.6829 43.3829 24.7496 43.1496 24.7496H38.1496ZM23.9996 43.8996C23.7663 43.8996 23.5829 43.8329 23.4496 43.6996C23.3163 43.5663 23.2496 43.3829 23.2496 43.1496V38.1996C23.2496 37.9663 23.3246 37.7746 23.4746 37.6246C23.6246 37.4746 23.7996 37.3996 23.9996 37.3996C24.2329 37.3996 24.4163 37.4746 24.5496 37.6246C24.6829 37.7746 24.7496 37.9663 24.7496 38.1996V43.1496C24.7496 43.3829 24.6746 43.5663 24.5246 43.6996C24.3746 43.8329 24.1996 43.8996 23.9996 43.8996V43.8996ZM13.4996 14.5496L9.89961 11.0496C9.73294 10.9163 9.64961 10.7329 9.64961 10.4996C9.64961 10.2663 9.73294 10.0663 9.89961 9.89961C10.0663 9.76628 10.2579 9.69961 10.4746 9.69961C10.6913 9.69961 10.8663 9.76628 10.9996 9.89961L14.5996 13.4996C14.7663 13.6663 14.8413 13.8496 14.8246 14.0496C14.8079 14.2496 14.7329 14.4163 14.5996 14.5496C14.3996 14.7163 14.1996 14.7913 13.9996 14.7746C13.7996 14.7579 13.6329 14.6829 13.4996 14.5496ZM37.0496 38.0996L33.4996 34.5496C33.3329 34.3829 33.2413 34.1913 33.2246 33.9746C33.2079 33.7579 33.2829 33.5829 33.4496 33.4496C33.5829 33.3163 33.7579 33.2496 33.9746 33.2496C34.1913 33.2496 34.3829 33.3329 34.5496 33.4996L38.0996 36.9996C38.2329 37.1329 38.2996 37.3079 38.2996 37.5246C38.2996 37.7413 38.2329 37.9329 38.0996 38.0996C37.9663 38.2663 37.7913 38.3496 37.5746 38.3496C37.3579 38.3496 37.1829 38.2663 37.0496 38.0996V38.0996ZM4.84961 24.7496C4.61628 24.7496 4.43294 24.6746 4.29961 24.5246C4.16628 24.3746 4.09961 24.1996 4.09961 23.9996C4.09961 23.7663 4.16628 23.5829 4.29961 23.4496C4.43294 23.3163 4.61628 23.2496 4.84961 23.2496H9.84961C10.0496 23.2496 10.2246 23.3246 10.3746 23.4746C10.5246 23.6246 10.5996 23.7996 10.5996 23.9996C10.5996 24.2329 10.5246 24.4163 10.3746 24.5496C10.2246 24.6829 10.0496 24.7496 9.84961 24.7496H4.84961ZM9.94961 38.0996C9.81628 37.9329 9.74128 37.7413 9.72461 37.5246C9.70794 37.3079 9.76628 37.1329 9.89961 36.9996L13.3996 33.4996C13.5996 33.3329 13.7913 33.2496 13.9746 33.2496C14.1579 33.2496 14.3329 33.3329 14.4996 33.4996C14.6996 33.6663 14.7996 33.8496 14.7996 34.0496C14.7996 34.2496 14.6996 34.4496 14.4996 34.6496L11.0496 38.0996C10.8829 38.2663 10.6913 38.3496 10.4746 38.3496C10.2579 38.3496 10.0829 38.2663 9.94961 38.0996V38.0996ZM23.9996 33.9996C21.2329 33.9996 18.8746 33.0246 16.9246 31.0746C14.9746 29.1246 13.9996 26.7663 13.9996 23.9996C13.9996 21.2329 14.9746 18.8746 16.9246 16.9246C18.8746 14.9746 21.2329 13.9996 23.9996 13.9996C26.7663 13.9996 29.1246 14.9746 31.0746 16.9246C33.0246 18.8746 33.9996 21.2329 33.9996 23.9996C33.9996 26.7663 33.0246 29.1246 31.0746 31.0746C29.1246 33.0246 26.7663 33.9996 23.9996 33.9996ZM23.9996 32.4496C26.3663 32.4496 28.3663 31.6329 29.9996 29.9996C31.6329 28.3663 32.4496 26.3663 32.4496 23.9996C32.4496 21.6663 31.6329 19.6746 29.9996 18.0246C28.3663 16.3746 26.3663 15.5496 23.9996 15.5496C21.6663 15.5496 19.6746 16.3663 18.0246 17.9996C16.3746 19.6329 15.5496 21.6329 15.5496 23.9996C15.5496 26.3663 16.3663 28.3663 17.9996 29.9996C19.6329 31.6329 21.6329 32.4496 23.9996 32.4496Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconEco = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1 37.7998C10.8333 36.4665 9.83333 34.9415 9.1 33.2248C8.36667 31.5081 8 29.7498 8 27.9498C8 25.9498 8.36667 24.0415 9.1 22.2248C9.83333 20.4081 10.9667 18.7331 12.5 17.1998C13.7667 15.9331 15.3833 14.9415 17.35 14.2248C19.3167 13.5081 21.4417 12.9831 23.725 12.6498C26.0083 12.3165 28.3583 12.1248 30.775 12.0748C33.1917 12.0248 35.5167 12.0498 37.75 12.1498C37.8833 14.4165 37.9333 16.7665 37.9 19.1998C37.8667 21.6331 37.6833 23.9998 37.35 26.2998C37.0167 28.5998 36.475 30.7248 35.725 32.6748C34.975 34.6248 33.9667 36.2331 32.7 37.4998C31.2333 39.0331 29.6083 40.1665 27.825 40.8998C26.0417 41.6331 24.2167 41.9998 22.35 41.9998C20.4167 41.9998 18.5583 41.6498 16.775 40.9498C14.9917 40.2498 13.4333 39.1998 12.1 37.7998ZM15.25 38.3498C16.25 39.0165 17.375 39.5331 18.625 39.8998C19.875 40.2665 21.1167 40.4498 22.35 40.4498C24.0167 40.4498 25.6417 40.1165 27.225 39.4498C28.8083 38.7831 30.2833 37.7665 31.65 36.3998C32.3833 35.6331 33.0583 34.6248 33.675 33.3748C34.2917 32.1248 34.8083 30.5748 35.225 28.7248C35.6417 26.8748 35.95 24.6998 36.15 22.1998C36.35 19.6998 36.4 16.8498 36.3 13.6498C33.9667 13.5831 31.6583 13.5915 29.375 13.6748C27.0917 13.7581 24.95 13.9831 22.95 14.3498C20.95 14.7165 19.15 15.2081 17.55 15.8248C15.95 16.4415 14.6667 17.2331 13.7 18.1998C12.2667 19.6331 11.2167 21.1831 10.55 22.8498C9.88333 24.5165 9.55 26.0831 9.55 27.5498C9.55 29.2165 9.9 30.8998 10.6 32.5998C11.3 34.2998 12.25 35.6831 13.45 36.7498C14.45 34.1165 15.8667 31.6748 17.7 29.4248C19.5333 27.1748 21.95 25.1331 24.95 23.2998C22.4167 25.4998 20.3667 27.7915 18.8 30.1748C17.2333 32.5581 16.05 35.2831 15.25 38.3498V38.3498Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

const SrCompIconWaterDrop = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.15 37.1996C24.4833 37.1996 24.7417 37.1329 24.925 36.9996C25.1083 36.8663 25.2 36.6829 25.2 36.4496C25.2 36.2163 25.1083 36.0413 24.925 35.9246C24.7417 35.8079 24.4833 35.7496 24.15 35.7496C22.75 35.8163 21.225 35.3663 19.575 34.3996C17.925 33.4329 16.9 31.8329 16.5 29.5996C16.4667 29.2996 16.375 29.0829 16.225 28.9496C16.075 28.8163 15.9167 28.7496 15.75 28.7496C15.5167 28.7496 15.3333 28.8413 15.2 29.0246C15.0667 29.2079 15.0167 29.4496 15.05 29.7496C15.55 32.4163 16.775 34.3329 18.725 35.4996C20.675 36.6663 22.4833 37.2329 24.15 37.1996V37.1996ZM24 41.9996C20 41.9996 16.6667 40.6246 14 37.8746C11.3333 35.1246 10 31.6996 10 27.5996C10 24.7329 11.1583 21.5579 13.475 18.0746C15.7917 14.5913 19.3 10.7663 24 6.59961C28.7 10.7663 32.2083 14.5913 34.525 18.0746C36.8417 21.5579 38 24.7329 38 27.5996C38 31.6996 36.6667 35.1246 34 37.8746C31.3333 40.6246 28 41.9996 24 41.9996ZM24 40.4496C27.5667 40.4496 30.5333 39.2246 32.9 36.7746C35.2667 34.3246 36.45 31.2663 36.45 27.5996C36.45 25.0663 35.3917 22.1996 33.275 18.9996C31.1583 15.7996 28.0667 12.3663 24 8.69961C19.9333 12.3663 16.8417 15.7996 14.725 18.9996C12.6083 22.1996 11.55 25.0663 11.55 27.5996C11.55 31.2663 12.7333 34.3246 15.1 36.7746C17.4667 39.2246 20.4333 40.4496 24 40.4496Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Other
const SrCompIconInterests = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5498 20.8502L14.0998 5.9502L22.5998 20.8502H5.5498ZM14.1498 41.0502C12.1831 41.0502 10.5165 40.3669 9.1498 39.0002C7.78314 37.6335 7.0998 35.9669 7.0998 34.0002C7.0998 32.0335 7.78314 30.3669 9.1498 29.0002C10.5165 27.6335 12.1831 26.9502 14.1498 26.9502C16.1165 26.9502 17.7748 27.6335 19.1248 29.0002C20.4748 30.3669 21.1498 32.0335 21.1498 34.0002C21.1498 35.9669 20.4748 37.6335 19.1248 39.0002C17.7748 40.3669 16.1165 41.0502 14.1498 41.0502ZM14.1498 39.5002C15.6498 39.5002 16.9415 38.9669 18.0248 37.9002C19.1081 36.8335 19.6498 35.5335 19.6498 34.0002C19.6498 32.4669 19.1081 31.1669 18.0248 30.1002C16.9415 29.0335 15.6498 28.5002 14.1498 28.5002C12.6165 28.5002 11.3165 29.0335 10.2498 30.1002C9.18314 31.1669 8.6498 32.4669 8.6498 34.0002C8.6498 35.5335 9.18314 36.8335 10.2498 37.9002C11.3165 38.9669 12.6165 39.5002 14.1498 39.5002ZM8.1998 19.3002H19.9998L14.0998 9.1002L8.1998 19.3002ZM27.0498 41.0502V26.9502H41.0998V41.0502H27.0498ZM28.5998 39.5002H39.5998V28.5002H28.5998V39.5002ZM34.0998 20.8502C32.8665 19.8502 31.7331 18.9335 30.6998 18.1002C29.6665 17.2669 28.7748 16.4502 28.0248 15.6502C27.2748 14.8502 26.6998 14.0585 26.2998 13.2752C25.8998 12.4919 25.6998 11.6669 25.6998 10.8002C25.6998 9.6002 26.0915 8.61686 26.8748 7.8502C27.6581 7.08353 28.6498 6.7002 29.8498 6.7002C30.6165 6.7002 31.3498 6.89186 32.0498 7.2752C32.7498 7.65853 33.4331 8.2502 34.0998 9.0502C34.7331 8.2502 35.4081 7.65853 36.1248 7.2752C36.8415 6.89186 37.5831 6.7002 38.3498 6.7002C39.5165 6.7002 40.4915 7.10853 41.2748 7.9252C42.0581 8.74186 42.4498 9.7502 42.4498 10.9502C42.4498 11.7835 42.2498 12.5835 41.8498 13.3502C41.4498 14.1169 40.8748 14.8919 40.1248 15.6752C39.3748 16.4585 38.4915 17.2669 37.4748 18.1002C36.4581 18.9335 35.3331 19.8502 34.0998 20.8502ZM34.0998 18.8502C36.5998 16.9169 38.3581 15.3502 39.3748 14.1502C40.3915 12.9502 40.8998 11.8669 40.8998 10.9002C40.8998 10.1335 40.6581 9.5002 40.1748 9.0002C39.6915 8.5002 39.0831 8.2502 38.3498 8.2502C37.8831 8.2502 37.4248 8.39186 36.9748 8.6752C36.5248 8.95853 35.8831 9.48353 35.0498 10.2502L34.0998 11.2002L33.0998 10.2502C32.2998 9.4502 31.6665 8.91686 31.1998 8.6502C30.7331 8.38353 30.2665 8.2502 29.7998 8.2502C29.0331 8.2502 28.4165 8.48353 27.9498 8.9502C27.4831 9.41686 27.2498 10.0502 27.2498 10.8502C27.2498 11.8502 27.7581 12.9502 28.7748 14.1502C29.7915 15.3502 31.5665 16.9169 34.0998 18.8502Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

// Team default
const SrCompIconViewInAR = (props) => {
  return (
    <svg
      width={props.size ? props.size : 20}
      height={props.size ? props.size : 20}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.55 38.55L12.3 32.55C11.9 32.2833 11.5833 31.95 11.35 31.55C11.1167 31.15 11 30.6833 11 30.15V18.15C11 17.6833 11.1167 17.2417 11.35 16.825C11.5833 16.4083 11.9 16.05 12.3 15.75L22.6 9.75C23.0667 9.48333 23.5417 9.35 24.025 9.35C24.5083 9.35 24.9667 9.48333 25.4 9.75L35.7 15.75C36.1 16.05 36.4167 16.4083 36.65 16.825C36.8833 17.2417 37 17.6833 37 18.15V30.15C37 30.6833 36.8833 31.15 36.65 31.55C36.4167 31.95 36.0833 32.2833 35.65 32.55L25.3 38.55C24.8667 38.8167 24.4083 38.95 23.925 38.95C23.4417 38.95 22.9833 38.8167 22.55 38.55V38.55ZM23.25 37.1V24.55L12.55 18.45V30.1C12.55 30.3 12.6 30.4917 12.7 30.675C12.8 30.8583 12.95 31.0167 13.15 31.15L23.25 37.1ZM24.75 37.1L34.85 31.15C35.05 31.0167 35.2 30.8583 35.3 30.675C35.4 30.4917 35.45 30.3 35.45 30.1V18.45L24.75 24.55V37.1ZM4 11.75V8.6C4 7.33333 4.45 6.25 5.35 5.35C6.25 4.45 7.33333 4 8.6 4H11.75V5.55H8.6C7.73333 5.55 7.00833 5.84167 6.425 6.425C5.84167 7.00833 5.55 7.73333 5.55 8.6V11.75H4ZM8.6 44C7.33333 44 6.25 43.55 5.35 42.65C4.45 41.75 4 40.6667 4 39.4V36.25H5.55V39.4C5.55 40.2667 5.84167 40.9917 6.425 41.575C7.00833 42.1583 7.73333 42.45 8.6 42.45H11.75V44H8.6ZM36.25 43.55V42H39.4C40.2667 42 40.9917 41.7083 41.575 41.125C42.1583 40.5417 42.45 39.8167 42.45 38.95V35.75H44V38.9C44 40.2 43.55 41.3 42.65 42.2C41.75 43.1 40.6667 43.55 39.4 43.55H36.25ZM42.45 11.75V8.6C42.45 7.73333 42.1583 7.00833 41.575 6.425C40.9917 5.84167 40.2667 5.55 39.4 5.55H36.25V4H39.4C40.6667 4 41.75 4.45 42.65 5.35C43.55 6.25 44 7.33333 44 8.6V11.75H42.45ZM24 23.2L34.7 17.05L24.6 11.2C24.4 11.1 24.2 11.05 24 11.05C23.8 11.05 23.6 11.1 23.4 11.2L13.3 17.05L24 23.2Z"
        fill={props.color ? props.color : "black"}
      />
    </svg>
  );
};

//General team icon
const SrCompIcon = (props) => {
  const iconComponents = {
    // New icons
    // Social media icons
    SrCompIconDiscord,
    SrCompIconFacebook,
    SrCompIconInstagram,
    SrCompIconLinkedin,
    SrCompIconMedium,
    SrCompIconPinterest,
    SrCompIconReddit,
    SrCompIconSubstack,
    SrCompIconTwitter,
    SrCompIconWhatsapp,
    SrCompIconYoutube,
    SrCompIconEMail,
    // General icons
    SrCompIconOpenInNew,
    SrCompIconHome,
    SrCompIconPreview,
    SrCompIconSave,
    SrCompIconUpload,
    SrCompIconManageAccounts,
    SrCompIconBrowseActivity,
    SrCompIconThumbUpFilled,

    SrCompIconThumbUpUnfilled,

    // Old icons
    // Edit action icons
    SrCompIconEdit,
    SrCompIconDelete,
    SrCompIconClearAll,
    SrCompIconAdd,
    SrCompIconDone,
    SrCompIconClose,
    SrCompIconAddCircle,
    SrCompIconPersonAddFilled,
    SrCompIconDoNotDisturbOn,
    SrCompIconCancel,
    SrCompIconBlock,
    SrCompIconPersonAddUnfilled,
    SrCompIconPersonRemove,
    // Navigation action icons
    SrCompIconThumbUpEmpty,
    SrCompIconThumbUpFull,
    SrCompIconExpandLess,
    SrCompIconExpandMore,
    SrCompIconChevronRight,
    SrCompIconArrowBack,
    SrCompIconArrowOutward,
    SrCompIconArrowsMoreUp,
    SrCompIconDisabledVisible,
    SrCompIconPlayCircle,
    // Review action icons
    SrCompIconGradeUnfilled,
    SrCompIconGradeFilled,
    SrCompIconStarRateUnfilled,
    SrCompIconStarRateFilled,
    SrCompIconSentimentDissatisfied,
    SrCompIconSentimentVerySatisfied,
    SrCompIconStarHalf,
    // To-do list icons
    SrCompIconEditNote,
    SrCompIconCheckBox,
    SrCompIconCheckBoxOutlineBlank,
    SrCompIconNoteAdd,
    // Task action icons
    SrCompIconAssignmentLate,
    SrCompIconFileOpen,
    SrCompIconUploadFile,
    SrCompIconTask,
    SrCompIconWorkHistory,
    SrCompIconFlag,
    SrCompIconPolyline,
    SrCompIconNotes,
    SrCompIconTour,
    SrCompIconBolt,
    SrCompIconFiberManualRecord,
    SrCompIconSearch,
    SrCompIconAirwave,
    // Navbar tab icons
    SrCompIconAutoAwesome,
    SrCompIconGroup,
    // Account action icons
    SrCompIconLogin,
    SrCompIconLogout,
    // More and help action icons
    SrCompIconSupportAgent,
    SrCompIconHelp,
    SrCompIconMoreVert,
    SrCompIconSettings,
    SrCompIconMenuBook,
    SrCompIconForum,
    SrCompIconCall,
    SrCompIconWhatsApp,
    SrCompIconInfo,

    SrCompIconChatUnfilled,
    SrCompIconChatFilled,
    // Input action icons
    SrCompIconCalendarToday,
    SrCompIconCalendarViewMonth,
    SrCompIconSchedule,
    SrCompIconContentPasteGo,
    SrCompIconContentCopy,
    SrCompIconCheckCircle,
    SrCompIconShare,
    SrCompIconVisibility,
    SrCompIconVisibilityOff,
    SrCompIconTimer,
    SrCompIconAddAPhoto,
    SrCompIconLocation,
    SrCompIconMail,
    //Inhouse icons
    SrCompIconShram,
    SrCompIconAccountCircle,
    SrCompIconRocketLaunch,
    // Team icons
    // Business strategy
    SrCompIconMonitoring,
    SrCompIconConversionPath,
    SrCompIconBusinessCenter,
    SrCompIconStorefront,
    SrCompIconShoppingBag,
    // Construction
    SrCompIconHandyman,
    SrCompIconEngineering,
    SrCompIconSquareFoot,
    SrCompIconCottage,
    SrCompIconHolidayVillage,
    SrCompIconChair,
    SrCompIconGrass,
    // Customer support
    SrCompIconSupport,
    SrCompIconLiveHelp,
    // Design
    SrCompIconDesignServices,
    SrCompIconPalette,
    SrCompIconShapeLine,
    SrCompIconFormatPaint,
    SrCompIconBrush,
    SrCompIconArchitecture,
    SrCompIconDraw,
    // Facilities
    SrCompIconRealEstateAgent,
    SrCompIconKey,
    // Finance
    SrCompIconSavings,
    SrCompIconAccountBalance,
    SrCompIconCalculate,
    SrCompIconAttachMoney,
    SrCompIconCurrencyRupee,
    // Logistics
    SrCompIconLocalShipping,
    SrCompIconModeOfTravel,
    // Legal
    SrCompIconBalance,
    SrCompIconAssuredWorkload,
    SrCompIconGavel,
    // Manufacturing
    SrCompIconPrecisionManufacturing,
    SrCompIconSettings2,
    SrCompIconFactory,
    // Marketing
    SrCompIconTrendingUp,
    SrCompIconLoyalty,
    SrCompIconAdsClick,
    SrCompIconBarChart,
    // Operations
    SrCompIconWarehouse,
    SrCompIconInventory,
    // People
    SrCompIconDiversity1,
    SrCompIconTransgender,
    SrCompIconPsychology,
    // R&D
    SrCompIconScience,
    SrCompIconTravelExplore,
    SrCompIconBiotech,
    // Sales
    SrCompIconPayments,
    SrCompIconSell,
    SrCompIconPointOfSale,
    // Technology
    SrCompIconTenancy,
    SrCompIconIntegrationInstructions,
    SrCompIconFingerprint,
    SrCompIconDeveloperMode,
    SrCompIconDevices,
    SrCompIconDevicesOther,
    SrCompIconSecurity,
    SrCompIconWindPower,
    SrCompIconSunny,
    SrCompIconEco,
    SrCompIconWaterDrop,
    // Other
    SrCompIconInterests,
    // Team default
    SrCompIconViewInAR,
    // General team icon
    SrCompIcon
  };

  const Icon = iconComponents[props.name];
  return <Icon {...props} />;
};

export {
  // New icons
  // Social media icons
  SrCompIconDiscord,
  SrCompIconFacebook,
  SrCompIconInstagram,
  SrCompIconLinkedin,
  SrCompIconMedium,
  SrCompIconPinterest,
  SrCompIconReddit,
  SrCompIconSubstack,
  SrCompIconTwitter,
  SrCompIconWhatsapp,
  SrCompIconYoutube,
  SrCompIconEMail,
  // General icons
  SrCompIconOpenInNew,
  SrCompIconHome,
  SrCompIconPreview,
  SrCompIconSave,
  SrCompIconUpload,
  SrCompIconManageAccounts,
  SrCompIconBrowseActivity,
  SrCompIconThumbUpFilled,
  SrCompIconThumbUpUnfilled,

  // Old icons
  // Edit action icons
  SrCompIconEdit,
  SrCompIconDelete,
  SrCompIconClearAll,
  SrCompIconAdd,
  SrCompIconDone,
  SrCompIconClose,
  SrCompIconAddCircle,
  SrCompIconPersonAddFilled,
  SrCompIconDoNotDisturbOn,
  SrCompIconCancel,
  SrCompIconBlock,
  SrCompIconPersonAddUnfilled,
  SrCompIconPersonRemove,
  // Navigation action icons
  SrCompIconThumbUpEmpty,
  SrCompIconThumbUpFull,
  SrCompIconExpandLess,
  SrCompIconExpandMore,
  SrCompIconChevronRight,
  SrCompIconArrowBack,
  SrCompIconArrowOutward,
  SrCompIconArrowsMoreUp,
  SrCompIconDisabledVisible,
  SrCompIconPlayCircle,
  // Review action icons
  SrCompIconGradeUnfilled,
  SrCompIconGradeFilled,
  SrCompIconStarRateFilled,
  SrCompIconStarRateUnfilled,
  SrCompIconSentimentDissatisfied,
  SrCompIconSentimentVerySatisfied,
  SrCompIconStarHalf,
  // To-do list icons
  SrCompIconEditNote,
  SrCompIconCheckBox,
  SrCompIconCheckBoxOutlineBlank,
  SrCompIconNoteAdd,
  // Task action icons
  SrCompIconAssignmentLate,
  SrCompIconFileOpen,
  SrCompIconUploadFile,
  SrCompIconTask,
  SrCompIconWorkHistory,
  SrCompIconFlag,
  SrCompIconPolyline,
  SrCompIconNotes,
  SrCompIconTour,
  SrCompIconBolt,
  SrCompIconFiberManualRecord,
  SrCompIconSearch,
  SrCompIconAirwave,
  // Navbar tab icons
  SrCompIconAutoAwesome,
  SrCompIconGroup,
  // Account action icons
  SrCompIconLogin,
  SrCompIconLogout,
  // More and help action icons
  SrCompIconSupportAgent,
  SrCompIconHelp,
  SrCompIconMoreVert,
  SrCompIconSettings,
  SrCompIconMenuBook,
  SrCompIconForum,
  SrCompIconCall,
  SrCompIconWhatsApp,
  SrCompIconInfo,
  SrCompIconChatUnfilled,
  SrCompIconChatFilled,
  // Input action icons
  SrCompIconCalendarToday,
  SrCompIconCalendarViewMonth,
  SrCompIconSchedule,
  SrCompIconContentPasteGo,
  SrCompIconContentCopy,
  SrCompIconCheckCircle,
  SrCompIconShare,
  SrCompIconVisibility,
  SrCompIconVisibilityOff,
  SrCompIconTimer,
  SrCompIconAddAPhoto,
  SrCompIconLocation,
  SrCompIconMail,
  //Inhouse icons
  SrCompIconShram,
  SrCompIconAccountCircle,
  SrCompIconRocketLaunch,
  // Team icons
  // Business strategy
  SrCompIconMonitoring,
  SrCompIconConversionPath,
  SrCompIconBusinessCenter,
  SrCompIconStorefront,
  SrCompIconShoppingBag,
  // Construction
  SrCompIconHandyman,
  SrCompIconEngineering,
  SrCompIconSquareFoot,
  SrCompIconCottage,
  SrCompIconHolidayVillage,
  SrCompIconChair,
  SrCompIconGrass,
  // Customer support
  SrCompIconSupport,
  SrCompIconLiveHelp,
  // Design
  SrCompIconDesignServices,
  SrCompIconPalette,
  SrCompIconShapeLine,
  SrCompIconFormatPaint,
  SrCompIconBrush,
  SrCompIconArchitecture,
  SrCompIconDraw,
  // Facilities
  SrCompIconRealEstateAgent,
  SrCompIconKey,
  // Finance
  SrCompIconSavings,
  SrCompIconAccountBalance,
  SrCompIconCalculate,
  SrCompIconAttachMoney,
  SrCompIconCurrencyRupee,
  // Logistics
  SrCompIconLocalShipping,
  SrCompIconModeOfTravel,
  // Legal
  SrCompIconBalance,
  SrCompIconAssuredWorkload,
  SrCompIconGavel,
  // Manufacturing
  SrCompIconPrecisionManufacturing,
  SrCompIconSettings2,
  SrCompIconFactory,
  // Marketing
  SrCompIconTrendingUp,
  SrCompIconLoyalty,
  SrCompIconAdsClick,
  SrCompIconBarChart,
  // Operations
  SrCompIconWarehouse,
  SrCompIconInventory,
  // People
  SrCompIconDiversity1,
  SrCompIconTransgender,
  SrCompIconPsychology,
  // R&D
  SrCompIconScience,
  SrCompIconTravelExplore,
  SrCompIconBiotech,
  // Sales
  SrCompIconPayments,
  SrCompIconSell,
  SrCompIconPointOfSale,
  // Technology
  SrCompIconTenancy,
  SrCompIconIntegrationInstructions,
  SrCompIconFingerprint,
  SrCompIconDeveloperMode,
  SrCompIconDevices,
  SrCompIconDevicesOther,
  SrCompIconSecurity,
  SrCompIconWindPower,
  SrCompIconSunny,
  SrCompIconEco,
  SrCompIconWaterDrop,
  // Other
  SrCompIconInterests,
  // Team default
  SrCompIconViewInAR,
  // General team icon
  SrCompIcon
};
